/*
 * $Id: combinatorics.js,v 0.25 2013/03/11 15:42:14 dankogai Exp dankogai $
 *
 *  Licensed under the MIT license.
 *  http://www.opensource.org/licenses/mit-license.php
 *
 *  References:
 *    http://www.ruby-doc.org/core-2.0/Array.html#method-i-combination
 *    http://www.ruby-doc.org/core-2.0/Array.html#method-i-permutation
 *    http://en.wikipedia.org/wiki/Factorial_number_system
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define([], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.Combinatorics = factory();
    }
}(this, function () {
    'use strict';
    var version = "0.5.2";
    /* combinatory arithmetics */
    var P = function(m, n) {
        var p = 1;
        while (n--) p *= m--;
        return p;
    };
    var C = function(m, n) {
        if (n > m) {
            return 0;
        }
        return P(m, n) / P(n, n);
    };
    var factorial = function(n) {
        return P(n, n);
    };
    var factoradic = function(n, d) {
        var f = 1;
        if (!d) {
            for (d = 1; f < n; f *= ++d);
            if (f > n) f /= d--;
        } else {
            f = factorial(d);
        }
        var result = [0];
        for (; d; f /= d--) {
            result[d] = Math.floor(n / f);
            n %= f;
        }
        return result;
    };
    /* common methods */
    var addProperties = function(dst, src) {
        Object.keys(src).forEach(function(p) {
            Object.defineProperty(dst, p, {
                value: src[p],
                configurable: p == 'next'
            });
        });
    };
    var hideProperty = function(o, p) {
        Object.defineProperty(o, p, {
            writable: true
        });
    };
    var toArray = function(f) {
        var e, result = [];
        this.init();
        while (e = this.next()) result.push(f ? f(e) : e);
        this.init();
        return result;
    };
    var common = {
        toArray: toArray,
        map: toArray,
        forEach: function(f) {
            var e;
            this.init();
            while (e = this.next()) f(e);
            this.init();
        },
        filter: function(f) {
            var e, result = [];
            this.init();
            while (e = this.next()) if (f(e)) result.push(e);
            this.init();
            return result;
        },
        lazyMap: function(f) {
            this._lazyMap = f;
            return this;
        },
        lazyFilter: function(f) {
            Object.defineProperty(this, 'next', {
                writable: true
            });
            if (typeof f !== 'function') {
                this.next = this._next;
            } else {
                if (typeof (this._next) !== 'function') {
                    this._next = this.next;
                }
                var _next = this._next.bind(this);
                this.next = (function() {
                    var e;
                    while (e = _next()) {
                        if (f(e))
                            return e;
                    }
                    return e;
                }).bind(this);
            }
            Object.defineProperty(this, 'next', {
                writable: false
            });
            return this;
        }

    };
    /* power set */
    var power = function(ary, fun) {
        var size = 1 << ary.length,
            sizeOf = function() {
                return size;
            },
            that = Object.create(ary.slice(), {
                length: {
                    get: sizeOf
                }
            });
        hideProperty(that, 'index');
        addProperties(that, {
            valueOf: sizeOf,
            init: function() {
                that.index = 0;
            },
            nth: function(n) {
                if (n >= size) return;
                var i = 0,
                    result = [];
                for (; n; n >>>= 1, i++) if (n & 1) result.push(this[i]);
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            },
            next: function() {
                return this.nth(this.index++);
            }
        });
        addProperties(that, common);
        that.init();
        return (typeof (fun) === 'function') ? that.map(fun) : that;
    };
    /* combination */
    var nextIndex = function(n) {
        var smallest = n & -n,
            ripple = n + smallest,
            new_smallest = ripple & -ripple,
            ones = ((new_smallest / smallest) >> 1) - 1;
        return ripple | ones;
    };
    var combination = function(ary, nelem, fun) {
        if (!nelem) nelem = ary.length;
        if (nelem < 1) throw new RangeError;
        if (nelem > ary.length) throw new RangeError;
        var first = (1 << nelem) - 1,
            size = C(ary.length, nelem),
            maxIndex = 1 << ary.length,
            sizeOf = function() {
                return size;
            },
            that = Object.create(ary.slice(), {
                length: {
                    get: sizeOf
                }
            });
        hideProperty(that, 'index');
        addProperties(that, {
            valueOf: sizeOf,
            init: function() {
                this.index = first;
            },
            next: function() {
                if (this.index >= maxIndex) return;
                var i = 0,
                    n = this.index,
                    result = [];
                for (; n; n >>>= 1, i++) {
                    if (n & 1) result[result.length] = this[i];
                }

                this.index = nextIndex(this.index);
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            }
        });
        addProperties(that, common);
        that.init();
        return (typeof (fun) === 'function') ? that.map(fun) : that;
    };
    /* bigcombination */
    var bigNextIndex = function(n, nelem) {

        var result = n;
        var j = nelem;
        var i = 0;
        for (i = result.length - 1; i >= 0; i--) {
            if (result[i] == 1) {
                j--;
            } else {
                break;
            }
        } 
        if (j == 0) {
            // Overflow
            result[result.length] = 1;
            for (var k = result.length - 2; k >= 0; k--) {
                result[k] = (k < nelem-1)?1:0;
            }
        } else {
            // Normal

            // first zero after 1
            var i1 = -1;
            var i0 = -1;
            for (var i = 0; i < result.length; i++) {
                if (result[i] == 0 && i1 != -1) {
                    i0 = i;
                }
                if (result[i] == 1) {
                    i1 = i;
                }
                if (i0 != -1 && i1 != -1) {
                    result[i0] = 1;
                    result[i1] = 0;
                    break;
                }
            }

            j = nelem;
            for (var i = result.length - 1; i >= i1; i--) {
                if (result[i] == 1)
                    j--;
            }
            for (var i = 0; i < i1; i++) {
                result[i] = (i < j)?1:0;
            }
        }

        return result;

    };
    var buildFirst = function(nelem) {
        var result = [];
        for (var i = 0; i < nelem; i++) {
            result[i] = 1;
        }
        result[0] = 1;
        return result;
    };
    var bigCombination = function(ary, nelem, fun) {
        if (!nelem) nelem = ary.length;
        if (nelem < 1) throw new RangeError;
        if (nelem > ary.length) throw new RangeError;
        var first = buildFirst(nelem),
            size = C(ary.length, nelem),
            maxIndex = ary.length,
            sizeOf = function() {
                return size;
            },
            that = Object.create(ary.slice(), {
                length: {
                    get: sizeOf
                }
            });
        hideProperty(that, 'index');
        addProperties(that, {
            valueOf: sizeOf,
            init: function() {
                this.index = first.concat();
            },
            next: function() {
                if (this.index.length > maxIndex) return;
                var i = 0,
                    n = this.index,
                    result = [];
                for (var j = 0; j < n.length; j++, i++) {
                    if (n[j])
                        result[result.length] = this[i];
                }
                bigNextIndex(this.index, nelem);
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            }
        });
        addProperties(that, common);
        that.init();
        return (typeof (fun) === 'function') ? that.map(fun) : that;
    };
    /* permutation */
    var _permutation = function(ary) {
        var that = ary.slice(),
            size = factorial(that.length);
        that.index = 0;
        that.next = function() {
            if (this.index >= size) return;
            var copy = this.slice(),
                digits = factoradic(this.index, this.length),
                result = [],
                i = this.length - 1;
            for (; i >= 0; --i) result.push(copy.splice(digits[i], 1)[0]);
            this.index++;
            return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
        };
        return that;
    };
    // which is really a permutation of combination
    var permutation = function(ary, nelem, fun) {
        if (!nelem) nelem = ary.length;
        if (nelem < 1) throw new RangeError;
        if (nelem > ary.length) throw new RangeError;
        var size = P(ary.length, nelem),
            sizeOf = function() {
                return size;
            },
            that = Object.create(ary.slice(), {
                length: {
                    get: sizeOf
                }
            });
        hideProperty(that, 'cmb');
        hideProperty(that, 'per');
        addProperties(that, {
            valueOf: function() {
                return size;
            },
            init: function() {
                this.cmb = combination(ary, nelem);
                this.per = _permutation(this.cmb.next());
            },
            next: function() {
                var result = this.per.next();
                if (!result) {
                    var cmb = this.cmb.next();
                    if (!cmb) return;
                    this.per = _permutation(cmb);
                    return this.next();
                }
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            }
        });
        addProperties(that, common);
        that.init();
        return (typeof (fun) === 'function') ? that.map(fun) : that;
    };

    var PC = function(m) {
        var total = 0;
        for (var n = 1; n <= m; n++) {
            var p = P(m,n);
            total += p;
        };
        return total;
    };
    // which is really a permutation of combination
    var permutationCombination = function(ary, fun) {
        // if (!nelem) nelem = ary.length;
        // if (nelem < 1) throw new RangeError;
        // if (nelem > ary.length) throw new RangeError;
        var size = PC(ary.length),
            sizeOf = function() {
                return size;
            },
            that = Object.create(ary.slice(), {
                length: {
                    get: sizeOf
                }
            });
        hideProperty(that, 'cmb');
        hideProperty(that, 'per');
        hideProperty(that, 'nelem');
        addProperties(that, {
            valueOf: function() {
                return size;
            },
            init: function() {
                this.nelem = 1;
                // console.log("Starting nelem: " + this.nelem);
                this.cmb = combination(ary, this.nelem);
                this.per = _permutation(this.cmb.next());
            },
            next: function() {
                var result = this.per.next();
                if (!result) {
                    var cmb = this.cmb.next();
                    if (!cmb) {
                        this.nelem++;
                        // console.log("increment nelem: " + this.nelem + " vs " + ary.length);
                        if (this.nelem > ary.length) return;
                        this.cmb = combination(ary, this.nelem);
                        cmb = this.cmb.next();
                        if (!cmb) return;
                    }
                    this.per = _permutation(cmb);
                    return this.next();
                }
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            }
        });
        addProperties(that, common);
        that.init();
        return (typeof (fun) === 'function') ? that.map(fun) : that;
    };
    /* Cartesian Product */
    var arraySlice = Array.prototype.slice;
    var cartesianProduct = function() {
        if (!arguments.length) throw new RangeError;
        var args = arraySlice.call(arguments),
            size = args.reduce(function(p, a) {
                return p * a.length;
            }, 1),
            sizeOf = function() {
                return size;
            },
            dim = args.length,
            that = Object.create(args, {
                length: {
                    get: sizeOf
                }
            });
        if (!size) throw new RangeError;
        hideProperty(that, 'index');
        addProperties(that, {
            valueOf: sizeOf,
            dim: dim,
            init: function() {
                this.index = 0;
            },
            get: function() {
                if (arguments.length !== this.length) return;
                var result = [],
                    d = 0;
                for (; d < dim; d++) {
                    var i = arguments[d];
                    if (i >= this[d].length) return;
                    result.push(this[d][i]);
                }
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            },
            nth: function(n) {
                var result = [],
                    d = 0;
                for (; d < dim; d++) {
                    var l = this[d].length;
                    var i = n % l;
                    result.push(this[d][i]);
                    n -= i;
                    n /= l;
                }
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            },
            next: function() {
                if (this.index >= size) return;
                var result = this.nth(this.index);
                this.index++;
                return result;
            }
        });
        addProperties(that, common);
        that.init();
        return that;
    };
    /* baseN */
    var baseN = function(ary, nelem, fun) {
                if (!nelem) nelem = ary.length;
        if (nelem < 1) throw new RangeError;
        var base = ary.length,
                size = Math.pow(base, nelem);
        var sizeOf = function() {
                return size;
            },
            that = Object.create(ary.slice(), {
                length: {
                    get: sizeOf
                }
            });
        hideProperty(that, 'index');
        addProperties(that, {
            valueOf: sizeOf,
            init: function() {
                that.index = 0;
            },
            nth: function(n) {
                if (n >= size) return;
                var result = [];
                for (var i = 0; i < nelem; i++) {
                    var d = n % base;
                    result.push(ary[d])
                    n -= d; n /= base
                }
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            },
            next: function() {
                return this.nth(this.index++);
            }
        });
        addProperties(that, common);
        that.init();
        return (typeof (fun) === 'function') ? that.map(fun) : that;
    };

    /* export */
    var Combinatorics = Object.create(null);
    addProperties(Combinatorics, {
        C: C,
        P: P,
        factorial: factorial,
        factoradic: factoradic,
        cartesianProduct: cartesianProduct,
        combination: combination,
        bigCombination: bigCombination,
        permutation: permutation,
        permutationCombination: permutationCombination,
        power: power,
        baseN: baseN,
        VERSION: version
    });
    return Combinatorics;
}));

(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.io = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){

/**
 * Module dependencies.
 */

var url = _dereq_('./url');
var parser = _dereq_('socket.io-parser');
var Manager = _dereq_('./manager');
var debug = _dereq_('debug')('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup(uri, opts) {
  if (typeof uri == 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }

  return io.socket(parsed.path);
}

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = _dereq_('./manager');
exports.Socket = _dereq_('./socket');

},{"./manager":2,"./socket":4,"./url":5,"debug":14,"socket.io-parser":40}],2:[function(_dereq_,module,exports){

/**
 * Module dependencies.
 */

var eio = _dereq_('engine.io-client');
var Socket = _dereq_('./socket');
var Emitter = _dereq_('component-emitter');
var parser = _dereq_('socket.io-parser');
var on = _dereq_('./on');
var bind = _dereq_('component-bind');
var debug = _dereq_('debug')('socket.io-client:manager');
var indexOf = _dereq_('indexof');
var Backoff = _dereq_('backo2');

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager(uri, opts){
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' == typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  this.encoder = new parser.Encoder();
  this.decoder = new parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function() {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function(){
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.engine.id;
    }
  }
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function(v){
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function(v){
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function(v){
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function(v){
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function(v){
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function(v){
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function() {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};


/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function(fn){
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function() {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function(data){
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    // set timer
    var timer = setTimeout(function(){
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function(){
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function(){
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function(){
  this.lastPing = new Date;
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function(){
  this.emitAll('pong', new Date - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function(data){
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function(packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function(err){
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function(nsp){
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function(){
      socket.id = self.engine.id;
    });

    if (this.autoConnect) {
      // manually call here since connecting evnet is fired before listening
      onConnecting();
    }
  }

  function onConnecting() {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function(socket){
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function(packet){
  debug('writing packet %j', packet);
  var self = this;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function(encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function() {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function(){
  debug('cleanup');

  var sub;
  while (sub = this.subs.shift()) sub.destroy();

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function(){
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' == this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function(reason){
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function(){
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function(){
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function(err){
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function(){
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function(){
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};

},{"./on":3,"./socket":4,"backo2":8,"component-bind":11,"component-emitter":12,"debug":14,"engine.io-client":16,"indexof":32,"socket.io-parser":40}],3:[function(_dereq_,module,exports){

/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on(obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function(){
      obj.removeListener(ev, fn);
    }
  };
}

},{}],4:[function(_dereq_,module,exports){

/**
 * Module dependencies.
 */

var parser = _dereq_('socket.io-parser');
var Emitter = _dereq_('component-emitter');
var toArray = _dereq_('to-array');
var on = _dereq_('./on');
var bind = _dereq_('component-bind');
var debug = _dereq_('debug')('socket.io-client:socket');
var hasBin = _dereq_('has-binary');

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket(io, nsp){
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function() {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function(){
  if (this.connected) return this;

  this.subEvents();
  this.io.open(); // ensure open
  if ('open' == this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function(){
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function(ev){
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var parserType = parser.EVENT; // default
  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
  var packet = { type: parserType, data: args };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' == typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  delete this.flags;

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function(packet){
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function(){
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' != this.nsp) {
    this.packet({ type: parser.CONNECT });
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function(reason){
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function(packet){
  if (packet.nsp != this.nsp) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function(packet){
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function(id){
  var self = this;
  var sent = false;
  return function(){
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
    self.packet({
      type: type,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function(packet){
  var ack = this.acks[packet.id];
  if ('function' == typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function(){
  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
  this.emitBuffered();
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function(){
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function(){
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function(){
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function(){
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function(compress){
  this.flags = this.flags || {};
  this.flags.compress = compress;
  return this;
};

},{"./on":3,"component-bind":11,"component-emitter":12,"debug":14,"has-binary":30,"socket.io-parser":40,"to-array":43}],5:[function(_dereq_,module,exports){
(function (global){

/**
 * Module dependencies.
 */

var parseuri = _dereq_('parseuri');
var debug = _dereq_('debug')('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url(uri, loc){
  var obj = uri;

  // default to window.location
  var loc = loc || global.location;
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' == typeof uri) {
    if ('/' == uri.charAt(0)) {
      if ('/' == uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' != typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    }
    else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port == obj.port ? '' : (':' + obj.port));

  return obj;
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{"debug":14,"parseuri":38}],6:[function(_dereq_,module,exports){
module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}

},{}],7:[function(_dereq_,module,exports){
/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};

},{}],8:[function(_dereq_,module,exports){

/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};


},{}],9:[function(_dereq_,module,exports){
/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(){
  "use strict";

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();

},{}],10:[function(_dereq_,module,exports){
(function (global){
/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = global.BlobBuilder
  || global.WebKitBlobBuilder
  || global.MSBlobBuilder
  || global.MozBlobBuilder;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  for (var i = 0; i < ary.length; i++) {
    var chunk = ary[i];
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      ary[i] = buf;
    }
  }
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary);

  for (var i = 0; i < ary.length; i++) {
    bb.append(ary[i]);
  }

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  mapArrayBufferViews(ary);
  return new Blob(ary, options || {});
};

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{}],11:[function(_dereq_,module,exports){
/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};

},{}],12:[function(_dereq_,module,exports){

/**
 * Expose `Emitter`.
 */

module.exports = Emitter;

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

},{}],13:[function(_dereq_,module,exports){

module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};
},{}],14:[function(_dereq_,module,exports){

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = _dereq_('./debug');
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  return ('WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  return JSON.stringify(v);
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}
  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}

},{"./debug":15}],15:[function(_dereq_,module,exports){

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = _dereq_('ms');

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = Array.prototype.slice.call(arguments);

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    if ('function' === typeof exports.formatArgs) {
      args = exports.formatArgs.apply(self, args);
    }
    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

},{"ms":35}],16:[function(_dereq_,module,exports){

module.exports =  _dereq_('./lib/');

},{"./lib/":17}],17:[function(_dereq_,module,exports){

module.exports = _dereq_('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = _dereq_('engine.io-parser');

},{"./socket":18,"engine.io-parser":27}],18:[function(_dereq_,module,exports){
(function (global){
/**
 * Module dependencies.
 */

var transports = _dereq_('./transports');
var Emitter = _dereq_('component-emitter');
var debug = _dereq_('debug')('engine.io-client:socket');
var index = _dereq_('indexof');
var parser = _dereq_('engine.io-parser');
var parseuri = _dereq_('parseuri');
var parsejson = _dereq_('parsejson');
var parseqs = _dereq_('parseqs');

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Noop function.
 *
 * @api private
 */

function noop(){}

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket(uri, opts){
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' == typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol == 'https' || uri.protocol == 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure :
    (global.location && 'https:' == location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (global.location ? location.hostname : 'localhost');
  this.port = opts.port || (global.location && location.port ?
       location.port :
       (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' == typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.readyState = '';
  this.writeBuffer = [];
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || null;
  this.key = opts.key || null;
  this.passphrase = opts.passphrase || null;
  this.cert = opts.cert || null;
  this.ca = opts.ca || null;
  this.ciphers = opts.ciphers || null;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;

  // other options for Node.js client
  var freeGlobal = typeof global == 'object' && global;
  if (freeGlobal.global === freeGlobal) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }
  }

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = _dereq_('./transport');
Socket.transports = _dereq_('./transports');
Socket.parser = _dereq_('engine.io-parser');

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    agent: this.agent,
    hostname: this.hostname,
    port: this.port,
    secure: this.secure,
    path: this.path,
    query: query,
    forceJSONP: this.forceJSONP,
    jsonp: this.jsonp,
    forceBase64: this.forceBase64,
    enablesXDR: this.enablesXDR,
    timestampRequests: this.timestampRequests,
    timestampParam: this.timestampParam,
    policyPort: this.policyPort,
    socket: this,
    pfx: this.pfx,
    key: this.key,
    passphrase: this.passphrase,
    cert: this.cert,
    ca: this.ca,
    ciphers: this.ciphers,
    rejectUnauthorized: this.rejectUnauthorized,
    perMessageDeflate: this.perMessageDeflate,
    extraHeaders: this.extraHeaders
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') != -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function() {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function(transport){
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function(){
    self.onDrain();
  })
  .on('packet', function(packet){
    self.onPacket(packet);
  })
  .on('error', function(e){
    self.onError(e);
  })
  .on('close', function(){
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 })
    , failed = false
    , self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen(){
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' == msg.type && 'probe' == msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' == transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' == self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport() {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  //Handle any error that happens while probing
  function onerror(err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose(){
    onerror("transport closed");
  }

  //When the socket is closed while we're probing
  function onclose(){
    onerror("socket closed");
  }

  //When the socket is upgraded while we're probing
  function onupgrade(to){
    if (transport && to.name != transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  //Remove all listeners on the transport and on self
  function cleanup(){
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();

};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' == this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' == this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' == this.readyState || 'open' == this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(parsejson(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if  ('closed' == this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' == self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function(){
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function() {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' != this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if('function' == typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' == typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' == this.readyState || 'closed' == this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' == this.readyState || 'open' == this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function() {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close() {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose() {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade() {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' == this.readyState || 'open' == this.readyState || 'closing' == this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i<j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{"./transport":19,"./transports":20,"component-emitter":26,"debug":14,"engine.io-parser":27,"indexof":32,"parsejson":36,"parseqs":37,"parseuri":38}],19:[function(_dereq_,module,exports){
/**
 * Module dependencies.
 */

var parser = _dereq_('engine.io-parser');
var Emitter = _dereq_('component-emitter');

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' == this.readyState || '' == this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' == this.readyState || 'open' == this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function(packets){
  if ('open' == this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function(data){
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};

},{"component-emitter":26,"engine.io-parser":27}],20:[function(_dereq_,module,exports){
(function (global){
/**
 * Module dependencies
 */

var XMLHttpRequest = _dereq_('xmlhttprequest-ssl');
var XHR = _dereq_('./polling-xhr');
var JSONP = _dereq_('./polling-jsonp');
var websocket = _dereq_('./websocket');

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling(opts){
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (global.location) {
    var isSSL = 'https:' == location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname != location.hostname || port != opts.port;
    xs = opts.secure != isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{"./polling-jsonp":21,"./polling-xhr":22,"./websocket":24,"xmlhttprequest-ssl":25}],21:[function(_dereq_,module,exports){
(function (global){

/**
 * Module requirements.
 */

var Polling = _dereq_('./polling');
var inherit = _dereq_('component-inherit');

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Callbacks count.
 */

var index = 0;

/**
 * Noop.
 */

function empty () { }

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    if (!global.___eio) global.___eio = [];
    callbacks = global.___eio;
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (global.document && global.addEventListener) {
    global.addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function(e){
    self.onError('jsonp poll error',e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  }
  else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' != typeof navigator && /gecko/i.test(navigator.userAgent);
  
  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="'+ self.iframeId +'">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch(e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function(){
      if (self.iframe.readyState == 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{"./polling":23,"component-inherit":13}],22:[function(_dereq_,module,exports){
(function (global){
/**
 * Module requirements.
 */

var XMLHttpRequest = _dereq_('xmlhttprequest-ssl');
var Polling = _dereq_('./polling');
var Emitter = _dereq_('component-emitter');
var inherit = _dereq_('component-inherit');
var debug = _dereq_('debug')('engine.io-client:polling-xhr');

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty(){}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR(opts){
  Polling.call(this, opts);

  if (global.location) {
    var isSSL = 'https:' == location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = opts.hostname != global.location.hostname ||
      port != opts.port;
    this.xs = opts.secure != isSSL;
  } else {
    this.extraHeaders = opts.extraHeaders;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function(opts){
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function(data, fn){
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function(err){
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function(){
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function(data){
    self.onData(data);
  });
  req.on('error', function(err){
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request(opts){
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined != opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function(){
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}
    if (this.supportsBinary) {
      // This has to be done after open because Firefox is stupid
      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
      xhr.responseType = 'arraybuffer';
    }

    if ('POST' == this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = true;
    }

    if (this.hasXDR()) {
      xhr.onload = function(){
        self.onLoad();
      };
      xhr.onerror = function(){
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function(){
        if (4 != xhr.readyState) return;
        if (200 == xhr.status || 1223 == xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function(){
            self.onError(xhr.status);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function() {
      self.onError(e);
    }, 0);
    return;
  }

  if (global.document) {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function(){
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function(data){
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function(err){
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function(fromError){
  if ('undefined' == typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch(e) {}
  }

  if (global.document) {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function(){
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
    } catch (e) {}
    if (contentType === 'application/octet-stream') {
      data = this.xhr.response;
    } else {
      if (!this.supportsBinary) {
        data = this.xhr.responseText;
      } else {
        try {
          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
        } catch (e) {
          var ui8Arr = new Uint8Array(this.xhr.response);
          var dataArray = [];
          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
            dataArray.push(ui8Arr[idx]);
          }

          data = String.fromCharCode.apply(null, dataArray);
        }
      }
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function(){
  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function(){
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

if (global.document) {
  Request.requestsCount = 0;
  Request.requests = {};
  if (global.attachEvent) {
    global.attachEvent('onunload', unloadHandler);
  } else if (global.addEventListener) {
    global.addEventListener('beforeunload', unloadHandler, false);
  }
}

function unloadHandler() {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{"./polling":23,"component-emitter":26,"component-inherit":13,"debug":14,"xmlhttprequest-ssl":25}],23:[function(_dereq_,module,exports){
/**
 * Module dependencies.
 */

var Transport = _dereq_('../transport');
var parseqs = _dereq_('parseqs');
var parser = _dereq_('engine.io-parser');
var inherit = _dereq_('component-inherit');
var yeast = _dereq_('yeast');
var debug = _dereq_('debug')('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function() {
  var XMLHttpRequest = _dereq_('xmlhttprequest-ssl');
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling(opts){
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function(){
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function(onPause){
  var pending = 0;
  var self = this;

  this.readyState = 'pausing';

  function pause(){
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function(){
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function(){
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function(){
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function(data){
  var self = this;
  debug('polling got data %s', data);
  var callback = function(packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' == self.readyState) {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' == packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' != this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' == this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function(){
  var self = this;

  function close(){
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' == this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function(packets){
  var self = this;
  this.writable = false;
  var callbackfn = function() {
    self.writable = true;
    self.emit('drain');
  };

  var self = this;
  parser.encodePayload(packets, this.supportsBinary, function(data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function(){
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' == schema && this.port != 443) ||
     ('http' == schema && this.port != 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

},{"../transport":19,"component-inherit":13,"debug":14,"engine.io-parser":27,"parseqs":37,"xmlhttprequest-ssl":25,"yeast":45}],24:[function(_dereq_,module,exports){
(function (global){
/**
 * Module dependencies.
 */

var Transport = _dereq_('../transport');
var parser = _dereq_('engine.io-parser');
var parseqs = _dereq_('parseqs');
var inherit = _dereq_('component-inherit');
var yeast = _dereq_('yeast');
var debug = _dereq_('debug')('engine.io-client:websocket');
var BrowserWebSocket = global.WebSocket || global.MozWebSocket;

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocket = BrowserWebSocket;
if (!WebSocket && typeof window === 'undefined') {
  try {
    WebSocket = _dereq_('ws');
  } catch (e) { }
}

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS(opts){
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function(){
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var self = this;
  var uri = this.uri();
  var protocols = void(0);
  var opts = {
    agent: this.agent,
    perMessageDeflate: this.perMessageDeflate
  };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }

  this.ws = BrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'buffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function(){
  var self = this;

  this.ws.onopen = function(){
    self.onOpen();
  };
  this.ws.onclose = function(){
    self.onClose();
  };
  this.ws.onmessage = function(ev){
    self.onData(ev.data);
  };
  this.ws.onerror = function(e){
    self.onError('websocket error', e);
  };
};

/**
 * Override `onData` to use a timer on iOS.
 * See: https://gist.github.com/mloughran/2052006
 *
 * @api private
 */

if ('undefined' != typeof navigator
  && /iPad|iPhone|iPod/i.test(navigator.userAgent)) {
  WS.prototype.onData = function(data){
    var self = this;
    setTimeout(function(){
      Transport.prototype.onData.call(self, data);
    }, 0);
  };
}

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function(packets){
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function(packet) {
      parser.encodePacket(packet, self.supportsBinary, function(data) {
        if (!BrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' == typeof data ? global.Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        //Sometimes the websocket has already been closed but the browser didn't
        //have a chance of informing us about it yet, in that case send will
        //throw an error
        try {
          if (BrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e){
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done(){
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function(){
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function(){
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function(){
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function(){
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' == schema && this.port != 443)
    || ('ws' == schema && this.port != 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function(){
  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
};

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{"../transport":19,"component-inherit":13,"debug":14,"engine.io-parser":27,"parseqs":37,"ws":undefined,"yeast":45}],25:[function(_dereq_,module,exports){
// browser shim for xmlhttprequest module
var hasCORS = _dereq_('has-cors');

module.exports = function(opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' != typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' != typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new ActiveXObject('Microsoft.XMLHTTP');
    } catch(e) { }
  }
}

},{"has-cors":31}],26:[function(_dereq_,module,exports){

/**
 * Expose `Emitter`.
 */

module.exports = Emitter;

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks[event] = this._callbacks[event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  var self = this;
  this._callbacks = this._callbacks || {};

  function on() {
    self.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks[event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks[event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks[event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks[event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

},{}],27:[function(_dereq_,module,exports){
(function (global){
/**
 * Module dependencies.
 */

var keys = _dereq_('./keys');
var hasBinary = _dereq_('has-binary');
var sliceBuffer = _dereq_('arraybuffer.slice');
var base64encoder = _dereq_('base64-arraybuffer');
var after = _dereq_('after');
var utf8 = _dereq_('utf8');

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = navigator.userAgent.match(/Android/i);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = _dereq_('blob');

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if ('function' == typeof supportsBinary) {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if ('function' == typeof utf8encode) {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (Blob && data instanceof global.Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    packet.data = fr.result;
    exports.encodePacket(packet, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (Blob && packet.data instanceof global.Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += global.btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  // String data
  if (typeof data == 'string' || data === undefined) {
    if (data.charAt(0) == 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      try {
        data = utf8.decode(data);
      } catch (e) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!global.ArrayBuffer) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary == 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data != 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data == '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = ''
    , n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (':' != chr) {
      length += chr;
    } else {
      if ('' == length || (length != (n = Number(length)))) {
        // parser error - ignoring payload
        return callback(err, 0, 1);
      }

      msg = data.substr(i + 1, n);

      if (length != msg.length) {
        // parser error - ignoring payload
        return callback(err, 0, 1);
      }

      if (msg.length) {
        packet = exports.decodePacket(msg, binaryType, true);

        if (err.type == packet.type && err.data == packet.data) {
          // parser error in individual packet - ignoring payload
          return callback(err, 0, 1);
        }

        var ret = callback(packet, i + n, l);
        if (false === ret) return;
      }

      // advance cursor
      i += n;
      length = '';
    }
  }

  if (length != '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  var numberTooLong = false;
  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] == 255) break;

      if (msgLength.length > 310) {
        numberTooLong = true;
        break;
      }

      msgLength += tailArray[i];
    }

    if(numberTooLong) return callback(err, 0, 1);

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{"./keys":28,"after":6,"arraybuffer.slice":7,"base64-arraybuffer":9,"blob":10,"has-binary":29,"utf8":44}],28:[function(_dereq_,module,exports){

/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};

},{}],29:[function(_dereq_,module,exports){
(function (global){

/*
 * Module requirements.
 */

var isArray = _dereq_('isarray');

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Right now only Buffer and ArrayBuffer are supported..
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary(data) {

  function _hasBinary(obj) {
    if (!obj) return false;

    if ( (global.Buffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
         (global.Blob && obj instanceof Blob) ||
         (global.File && obj instanceof File)
        ) {
      return true;
    }

    if (isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
          if (_hasBinary(obj[i])) {
              return true;
          }
      }
    } else if (obj && 'object' == typeof obj) {
      if (obj.toJSON) {
        obj = obj.toJSON();
      }

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
          return true;
        }
      }
    }

    return false;
  }

  return _hasBinary(data);
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{"isarray":33}],30:[function(_dereq_,module,exports){
(function (global){

/*
 * Module requirements.
 */

var isArray = _dereq_('isarray');

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Right now only Buffer and ArrayBuffer are supported..
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary(data) {

  function _hasBinary(obj) {
    if (!obj) return false;

    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
         (global.Blob && obj instanceof Blob) ||
         (global.File && obj instanceof File)
        ) {
      return true;
    }

    if (isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
          if (_hasBinary(obj[i])) {
              return true;
          }
      }
    } else if (obj && 'object' == typeof obj) {
      // see: https://github.com/Automattic/has-binary/pull/4
      if (obj.toJSON && 'function' == typeof obj.toJSON) {
        obj = obj.toJSON();
      }

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
          return true;
        }
      }
    }

    return false;
  }

  return _hasBinary(data);
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{"isarray":33}],31:[function(_dereq_,module,exports){

/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}

},{}],32:[function(_dereq_,module,exports){

var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};
},{}],33:[function(_dereq_,module,exports){
module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

},{}],34:[function(_dereq_,module,exports){
(function (global){
/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
;(function () {
  // Detect the `define` function exposed by asynchronous module loaders. The
  // strict `define` check is necessary for compatibility with `r.js`.
  var isLoader = typeof define === "function" && define.amd;

  // A set of types used to distinguish objects from primitives.
  var objectTypes = {
    "function": true,
    "object": true
  };

  // Detect the `exports` object exposed by CommonJS implementations.
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  // Use the `global` object exposed by Node (including Browserify via
  // `insert-module-globals`), Narwhal, and Ringo as the default context,
  // and the `window` object in browsers. Rhino exports a `global` function
  // instead.
  var root = objectTypes[typeof window] && window || this,
      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;

  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
    root = freeGlobal;
  }

  // Public: Initializes JSON 3 using the given `context` object, attaching the
  // `stringify` and `parse` functions to the specified `exports` object.
  function runInContext(context, exports) {
    context || (context = root["Object"]());
    exports || (exports = root["Object"]());

    // Native constructor aliases.
    var Number = context["Number"] || root["Number"],
        String = context["String"] || root["String"],
        Object = context["Object"] || root["Object"],
        Date = context["Date"] || root["Date"],
        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
        TypeError = context["TypeError"] || root["TypeError"],
        Math = context["Math"] || root["Math"],
        nativeJSON = context["JSON"] || root["JSON"];

    // Delegate to the native `stringify` and `parse` implementations.
    if (typeof nativeJSON == "object" && nativeJSON) {
      exports.stringify = nativeJSON.stringify;
      exports.parse = nativeJSON.parse;
    }

    // Convenience aliases.
    var objectProto = Object.prototype,
        getClass = objectProto.toString,
        isProperty, forEach, undef;

    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
    var isExtended = new Date(-3509827334573292);
    try {
      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
      // results for certain dates in Opera >= 10.53.
      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
        // Safari < 2.0.2 stores the internal millisecond time value correctly,
        // but clips the values returned by the date methods to the range of
        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
    } catch (exception) {}

    // Internal: Determines whether the native `JSON.stringify` and `parse`
    // implementations are spec-compliant. Based on work by Ken Snyder.
    function has(name) {
      if (has[name] !== undef) {
        // Return cached feature test result.
        return has[name];
      }
      var isSupported;
      if (name == "bug-string-char-index") {
        // IE <= 7 doesn't support accessing string characters using square
        // bracket notation. IE 8 only supports this for primitives.
        isSupported = "a"[0] != "a";
      } else if (name == "json") {
        // Indicates whether both `JSON.stringify` and `JSON.parse` are
        // supported.
        isSupported = has("json-stringify") && has("json-parse");
      } else {
        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
        // Test `JSON.stringify`.
        if (name == "json-stringify") {
          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
          if (stringifySupported) {
            // A test function object with a custom `toJSON` method.
            (value = function () {
              return 1;
            }).toJSON = value;
            try {
              stringifySupported =
                // Firefox 3.1b1 and b2 serialize string, number, and boolean
                // primitives as object literals.
                stringify(0) === "0" &&
                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
                // literals.
                stringify(new Number()) === "0" &&
                stringify(new String()) == '""' &&
                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
                // does not define a canonical JSON representation (this applies to
                // objects with `toJSON` properties as well, *unless* they are nested
                // within an object or array).
                stringify(getClass) === undef &&
                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
                // FF 3.1b3 pass this test.
                stringify(undef) === undef &&
                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
                // respectively, if the value is omitted entirely.
                stringify() === undef &&
                // FF 3.1b1, 2 throw an error if the given value is not a number,
                // string, array, object, Boolean, or `null` literal. This applies to
                // objects with custom `toJSON` methods as well, unless they are nested
                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
                // methods entirely.
                stringify(value) === "1" &&
                stringify([value]) == "[1]" &&
                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
                // `"[null]"`.
                stringify([undef]) == "[null]" &&
                // YUI 3.0.0b1 fails to serialize `null` literals.
                stringify(null) == "null" &&
                // FF 3.1b1, 2 halts serialization if an array contains a function:
                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
                // elides non-JSON values from objects and arrays, unless they
                // define custom `toJSON` methods.
                stringify([undef, getClass, null]) == "[null,null,null]" &&
                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
                // where character escape codes are expected (e.g., `\b` => `\u0008`).
                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
                stringify(null, value) === "1" &&
                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
                // serialize extended years.
                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
                // The milliseconds are optional in ES 5, but required in 5.1.
                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
                // four-digit years instead of six-digit years. Credits: @Yaffle.
                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
                // values less than 1000. Credits: @Yaffle.
                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
            } catch (exception) {
              stringifySupported = false;
            }
          }
          isSupported = stringifySupported;
        }
        // Test `JSON.parse`.
        if (name == "json-parse") {
          var parse = exports.parse;
          if (typeof parse == "function") {
            try {
              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
              // Conforming implementations should also coerce the initial argument to
              // a string prior to parsing.
              if (parse("0") === 0 && !parse(false)) {
                // Simple parsing test.
                value = parse(serialized);
                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
                if (parseSupported) {
                  try {
                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
                    parseSupported = !parse('"\t"');
                  } catch (exception) {}
                  if (parseSupported) {
                    try {
                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
                      // certain octal literals.
                      parseSupported = parse("01") !== 1;
                    } catch (exception) {}
                  }
                  if (parseSupported) {
                    try {
                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
                      // points. These environments, along with FF 3.1b1 and 2,
                      // also allow trailing commas in JSON objects and arrays.
                      parseSupported = parse("1.") !== 1;
                    } catch (exception) {}
                  }
                }
              }
            } catch (exception) {
              parseSupported = false;
            }
          }
          isSupported = parseSupported;
        }
      }
      return has[name] = !!isSupported;
    }

    if (!has("json")) {
      // Common `[[Class]]` name aliases.
      var functionClass = "[object Function]",
          dateClass = "[object Date]",
          numberClass = "[object Number]",
          stringClass = "[object String]",
          arrayClass = "[object Array]",
          booleanClass = "[object Boolean]";

      // Detect incomplete support for accessing string characters by index.
      var charIndexBuggy = has("bug-string-char-index");

      // Define additional utility methods if the `Date` methods are buggy.
      if (!isExtended) {
        var floor = Math.floor;
        // A mapping between the months of the year and the number of days between
        // January 1st and the first of the respective month.
        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        // Internal: Calculates the number of days between the Unix epoch and the
        // first day of the given month.
        var getDay = function (year, month) {
          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
        };
      }

      // Internal: Determines if a property is a direct property of the given
      // object. Delegates to the native `Object#hasOwnProperty` method.
      if (!(isProperty = objectProto.hasOwnProperty)) {
        isProperty = function (property) {
          var members = {}, constructor;
          if ((members.__proto__ = null, members.__proto__ = {
            // The *proto* property cannot be set multiple times in recent
            // versions of Firefox and SeaMonkey.
            "toString": 1
          }, members).toString != getClass) {
            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
            // supports the mutable *proto* property.
            isProperty = function (property) {
              // Capture and break the object's prototype chain (see section 8.6.2
              // of the ES 5.1 spec). The parenthesized expression prevents an
              // unsafe transformation by the Closure Compiler.
              var original = this.__proto__, result = property in (this.__proto__ = null, this);
              // Restore the original prototype chain.
              this.__proto__ = original;
              return result;
            };
          } else {
            // Capture a reference to the top-level `Object` constructor.
            constructor = members.constructor;
            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
            // other environments.
            isProperty = function (property) {
              var parent = (this.constructor || constructor).prototype;
              return property in this && !(property in parent && this[property] === parent[property]);
            };
          }
          members = null;
          return isProperty.call(this, property);
        };
      }

      // Internal: Normalizes the `for...in` iteration algorithm across
      // environments. Each enumerated key is yielded to a `callback` function.
      forEach = function (object, callback) {
        var size = 0, Properties, members, property;

        // Tests for bugs in the current environment's `for...in` algorithm. The
        // `valueOf` property inherits the non-enumerable flag from
        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
        (Properties = function () {
          this.valueOf = 0;
        }).prototype.valueOf = 0;

        // Iterate over a new instance of the `Properties` class.
        members = new Properties();
        for (property in members) {
          // Ignore all properties inherited from `Object.prototype`.
          if (isProperty.call(members, property)) {
            size++;
          }
        }
        Properties = members = null;

        // Normalize the iteration algorithm.
        if (!size) {
          // A list of non-enumerable properties inherited from `Object.prototype`.
          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
          // properties.
          forEach = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, length;
            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
            for (property in object) {
              // Gecko <= 1.0 enumerates the `prototype` property of functions under
              // certain conditions; IE does not.
              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
                callback(property);
              }
            }
            // Manually invoke the callback for each non-enumerable property.
            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
          };
        } else if (size == 2) {
          // Safari <= 2.0.4 enumerates shadowed properties twice.
          forEach = function (object, callback) {
            // Create a set of iterated properties.
            var members = {}, isFunction = getClass.call(object) == functionClass, property;
            for (property in object) {
              // Store each property name to prevent double enumeration. The
              // `prototype` property of functions is not enumerated due to cross-
              // environment inconsistencies.
              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
                callback(property);
              }
            }
          };
        } else {
          // No bugs detected; use the standard `for...in` algorithm.
          forEach = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
            for (property in object) {
              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
                callback(property);
              }
            }
            // Manually invoke the callback for the `constructor` property due to
            // cross-environment inconsistencies.
            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
              callback(property);
            }
          };
        }
        return forEach(object, callback);
      };

      // Public: Serializes a JavaScript `value` as a JSON string. The optional
      // `filter` argument may specify either a function that alters how object and
      // array members are serialized, or an array of strings and numbers that
      // indicates which properties should be serialized. The optional `width`
      // argument may be either a string or number that specifies the indentation
      // level of the output.
      if (!has("json-stringify")) {
        // Internal: A map of control characters and their escaped equivalents.
        var Escapes = {
          92: "\\\\",
          34: '\\"',
          8: "\\b",
          12: "\\f",
          10: "\\n",
          13: "\\r",
          9: "\\t"
        };

        // Internal: Converts `value` into a zero-padded string such that its
        // length is at least equal to `width`. The `width` must be <= 6.
        var leadingZeroes = "000000";
        var toPaddedString = function (width, value) {
          // The `|| 0` expression is necessary to work around a bug in
          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
          return (leadingZeroes + (value || 0)).slice(-width);
        };

        // Internal: Double-quotes a string `value`, replacing all ASCII control
        // characters (characters with code unit values between 0 and 31) with
        // their escaped equivalents. This is an implementation of the
        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
        var unicodePrefix = "\\u00";
        var quote = function (value) {
          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
          for (; index < length; index++) {
            var charCode = value.charCodeAt(index);
            // If the character is a control character, append its Unicode or
            // shorthand escape sequence; otherwise, append the character as-is.
            switch (charCode) {
              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
                result += Escapes[charCode];
                break;
              default:
                if (charCode < 32) {
                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
                  break;
                }
                result += useCharIndex ? symbols[index] : value.charAt(index);
            }
          }
          return result + '"';
        };

        // Internal: Recursively serializes an object. Implements the
        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
          try {
            // Necessary for host object support.
            value = object[property];
          } catch (exception) {}
          if (typeof value == "object" && value) {
            className = getClass.call(value);
            if (className == dateClass && !isProperty.call(value, "toJSON")) {
              if (value > -1 / 0 && value < 1 / 0) {
                // Dates are serialized according to the `Date#toJSON` method
                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
                // for the ISO 8601 date time string format.
                if (getDay) {
                  // Manually compute the year, month, date, hours, minutes,
                  // seconds, and milliseconds if the `getUTC*` methods are
                  // buggy. Adapted from @Yaffle's `date-shim` project.
                  date = floor(value / 864e5);
                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
                  date = 1 + date - getDay(year, month);
                  // The `time` value specifies the time within the day (see ES
                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
                  // to compute `A modulo B`, as the `%` operator does not
                  // correspond to the `modulo` operation for negative numbers.
                  time = (value % 864e5 + 864e5) % 864e5;
                  // The hours, minutes, seconds, and milliseconds are obtained by
                  // decomposing the time within the day. See section 15.9.1.10.
                  hours = floor(time / 36e5) % 24;
                  minutes = floor(time / 6e4) % 60;
                  seconds = floor(time / 1e3) % 60;
                  milliseconds = time % 1e3;
                } else {
                  year = value.getUTCFullYear();
                  month = value.getUTCMonth();
                  date = value.getUTCDate();
                  hours = value.getUTCHours();
                  minutes = value.getUTCMinutes();
                  seconds = value.getUTCSeconds();
                  milliseconds = value.getUTCMilliseconds();
                }
                // Serialize extended years correctly.
                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
                  // Months, dates, hours, minutes, and seconds should have two
                  // digits; milliseconds should have three.
                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
                  // Milliseconds are optional in ES 5.0, but required in 5.1.
                  "." + toPaddedString(3, milliseconds) + "Z";
              } else {
                value = null;
              }
            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
              // ignores all `toJSON` methods on these objects unless they are
              // defined directly on an instance.
              value = value.toJSON(property);
            }
          }
          if (callback) {
            // If a replacement function was provided, call it to obtain the value
            // for serialization.
            value = callback.call(object, property, value);
          }
          if (value === null) {
            return "null";
          }
          className = getClass.call(value);
          if (className == booleanClass) {
            // Booleans are represented literally.
            return "" + value;
          } else if (className == numberClass) {
            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
            // `"null"`.
            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
          } else if (className == stringClass) {
            // Strings are double-quoted and escaped.
            return quote("" + value);
          }
          // Recursively serialize objects and arrays.
          if (typeof value == "object") {
            // Check for cyclic structures. This is a linear search; performance
            // is inversely proportional to the number of unique nested objects.
            for (length = stack.length; length--;) {
              if (stack[length] === value) {
                // Cyclic structures cannot be serialized by `JSON.stringify`.
                throw TypeError();
              }
            }
            // Add the object to the stack of traversed objects.
            stack.push(value);
            results = [];
            // Save the current indentation level and indent one additional level.
            prefix = indentation;
            indentation += whitespace;
            if (className == arrayClass) {
              // Recursively serialize array elements.
              for (index = 0, length = value.length; index < length; index++) {
                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
                results.push(element === undef ? "null" : element);
              }
              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
            } else {
              // Recursively serialize object members. Members are selected from
              // either a user-specified list of property names, or the object
              // itself.
              forEach(properties || value, function (property) {
                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
                if (element !== undef) {
                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
                  // is not the empty string, let `member` {quote(property) + ":"}
                  // be the concatenation of `member` and the `space` character."
                  // The "`space` character" refers to the literal space
                  // character, not the `space` {width} argument provided to
                  // `JSON.stringify`.
                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
                }
              });
              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
            }
            // Remove the object from the traversed object stack.
            stack.pop();
            return result;
          }
        };

        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
        exports.stringify = function (source, filter, width) {
          var whitespace, callback, properties, className;
          if (objectTypes[typeof filter] && filter) {
            if ((className = getClass.call(filter)) == functionClass) {
              callback = filter;
            } else if (className == arrayClass) {
              // Convert the property names array into a makeshift set.
              properties = {};
              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
            }
          }
          if (width) {
            if ((className = getClass.call(width)) == numberClass) {
              // Convert the `width` to an integer and create a string containing
              // `width` number of space characters.
              if ((width -= width % 1) > 0) {
                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
              }
            } else if (className == stringClass) {
              whitespace = width.length <= 10 ? width : width.slice(0, 10);
            }
          }
          // Opera <= 7.54u2 discards the values associated with empty string keys
          // (`""`) only if they are used directly within an object member list
          // (e.g., `!("" in { "": 1})`).
          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
        };
      }

      // Public: Parses a JSON source string.
      if (!has("json-parse")) {
        var fromCharCode = String.fromCharCode;

        // Internal: A map of escaped control characters and their unescaped
        // equivalents.
        var Unescapes = {
          92: "\\",
          34: '"',
          47: "/",
          98: "\b",
          116: "\t",
          110: "\n",
          102: "\f",
          114: "\r"
        };

        // Internal: Stores the parser state.
        var Index, Source;

        // Internal: Resets the parser state and throws a `SyntaxError`.
        var abort = function () {
          Index = Source = null;
          throw SyntaxError();
        };

        // Internal: Returns the next token, or `"$"` if the parser has reached
        // the end of the source string. A token may be a string, number, `null`
        // literal, or Boolean literal.
        var lex = function () {
          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
          while (Index < length) {
            charCode = source.charCodeAt(Index);
            switch (charCode) {
              case 9: case 10: case 13: case 32:
                // Skip whitespace tokens, including tabs, carriage returns, line
                // feeds, and space characters.
                Index++;
                break;
              case 123: case 125: case 91: case 93: case 58: case 44:
                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
                // the current position.
                value = charIndexBuggy ? source.charAt(Index) : source[Index];
                Index++;
                return value;
              case 34:
                // `"` delimits a JSON string; advance to the next character and
                // begin parsing the string. String tokens are prefixed with the
                // sentinel `@` character to distinguish them from punctuators and
                // end-of-string tokens.
                for (value = "@", Index++; Index < length;) {
                  charCode = source.charCodeAt(Index);
                  if (charCode < 32) {
                    // Unescaped ASCII control characters (those with a code unit
                    // less than the space character) are not permitted.
                    abort();
                  } else if (charCode == 92) {
                    // A reverse solidus (`\`) marks the beginning of an escaped
                    // control character (including `"`, `\`, and `/`) or Unicode
                    // escape sequence.
                    charCode = source.charCodeAt(++Index);
                    switch (charCode) {
                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
                        // Revive escaped control characters.
                        value += Unescapes[charCode];
                        Index++;
                        break;
                      case 117:
                        // `\u` marks the beginning of a Unicode escape sequence.
                        // Advance to the first character and validate the
                        // four-digit code point.
                        begin = ++Index;
                        for (position = Index + 4; Index < position; Index++) {
                          charCode = source.charCodeAt(Index);
                          // A valid sequence comprises four hexdigits (case-
                          // insensitive) that form a single hexadecimal value.
                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
                            // Invalid Unicode escape sequence.
                            abort();
                          }
                        }
                        // Revive the escaped character.
                        value += fromCharCode("0x" + source.slice(begin, Index));
                        break;
                      default:
                        // Invalid escape sequence.
                        abort();
                    }
                  } else {
                    if (charCode == 34) {
                      // An unescaped double-quote character marks the end of the
                      // string.
                      break;
                    }
                    charCode = source.charCodeAt(Index);
                    begin = Index;
                    // Optimize for the common case where a string is valid.
                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
                      charCode = source.charCodeAt(++Index);
                    }
                    // Append the string as-is.
                    value += source.slice(begin, Index);
                  }
                }
                if (source.charCodeAt(Index) == 34) {
                  // Advance to the next character and return the revived string.
                  Index++;
                  return value;
                }
                // Unterminated string.
                abort();
              default:
                // Parse numbers and literals.
                begin = Index;
                // Advance past the negative sign, if one is specified.
                if (charCode == 45) {
                  isSigned = true;
                  charCode = source.charCodeAt(++Index);
                }
                // Parse an integer or floating-point value.
                if (charCode >= 48 && charCode <= 57) {
                  // Leading zeroes are interpreted as octal literals.
                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
                    // Illegal octal literal.
                    abort();
                  }
                  isSigned = false;
                  // Parse the integer component.
                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
                  // Floats cannot contain a leading decimal point; however, this
                  // case is already accounted for by the parser.
                  if (source.charCodeAt(Index) == 46) {
                    position = ++Index;
                    // Parse the decimal component.
                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
                    if (position == Index) {
                      // Illegal trailing decimal.
                      abort();
                    }
                    Index = position;
                  }
                  // Parse exponents. The `e` denoting the exponent is
                  // case-insensitive.
                  charCode = source.charCodeAt(Index);
                  if (charCode == 101 || charCode == 69) {
                    charCode = source.charCodeAt(++Index);
                    // Skip past the sign following the exponent, if one is
                    // specified.
                    if (charCode == 43 || charCode == 45) {
                      Index++;
                    }
                    // Parse the exponential component.
                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
                    if (position == Index) {
                      // Illegal empty exponent.
                      abort();
                    }
                    Index = position;
                  }
                  // Coerce the parsed value to a JavaScript number.
                  return +source.slice(begin, Index);
                }
                // A negative sign may only precede numbers.
                if (isSigned) {
                  abort();
                }
                // `true`, `false`, and `null` literals.
                if (source.slice(Index, Index + 4) == "true") {
                  Index += 4;
                  return true;
                } else if (source.slice(Index, Index + 5) == "false") {
                  Index += 5;
                  return false;
                } else if (source.slice(Index, Index + 4) == "null") {
                  Index += 4;
                  return null;
                }
                // Unrecognized token.
                abort();
            }
          }
          // Return the sentinel `$` character if the parser has reached the end
          // of the source string.
          return "$";
        };

        // Internal: Parses a JSON `value` token.
        var get = function (value) {
          var results, hasMembers;
          if (value == "$") {
            // Unexpected end of input.
            abort();
          }
          if (typeof value == "string") {
            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
              // Remove the sentinel `@` character.
              return value.slice(1);
            }
            // Parse object and array literals.
            if (value == "[") {
              // Parses a JSON array, returning a new JavaScript array.
              results = [];
              for (;; hasMembers || (hasMembers = true)) {
                value = lex();
                // A closing square bracket marks the end of the array literal.
                if (value == "]") {
                  break;
                }
                // If the array literal contains elements, the current token
                // should be a comma separating the previous element from the
                // next.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "]") {
                      // Unexpected trailing `,` in array literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each array element.
                    abort();
                  }
                }
                // Elisions and leading commas are not permitted.
                if (value == ",") {
                  abort();
                }
                results.push(get(value));
              }
              return results;
            } else if (value == "{") {
              // Parses a JSON object, returning a new JavaScript object.
              results = {};
              for (;; hasMembers || (hasMembers = true)) {
                value = lex();
                // A closing curly brace marks the end of the object literal.
                if (value == "}") {
                  break;
                }
                // If the object literal contains members, the current token
                // should be a comma separator.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "}") {
                      // Unexpected trailing `,` in object literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each object member.
                    abort();
                  }
                }
                // Leading commas are not permitted, object property names must be
                // double-quoted strings, and a `:` must separate each property
                // name and value.
                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
                  abort();
                }
                results[value.slice(1)] = get(lex());
              }
              return results;
            }
            // Unexpected token encountered.
            abort();
          }
          return value;
        };

        // Internal: Updates a traversed object member.
        var update = function (source, property, callback) {
          var element = walk(source, property, callback);
          if (element === undef) {
            delete source[property];
          } else {
            source[property] = element;
          }
        };

        // Internal: Recursively traverses a parsed JSON object, invoking the
        // `callback` function for each value. This is an implementation of the
        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
        var walk = function (source, property, callback) {
          var value = source[property], length;
          if (typeof value == "object" && value) {
            // `forEach` can't be used to traverse an array in Opera <= 8.54
            // because its `Object#hasOwnProperty` implementation returns `false`
            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
            if (getClass.call(value) == arrayClass) {
              for (length = value.length; length--;) {
                update(value, length, callback);
              }
            } else {
              forEach(value, function (property) {
                update(value, property, callback);
              });
            }
          }
          return callback.call(source, property, value);
        };

        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
        exports.parse = function (source, callback) {
          var result, value;
          Index = 0;
          Source = "" + source;
          result = get(lex());
          // If a JSON string contains multiple tokens, it is invalid.
          if (lex() != "$") {
            abort();
          }
          // Reset the parser state.
          Index = Source = null;
          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
        };
      }
    }

    exports["runInContext"] = runInContext;
    return exports;
  }

  if (freeExports && !isLoader) {
    // Export for CommonJS environments.
    runInContext(root, freeExports);
  } else {
    // Export for web browsers and JavaScript engines.
    var nativeJSON = root.JSON,
        previousJSON = root["JSON3"],
        isRestored = false;

    var JSON3 = runInContext(root, (root["JSON3"] = {
      // Public: Restores the original value of the global `JSON` object and
      // returns a reference to the `JSON3` object.
      "noConflict": function () {
        if (!isRestored) {
          isRestored = true;
          root.JSON = nativeJSON;
          root["JSON3"] = previousJSON;
          nativeJSON = previousJSON = null;
        }
        return JSON3;
      }
    }));

    root.JSON = {
      "parse": JSON3.parse,
      "stringify": JSON3.stringify
    };
  }

  // Export for asynchronous module loaders.
  if (isLoader) {
    define(function () {
      return JSON3;
    });
  }
}).call(this);

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{}],35:[function(_dereq_,module,exports){
/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options){
  options = options || {};
  if ('string' == typeof val) return parse(val);
  return options.long
    ? long(val)
    : short(val);
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = '' + str;
  if (str.length > 10000) return;
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) return;
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function short(ms) {
  if (ms >= d) return Math.round(ms / d) + 'd';
  if (ms >= h) return Math.round(ms / h) + 'h';
  if (ms >= m) return Math.round(ms / m) + 'm';
  if (ms >= s) return Math.round(ms / s) + 's';
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function long(ms) {
  return plural(ms, d, 'day')
    || plural(ms, h, 'hour')
    || plural(ms, m, 'minute')
    || plural(ms, s, 'second')
    || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) return;
  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
  return Math.ceil(ms / n) + ' ' + name + 's';
}

},{}],36:[function(_dereq_,module,exports){
(function (global){
/**
 * JSON parse.
 *
 * @see Based on jQuery#parseJSON (MIT) and JSON2
 * @api private
 */

var rvalidchars = /^[\],:{}\s]*$/;
var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
var rtrimLeft = /^\s+/;
var rtrimRight = /\s+$/;

module.exports = function parsejson(data) {
  if ('string' != typeof data || !data) {
    return null;
  }

  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');

  // Attempt to parse using the native JSON parser first
  if (global.JSON && JSON.parse) {
    return JSON.parse(data);
  }

  if (rvalidchars.test(data.replace(rvalidescape, '@')
      .replace(rvalidtokens, ']')
      .replace(rvalidbraces, ''))) {
    return (new Function('return ' + data))();
  }
};
}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{}],37:[function(_dereq_,module,exports){
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};

},{}],38:[function(_dereq_,module,exports){
/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    return uri;
};

},{}],39:[function(_dereq_,module,exports){
(function (global){
/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = _dereq_('isarray');
var isBuf = _dereq_('./is-buffer');

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet){
  var buffers = [];
  var packetData = packet.data;

  function _deconstructPacket(data) {
    if (!data) return data;

    if (isBuf(data)) {
      var placeholder = { _placeholder: true, num: buffers.length };
      buffers.push(data);
      return placeholder;
    } else if (isArray(data)) {
      var newData = new Array(data.length);
      for (var i = 0; i < data.length; i++) {
        newData[i] = _deconstructPacket(data[i]);
      }
      return newData;
    } else if ('object' == typeof data && !(data instanceof Date)) {
      var newData = {};
      for (var key in data) {
        newData[key] = _deconstructPacket(data[key]);
      }
      return newData;
    }
    return data;
  }

  var pack = packet;
  pack.data = _deconstructPacket(packetData);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  var curPlaceHolder = 0;

  function _reconstructPacket(data) {
    if (data && data._placeholder) {
      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
      return buf;
    } else if (isArray(data)) {
      for (var i = 0; i < data.length; i++) {
        data[i] = _reconstructPacket(data[i]);
      }
      return data;
    } else if (data && 'object' == typeof data) {
      for (var key in data) {
        data[key] = _reconstructPacket(data[key]);
      }
      return data;
    }
    return data;
  }

  packet.data = _reconstructPacket(packet.data);
  packet.attachments = undefined; // no longer useful
  return packet;
};

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((global.Blob && obj instanceof Blob) ||
        (global.File && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{"./is-buffer":41,"isarray":33}],40:[function(_dereq_,module,exports){

/**
 * Module dependencies.
 */

var debug = _dereq_('debug')('socket.io-parser');
var json = _dereq_('json3');
var isArray = _dereq_('isarray');
var Emitter = _dereq_('component-emitter');
var binary = _dereq_('./binary');
var isBuf = _dereq_('./is-buffer');

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
    encodeAsBinary(obj, callback);
  }
  else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {
  var str = '';
  var nsp = false;

  // first is type
  str += obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
    str += obj.attachments;
    str += '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' != obj.nsp) {
    nsp = true;
    str += obj.nsp;
  }

  // immediately followed by the id
  if (null != obj.id) {
    if (nsp) {
      str += ',';
      nsp = false;
    }
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    if (nsp) str += ',';
    str += json.stringify(obj.data);
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an ecoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if ('string' == typeof obj) {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  }
  else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  }
  else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var p = {};
  var i = 0;

  // look up type
  p.type = Number(str.charAt(0));
  if (null == exports.types[p.type]) return error();

  // look up attachments if type binary
  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
    var buf = '';
    while (str.charAt(++i) != '-') {
      buf += str.charAt(i);
      if (i == str.length) break;
    }
    if (buf != Number(buf) || str.charAt(i) != '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' == str.charAt(i + 1)) {
    p.nsp = '';
    while (++i) {
      var c = str.charAt(i);
      if (',' == c) break;
      p.nsp += c;
      if (i == str.length) break;
    }
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    p.id = '';
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      p.id += str.charAt(i);
      if (i == str.length) break;
    }
    p.id = Number(p.id);
  }

  // look up json data
  if (str.charAt(++i)) {
    try {
      p.data = json.parse(str.substr(i));
    } catch(e){
      return error();
    }
  }

  debug('decoded %s as %j', str, p);
  return p;
}

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error(data){
  return {
    type: exports.ERROR,
    data: 'parser error'
  };
}

},{"./binary":39,"./is-buffer":41,"component-emitter":42,"debug":14,"isarray":33,"json3":34}],41:[function(_dereq_,module,exports){
(function (global){

module.exports = isBuf;

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer);
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{}],42:[function(_dereq_,module,exports){
arguments[4][26][0].apply(exports,arguments)
},{"dup":26}],43:[function(_dereq_,module,exports){
module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}

},{}],44:[function(_dereq_,module,exports){
(function (global){
/*! https://mths.be/utf8js v2.0.0 by @mathias */
;(function(root) {

	// Detect free variables `exports`
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	function checkScalarValue(codePoint) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
	}
	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			checkScalarValue(codePoint);
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function utf8encode(string) {
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol() {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			var byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				checkScalarValue(codePoint);
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid UTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString) {
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol()) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	var utf8 = {
		'version': '2.0.0',
		'encode': utf8encode,
		'decode': utf8decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define(function() {
			return utf8;
		});
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = utf8;
		} else { // in Narwhal or RingoJS v0.7.0-
			var object = {};
			var hasOwnProperty = object.hasOwnProperty;
			for (var key in utf8) {
				hasOwnProperty.call(utf8, key) && (freeExports[key] = utf8[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.utf8 = utf8;
	}

}(this));

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {})
},{}],45:[function(_dereq_,module,exports){
'use strict';

var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;

},{}]},{},[1])(1)
});

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages', [
    'ui.router',

    // 'BlurAdmin.pages.dashboard',
    // 'BlurAdmin.pages.ui',
    // 'BlurAdmin.pages.components',
    // 'BlurAdmin.pages.form',
    // 'BlurAdmin.pages.tables',
    // 'BlurAdmin.pages.charts',
    // 'BlurAdmin.pages.maps',
    // 'BlurAdmin.pages.profile',

    'BlurAdmin.pages.turf'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, $stateProvider) {
    $urlRouterProvider.otherwise('/login');

    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/pages/login.html'
      })
      .state('grupo', {
        url: '/grupo',
        templateUrl: 'app/pages/grupo.html'
      });

  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      // 'chart.js',
      // 'angular-chartist',
      // 'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components'
  ]);

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf', [])
        .constant('HIPODROMO', {
            palermo: 1,
            sanIsidro: 2,
            laPlata: 3
        })
        .config(routeConfig)
        .factory('TurfSocket', function (socketFactory, ENV_VARS) {
            var myIoSocket = io.connect(ENV_VARS.socketUrl);
            var TurfSocket;

            TurfSocket = socketFactory({
                ioSocket: myIoSocket
            });

            return TurfSocket;
        });

    function routeConfig($stateProvider) {
        $stateProvider
            .state('turf', {
                url: '/turf',
                template : '<ui-view></ui-view>',
                abstract: true,
                title: 'Turf',
                sidebarMeta: {
                    icon: 'ion-trophy',
                    order: 0
                }
            })
            .state('turf.usuarios', {
                url: '/usuarios',
                templateUrl: 'app/pages/turf/usuarios/usuarios.html',
                controller: 'UsuariosController',
                controllerAs: 'vm',
                title: 'Usuarios',
                sidebarMeta: {
                    order: 10,
                },
                itemFor: ['superadmin', 'agente']
            })
            .state('turf.grupos', {
                url: '/grupos',
                templateUrl: 'app/pages/turf/grupos/grupos.html',
                controller: 'GruposController',
                controllerAs: 'vm',
                title: 'Grupos',
                sidebarMeta: {
                    order: 15,
                },
                itemFor: ['superadmin', 'admin']
            })
            .state('turf.saldos', {
                url: '/saldos',
                templateUrl: 'app/pages/turf/saldos/saldos.html',
                controller: 'SaldosController',
                controllerAs: 'vm',
                title: 'Saldos',
                sidebarMeta: {
                    order: 17,
                },
                itemFor: ['superadmin', 'admin', 'agente']
            })
            .state('turf.hipodromos', {
                url: '/hipodromos',
                templateUrl: 'app/pages/turf/hipodromos/hipodromos.html',
                controller: 'HipodromosController',
                controllerAs: 'vm',
                title: 'Hipódromos',
                sidebarMeta: {
                    order: 20,
                },
                itemFor: ['superadmin', 'admin']
            })
            .state('turf.tarifas', {
                url: '/tarifas',
                templateUrl: 'app/pages/turf/tarifas/tarifas.html',
                controller: 'TarifasController',
                controllerAs: 'vm',
                title: 'Tarifas',
                sidebarMeta: {
                    order: 25,
                },
                itemFor: ['superadmin', 'admin']
            })
            .state('turf.incrementos', {
                url: '/incrementos',
                templateUrl: 'app/pages/turf/incrementos/incrementos.html',
                controller: 'IncrementosController',
                controllerAs: 'vm',
                title: 'Incrementos',
                sidebarMeta: {
                    order: 27,
                },
                itemFor: ['superadmin', 'admin']
            })
            .state('turf.limites', {
                url: '/limites',
                templateUrl: 'app/pages/turf/limites/limites.html',
                controller: 'LimitesController',
                controllerAs: 'vm',
                title: 'Limites',
                sidebarMeta: {
                    order: 28,
                },
                itemFor: ['superadmin', 'admin']
            })
            .state('turf.jornadas', {
                url: '/jornadas',
                templateUrl: 'app/pages/turf/jornadas/jornadas.html',
                controller: 'JornadasController',
                controllerAs: 'vm',
                title: 'Jornadas',
                sidebarMeta: {
                    order: 30,
                },
                itemFor: ['superadmin', 'admin']
            })
            .state('turf.carreras', {
                url: '/carreras',
                templateUrl: 'app/pages/turf/carreras/carreras.html',
                controller: 'CarrerasController',
                controllerAs: 'vm',
                title: 'Carreras',
                sidebarMeta: {
                    order: 40,
                },
                itemFor: ['superadmin', 'admin']
            })
            .state('turf.retirados', {
                url: '/retirados',
                templateUrl: 'app/pages/turf/retirados/retirados.html',
                controller: 'RetiradosController',
                controllerAs: 'vm',
                title: 'Retirados',
                sidebarMeta: {
                    order: 50,
                },
                itemFor: ['superadmin', 'admin']
            })
            .state('turf.jugar', {
                url: '/jugar',
                templateUrl: 'app/pages/turf/jugar/jugar.html',
                controller: 'JugarController',
                controllerAs: 'vm',
                title: 'Jugar',
                sidebarMeta: {
                    order: 55,
                },
                itemFor: ['superadmin', 'admin', 'empleado', 'particular', 'agente']
            })
            .state('turf.apuestas', {
                url: '/apuestas',
                templateUrl: 'app/pages/turf/apuestas/apuestas.html',
                controller: 'ApuestasController',
                controllerAs: 'vm',
                title: 'Apuestas',
                sidebarMeta: {
                    order: 60,
                },
                itemFor: ['superadmin', 'admin', 'empleado', 'particular', 'agente']
            })
            .state('turf.movimientos', {
                url: '/movimientos',
                templateUrl: 'app/pages/turf/movimientos/movimientos.html',
                controller: 'MovimientosController',
                controllerAs: 'vm',
                title: 'Movimientos',
                sidebarMeta: {
                    order: 65,
                },
                itemFor: ['superadmin', 'admin']
            })
            .state('turf.netwin', {
                url: '/netwin',
                templateUrl: 'app/pages/turf/netwin/netwin.html',
                controller: 'NetwinController',
                controllerAs: 'vm',
                title: 'Netwin',
                sidebarMeta: {
                    order: 66,
                },
                itemFor: ['superadmin', 'admin']
            })
            .state('turf.cierres', {
                url: '/cierres',
                templateUrl: 'app/pages/turf/cierres/cierres.html',
                controller: 'CierresController',
                controllerAs: 'vm',
                title: 'Cierres',
                sidebarMeta: {
                    order: 70,
                },
                itemFor: ['superadmin', 'admin']
            })
            .state('turf.resultados', {
                url: '/resultados',
                templateUrl: 'app/pages/turf/resultados/resultados.html',
                controller: 'ResultadosController',
                controllerAs: 'vm',
                title: 'Resultados',
                sidebarMeta: {
                    order: 80,
                },
                itemFor: ['superadmin', 'admin', 'empleado', 'particular', 'agente']
            })
            // .state('turf.liquidacion', {
            //     url: '/liquidacion',
            //     templateUrl: 'app/pages/turf/liquidacion/liquidacion.html',
            //     controller: 'LiquidacionController',
            //     controllerAs: 'vm',
            //     title: 'Liquidación',
            //     sidebarMeta: {
            //         order: 90,
            //     },
            //     itemFor: ['superadmin', 'admin', 'empleado']
            // })
    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

'use strict';

angular.module('BlurAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  // "xeditable",
  'ui.slimscroll',
  // 'ngJsTree',
  // 'angular-progress-button-styles',

  'BlurAdmin.theme',
  'BlurAdmin.pages',
  'BlurAdmin.config',
  'Auth',
  'LocalStorageModule',
  'btford.socket-io',
  'pr.longpress'
]);

angular.module('BlurAdmin.config', [])
.config(function ($httpProvider) {
  $httpProvider.interceptors.push(function ($q, SessionService) {
    return {
      'request': function (config) {
        config.data = config.data || {};
        if (SessionService.currentUser) {
          config.data['auid'] = SessionService.currentUser.id;
        }
        if (SessionService.token) {
          config.headers['Authorization'] = 'Bearer ' + SessionService.token
        }

        return config;
      }
    };
  });
});

angular.module("BlurAdmin.config")
.constant("ENV_VARS", {"apiUrl":"https://turfapi.cenlog.pro/","socketUrl":"https://turfapi.cenlog.pro/"});

(function () {

    angular.module('Auth', [])
        .controller('AuthController', AuthController)
        .directive('formInit', function () {
            return {
                link: function (scope) {
                    scope.vm.clearCredencial();
                    scope.vm.getLugares();
                }
            }
        });

    function AuthController ($http, $location, $scope, $state, $timeout, ENV_VARS, GlobalHelpers, SessionService, localStorageService, toastr) {
        var vm = this;

        vm.loggingIn = false;

        vm.GlobalHelpers = GlobalHelpers;

        vm.redirectCurrentUser = function () {
            SessionService.initSaldos();
            switch (SessionService.currentUser.tipo) {
                case 'superadmin':
                    $timeout(function () {
                        if (!SessionService.lugar) {
                            $state.go('grupo');
                        } else {
                            // if ($location.path() == '') {
                                $state.go('turf.usuarios');
                            // }
                        }
                    }, 0);
                    break;
                case 'admin':
                    $timeout(function () {
                        if (!SessionService.lugar) {
                            $state.go('grupo');
                        } else {
                            // if ($location.path() == '') {
                                $state.go('turf.apuestas');
                            // }
                        }
                    }, 0);
                    break;
                case 'empleado':
                    $timeout(function () {
                        if (!SessionService.lugar) {
                            $state.go('grupo');
                        } else {
                            // if ($location.path() == '') {
                                $state.go('turf.jugar');
                            // }
                        }
                    }, 0);
                    break;
                case 'agente':
                case 'particular':
                    var lid = SessionService.currentUser.cliente ? SessionService.currentUser.cliente.lugar_id : SessionService.currentUser.lugar_id
                    var lidNum = parseInt(lid, 10)
                    function lugarConId (lista) {
                        return (lista || []).find(function (lugar) {
                            return parseInt(lugar.id, 10) === lidNum
                        })
                    }
                    // Numeric match: JSON/user puede traer lugar_id string y lugar.id number (=== fallaba).
                    SessionService.lugar = lugarConId(SessionService.lugaresParticulares) || lugarConId(SessionService.lugares)
                    $timeout(function () {
                        // if ($location.path() == '') {
                            $state.go('turf.jugar');
                        // }
                    }, 0);
                    break;
            }
        };

        if (localStorageService.keys().indexOf('currentUser') != -1) {
            SessionService.currentUser = localStorageService.get('currentUser');
        }

        if (localStorageService.keys().indexOf('lugar') != -1) {
            SessionService.lugar = localStorageService.get('lugar');
        }
        SessionService.flush()
        // if (!SessionService.checkLoginStatus()) {
            // toastr.error('Sesión expirada, vuelva a ingresar');
            $timeout(function () {
                $state.go('login');
            }, 0);
        // } else {
        //     vm.redirectCurrentUser();
        // }

        vm.SessionService = SessionService;
        vm.localStorageService = localStorageService;

        vm.getLugares = function() {
            $http.get(ENV_VARS.apiUrl + 'lugar').then(function (response) {
                SessionService.lugares = response.data.lugares;
                GlobalHelpers.selectRefresh('select');
            });
        };

        vm.clearCredencial = function () {
            vm.credencial = {
                username: null,
                password: null
            }
        };

        vm.doLogin = function () {
            var msg = '';
            if (!vm.credencial.username) {
                msg += 'Ingrese el usuario. ';
            }
            if (!vm.credencial.password) {
                msg += 'Ingrese la contraseña. ';
            }
            if (msg != '') {
                toastr.warning(msg.trim());
            } else {
                vm.loggingIn = true
                $http.post(ENV_VARS.apiUrl + 'login', vm.credencial).then(function (response) {
                    vm.loggingIn = false
                    if (response.data.status == 'accepted') {
                        SessionService.currentUser = response.data.user;
                        SessionService.initSaldoUser(SessionService.currentUser)
                        SessionService.token = response.data.auth.access_token;
                        vm.redirectCurrentUser();
                    } else {
                        toastr.error('No existe un usuario con esos datos');
                    }
                }).catch(function (err) {
                    vm.loggingIn = false
                    toastr.error('No existe un usuario con esos datos');
                    // console.log(err)
                });
            }
        };

        vm.doSetLugar = function () {
            var msg = '';
            if (!vm.lugar) {
                msg += 'Seleccione el grupo. ';
            }
            if (msg != '') {
                toastr.warning(msg.trim());
            } else {
                SessionService.lugar = vm.lugar;
                // localStorageService.set('lugar', SessionService.lugar);
                vm.redirectCurrentUser();
            }
        };

        vm.logout = function () {
            SessionService.flush();
            localStorageService.clearAll();
            $state.go('login');
        };
    }

})();

(function(){

    angular.module('BlurAdmin.pages.turf')
        .factory('GlobalHelpers', function($timeout, SessionService, $filter) {
            return {
                formatMoney: function (value) {
                    if (value == null || value === '') {
                        return value;
                    }
                    var n = Number(value);
                    if (!isFinite(n)) {
                        return value;
                    }
                    return $filter('number')(Math.round(n), 0);
                },
                findWithAttr: function (array, attr, value) {
                    for (var i = 0; i < array.length; i += 1) {
                        if (array[i][attr] === value) {
                            return i;
                        }
                    }
                    return -1;
                },

                /**
                 * Rango 1..N para la grilla de una carrera. N suele ser el entero `carrera.caballos` (cantidad de caballos).
                 * Tolera string numérico y array (usa array.length) por respuestas API inconsistentes.
                 */
                makeArray: function (n) {
                    var cap;
                    if (n == null || n === '') {
                        return [];
                    }
                    if (typeof n === 'number') {
                        if (!isFinite(n) || isNaN(n)) {
                            return [];
                        }
                        cap = Math.floor(n);
                    } else if (typeof n === 'string') {
                        cap = parseInt(String(n).trim(), 10);
                        if (isNaN(cap)) {
                            return [];
                        }
                    } else if (Array.isArray(n)) {
                        cap = n.length;
                    } else {
                        return [];
                    }
                    if (cap < 1) {
                        return [];
                    }
                    var arr = [];
                    for (var i = 1; i <= cap; i++) {
                        arr.push(i);
                    }
                    return arr;
                },

                selectRefresh: function (selector, time) {
                    $timeout(function(){
                        angular.element(selector).selectpicker('refresh');
                    }, time || 250);
                },

                pushPop: function (array, item) {
                    if (array.indexOf(item) != -1) {
                        array.splice(array.indexOf(item), 1);
                        return false;
                    } else {
                        array.push(item);
                        return true;
                    }
                },

                add: function (a, b) {
                    return a + b;
                },

                // showTo: function (arr) {
                //     if (arr) {
                //         if (arr.indexOf(SessionService.currentUser.tipo) != -1) {
                //             return true;
                //         } else {
                //             return false;
                //         }
                //     }
                // },

                hideFrom: function (attr) {
                    switch (typeof attr) {
                        case 'string':
                            if (attr == SessionService.currentUser.tipo) {
                                return false;
                            } else {
                                return true;
                            }
                            break;
                        case 'object':
                            if (attr.indexOf(SessionService.currentUser.tipo) != -1) {
                                return false;
                            } else {
                                return true;
                            }
                            break;
                    }
                }
            }
        });

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .factory('SessionService', function (TurfSocket, $rootScope) {

            function toSaldo(value) {
                return parseFloat(value) || 0;
            }

            return {
                currentUser: undefined,
                lugar: undefined,
                token: undefined,
                saldosBound: false,
                checkLoginStatus: function () {
                    if (this.currentUser) {
                        if (this.currentUser.tipo == 'superadmin' || this.currentUser.tipo == 'admin' || this.currentUser.tipo == 'empleado') {
                            if (this.lugar) {
                                return true;
                            }
                        } else {
                            return true;
                        }
                    } else {
                        return false;
                    }
                },
                flush: function () {
                    this.currentUser = undefined;
                    this.lugar = undefined;
                    this.token = undefined;
                    this.saldosBound = false;
                },
                applySaldoUpdate: function (payload) {
                    if (!payload || !payload.entity) return;
                    var entity = payload.entity;
                    var id = parseInt(payload.id, 10);
                    var saldo = toSaldo(payload.saldo);

                    if (entity === 'lugar') {
                        if (this.lugar && this.lugar.id === id) this.lugar.saldo = saldo;
                        if (this.lugares) {
                            this.lugares.forEach(function (lugar) {
                                if (lugar.id === id) lugar.saldo = saldo;
                            });
                        }
                        return;
                    }

                    if (entity === 'user') {
                        if (this.currentUser && this.currentUser.id === id) this.currentUser.saldo = saldo;
                        if (this.lugares) {
                            this.lugares.forEach(function (lugar) {
                                (lugar.users || []).forEach(function (user) {
                                    if (user.id === id) user.saldo = saldo;
                                });
                            });
                        }
                        return;
                    }

                    if (entity === 'cliente') {
                        if (this.currentUser && this.currentUser.cliente && this.currentUser.cliente.id === id) {
                            this.currentUser.cliente.saldo = saldo;
                        }
                        if (this.lugares) {
                            this.lugares.forEach(function (lugar) {
                                (lugar.clientes || []).forEach(function (cliente) {
                                    if (cliente.id === id) cliente.saldo = saldo;
                                });
                            });
                        }
                    }
                },
                bindSaldosSocket: function () {
                    var scope = this;
                    if (scope.saldosBound) return;
                    TurfSocket.on("TurfSocket:App\\Events\\SaldoUpdated", function (payload) {
                        $rootScope.$evalAsync(function () {
                            scope.applySaldoUpdate(payload);
                        });
                    });
                    scope.saldosBound = true;
                },
                initSaldoLugar: function (lugar) {
                    if (!lugar) return;
                    lugar.saldo = toSaldo(lugar.saldo);
                },
                initSaldoUser: function (user) {
                    if (!user) return;
                    user.saldo = toSaldo(user.saldo);
                },
                initSaldoCliente: function (cliente) {
                    if (!cliente) return;
                    cliente.saldo = toSaldo(cliente.saldo);
                },
                initSaldos: function () {
                    this.bindSaldosSocket();
                    this.lugaresNoParticulares = [];
                    for (var i = 0; i < this.lugares.length; i++) {
                      if (!this.lugares[i].particular) this.lugaresNoParticulares.push(this.lugares[i]);
                    }
                    this.lugaresParticulares = [];
                    for (var i = 0; i < this.lugares.length; i++) {
                      if (this.lugares[i].particular) this.lugaresParticulares.push(this.lugares[i]);
                    }

                    for(var i = 0; i < this.lugaresParticulares.length; i++) {
                      (function (_i, scope) {
                        scope.initSaldoLugar(scope.lugaresParticulares[_i])
                      })(i, this)

                      for (var j = 0; j < this.lugaresParticulares[i].clientes.length; j++) {
                        (function (_i, _j, scope) {
                          scope.initSaldoCliente(scope.lugaresParticulares[_i].clientes[_j])
                        })(i, j, this)
                      }

                      for (var j = 0; j < this.lugaresParticulares[i].users.length; j++) {
                        (function (_i, _j, scope) {
                          scope.initSaldoUser(scope.lugaresParticulares[_i].users[_j])
                        })(i, j, this)
                      }
                    }
                }
            }

        });
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper) {
    // baConfigProvider.changeTheme({blur: true});

    baConfigProvider.changeColors({
      default: '#4e4e55',
      defaultText: '#e2e2e2',
     // dashboard: {
     //   white: '#ffffff',
     // },
    });
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      // preloader.loadAmCharts(),
      $timeout(1000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      // loadAmCharts : function(){
      //   var d = $q.defer();
      //   AmCharts.ready(function(){
      //     d.resolve();
      //   });
      //   return d.promise;
      // }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.turf')
    .controller('ApuestasController', ApuestasController);

  function ApuestasController ($http, $location, $scope, $timeout, ENV_VARS, GlobalHelpers, SessionService, TurfSocket) {
    var vm = this;

    vm.ready    = false;
    vm.ajax     = false;
    vm.update   = false;
    vm.buscando = false;
    vm.origen   = true;

    vm.agruparCombinaciones = true;
    vm.agruparCarreras      = false;
    vm.agruparUsuarios      = false;
    vm.agruparLugares       = false;
    vm.agruparClientes      = false;
    vm.agruparTipos         = false;

    vm.SessionService = SessionService;
    vm.GlobalHelpers  = GlobalHelpers;

    vm.filtersOpen = false;
    var filtersScrollY = 0;

    function setFiltersPanelOpen (open) {
      var body = angular.element(document.body);
      var html = angular.element(document.documentElement);

      if (open) {
        filtersScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        html.addClass('apuestas-filters-panel-open');
        body.addClass('apuestas-filters-panel-open');
        document.body.style.top = '-' + filtersScrollY + 'px';
        vm.filtersOpen = true;
        return;
      }

      vm.filtersOpen = false;
      html.removeClass('apuestas-filters-panel-open');
      body.removeClass('apuestas-filters-panel-open');
      document.body.style.top = '';
      window.scrollTo(0, filtersScrollY);
    }

    vm.openFiltersPanel = function () {
      setFiltersPanelOpen(true);
    };

    vm.closeFiltersPanel = function () {
      setFiltersPanelOpen(false);
    };

    $scope.$on('$destroy', function () {
      angular.element(document.documentElement).removeClass('apuestas-filters-panel-open');
      angular.element(document.body).removeClass('apuestas-filters-panel-open');
      document.body.style.top = '';
    });

    vm.getFiltersGridStyle = function () {
      var cols = vm.cols[SessionService.currentUser.tipo] + 2;
      return {
        'grid-template-columns': 'repeat(' + cols + ', minmax(72px, 1fr))'
      };
    };

    vm.cols = {
      particular: 4,
      empleado: 5,
      agente: 5,
      admin: 7,
      superadmin: 7
    };

    TurfSocket.removeAllListeners("TurfSocket:App\\Events\\NuevaApuesta");
    TurfSocket.on("TurfSocket:App\\Events\\NuevaApuesta", function (data) {
      if ($location.path() == '/turf/apuestas') {
        console.log('Evento: NuevaApuesta');
        if (vm.update) {
          if (data.carrera.id == vm.carrera.id) {
            updateList();
          }
        }
      }
    });

    getJornadas().then(function () {
      Promise.all([getCarreras(), getUsers(), getLugares(), getClientes(), getTipos()]).then(function () {
        vm.ready = true;
        GlobalHelpers.selectRefresh('select');
        // updateList();
      });
    });

    function getJornadas () {
      return $http.get(ENV_VARS.apiUrl + 'jornada', {
        params: {
          d: 'p'
        }
      }).then(function (response) {
        vm.jornadas = response.data.jornadas;
        vm.jornadaDesde = vm.jornadas[0];
        vm.jornadaHasta = vm.jornadas[0];
        vm.jornada = vm.jornadas[0];

        // if (vm.jornada) {
        //   for (var i = 0; i < vm.jornada.carreras.length; i++) {
        //     if (vm.jornada.carreras[i].abierta) {
        //       vm.carrera = vm.jornada.carreras[i];
        //       break;
        //     } else {
        //       vm.carrera = vm.jornada.carreras[vm.jornada.carreras.length - 1];
        //     }
        //   }
        // }
      });
    }

    function getCarreras () {
      return $http.get(ENV_VARS.apiUrl + 'carrera', {
        params: {
          jid: vm.jornada.id,
          uid: ['empleado', 'particular'].indexOf(SessionService.currentUser.tipo) != -1 ? SessionService.currentUser.id : (vm.user ? vm.user.id : null),
          lid: ['empleado', 'agente'].indexOf(SessionService.currentUser.tipo) != -1 ? SessionService.lugar.id : (vm.lugar ? vm.lugar.id : null),
          cid: vm.cliente ? vm.cliente.id : null,
          tcd: vm.tipo ? vm.tipo.code : null
        }
      }).then(function (response) {
        if (!vm.carrera) {
          vm.carreras = response.data.carreras;
        }
      });
    }

    function getUsers () {
      return $http.get(ENV_VARS.apiUrl + 'user', {
        params: {
          // t: SessionService.currentUser.tipo == 'empleado' ? 'empleado' : 'superadmin-admin-empleado',
          jid: vm.jornada.id,
          rid: vm.carrera ? vm.carrera.id : null,
          lid: ['empleado', 'agente'].indexOf(SessionService.currentUser.tipo) != -1 ? SessionService.lugar.id : (vm.lugar ? vm.lugar.id : null),
          cid: vm.cliente ? vm.cliente.id : null,
          tcd: vm.tipo ? vm.tipo.code : null
        }
      }).then(function (response) {
        if (!vm.user) {
          vm.users = response.data.users;
        }
        // vm.user = SessionService.currentUser.tipo == 'empleado' ? vm.users[GlobalHelpers.findWithAttr(vm.users, 'id', SessionService.currentUser.id)] : undefined;
      });
    }

    function getLugares () {
      return $http.get(ENV_VARS.apiUrl + 'lugar', {
        params: {
          jid: vm.jornada.id,
          rid: vm.carrera ? vm.carrera.id : null,
          uid: ['empleado', 'particular'].indexOf(SessionService.currentUser.tipo) != -1 ? SessionService.currentUser.id : (vm.user ? vm.user.id : null),
          cid: vm.cliente ? vm.cliente.id : null,
          tcd: vm.tipo ? vm.tipo.code : null,
        }
      }).then(function (response) {
        if (!vm.lugar) {
          vm.lugares = response.data.lugares;
        }
        // vm.lugar = SessionService.currentUser.tipo == 'empleado' ? vm.lugares[GlobalHelpers.findWithAttr(vm.lugares, 'id', SessionService.lugar.id)] : undefined;
      });
    }

    function getClientes () {
      return $http.get(ENV_VARS.apiUrl + 'cliente', {
        params: {
          jid: vm.jornada.id,
          rid: vm.carrera ? vm.carrera.id : null,
          uid: ['empleado', 'particular'].indexOf(SessionService.currentUser.tipo) != -1 ? SessionService.currentUser.id : (vm.user ? vm.user.id : null),
          lid: ['empleado', 'agente'].indexOf(SessionService.currentUser.tipo) != -1 ? SessionService.lugar.id : (vm.lugar ? vm.lugar.id : null),
          tcd: vm.tipo ? vm.tipo.code : null,
        }
      }).then(function (response) {
        if (!vm.cliente) {
          vm.clientes = response.data.clientes;
        }
      });
    }

    function getTipos () {
      return $http.get(ENV_VARS.apiUrl + 'tipo', {
        params: {
          jid: vm.jornada.id,
          rid: vm.carrera ? vm.carrera.id : null,
          uid: ['empleado', 'particular'].indexOf(SessionService.currentUser.tipo) != -1 ? SessionService.currentUser.id : (vm.user ? vm.user.id : null),
          lid: ['empleado', 'agente'].indexOf(SessionService.currentUser.tipo) != -1 ? SessionService.lugar.id : (vm.lugar ? vm.lugar.id : null),
          cid: vm.cliente ? vm.cliente.id : null
        }
      }).then(function (response) {
        if (!vm.tipo) {
          vm.tipos = response.data.tipos;
        }
      });
    }

    function updateFilters (reset) {
      if (reset) {
        vm.carrera = undefined;
        vm.user = undefined;
        vm.lugar = undefined;
        vm.cliente = undefined;
        vm.tipo = undefined;
      }
      GlobalHelpers.selectRefresh('select');
      Promise.all([getCarreras(), getUsers(), getLugares(), getClientes(), getTipos()]).then(function () {
        $scope.$apply();
        GlobalHelpers.selectRefresh('select');
      });
    }

    vm.updateFilters = updateFilters;

    function updateList () {
      vm.ajax = true;
      vm.buscando = true;
      $http.get(ENV_VARS.apiUrl + 'combination', {
        params: {
          // jidf: vm.jornadaDesde ? vm.jornadaDesde.id : null,
          // jidt: vm.jornadaHasta ? vm.jornadaHasta.id : null,
          o: vm.origen ? true : null,
          jid: vm.jornada ? vm.jornada.id : null,
          rid: vm.carrera ? vm.carrera.id : null,
          uid: ['empleado'].indexOf(SessionService.currentUser.tipo) != -1 ? SessionService.currentUser.id : (vm.user ? vm.user.id : null),
          lid: ['empleado', 'agente'].indexOf(SessionService.currentUser.tipo) != -1 ? SessionService.lugar.id : (vm.lugar ? vm.lugar.id : null),
          cid: ['particular'].indexOf(SessionService.currentUser.tipo) != -1 ? SessionService.currentUser.cliente_id : (vm.cliente ? vm.cliente.id : null),
          tcd: vm.tipo ? vm.tipo.code : null,
          gr: vm.agruparCarreras ? true : null,
          gu: vm.agruparUsuarios ? true : null,
          gl: vm.agruparLugares ? true : null,
          gc: vm.agruparClientes ? true : null,
          gt: vm.agruparTipos ? true : null,
          // Modo compacto (por defecto): no pedir miles de apuestas por combinación.
          resumen: vm.agruparCombinaciones ? true : false
        }
      }).then(function (response) {
        vm.data = response.data;
        vm.ajax = false;
        vm.buscando = false;
        GlobalHelpers.selectRefresh('select');
      });
    };

    vm.updateList = updateList;

    function combinationClass (combination) {
      return {
        'comb-overtime'     : combination.overtime,
        'comb-after-reopen' : combination.after_reopen,
        'comb-ganadora'     : combination.hasGanadora,
        'comb-deleted'      : combination.deleted_at
      }
    }

    vm.combinationClass = combinationClass;

    function apuestaClass (apuesta) {
      return {
        'apuesta-ganadora' : apuesta.isGanadora
      }
    }

    vm.apuestaClass = apuestaClass;

  }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('CarrerasController', CarrerasController);

    function CarrerasController($http, $scope, $timeout, ENV_VARS, GlobalHelpers, toastr) {
        var vm = this;
        vm.ajax = false;
        vm.ready = false;

        vm.GlobalHelpers = GlobalHelpers;

        getJornada().then(function () {
          Promise.all([getCarreras()]).then(function () {
            vm.ready = true;
            $scope.$apply();
            GlobalHelpers.selectRefresh('select');
          });
        });

        function getJornada () {
          return $http.get(ENV_VARS.apiUrl + 'jornada', {
            params: {
              d: 'f'
            }
          }).then(function (response) {
            vm.jornadas = response.data.jornadas;
            vm.jornada = vm.jornadas[0];
            if (!vm.jornada) {
              vm.ready = true;
              toastr.warning('No hay jornadas para mostrar carreras');
            }
          });
        }

        function getCarreras () {
          if (!vm.jornada || !vm.jornada.id) {
            vm.jornada = vm.jornada || {};
            vm.jornada.carreras = [];
            return Promise.resolve();
          }
          return $http.get(ENV_VARS.apiUrl + 'jornada-carrera', {
            params: {
              jornada_id: vm.jornada.id
            }
          }).then(function (response) {
            vm.jornada.carreras = response.data;
          });
        }

        vm.getCarreras = getCarreras

        function jornadaChange () {
          if (!vm.jornada || !vm.jornada.id) {
            vm.jornada = vm.jornada || {};
            vm.jornada.carreras = [];
            return;
          }
          getCarreras().then(function () {
            GlobalHelpers.selectRefresh('.multiples-select');
          });
        }

        vm.jornadaChange = jornadaChange;

        function guardarCarreras () {
          if (!vm.jornada || !vm.jornada.id) {
            toastr.warning('Seleccioná una jornada primero');
            return;
          }
          vm.ajax = true;
          Promise.all(vm.jornada.carreras.map(function (carrera, index, array) {
            return $http.patch(ENV_VARS.apiUrl + 'carrera/' + carrera.id, carrera);
          })).then(function (response) {
            toastr.success('Cambios guardados correctamente');
            vm.getCarreras().then(function () {
              GlobalHelpers.selectRefresh('.multiples-select');
            })
          }).catch(function (error) {
            console.log(error)
          }).finally(function () {
            vm.ajax = false;
          });
        }

        vm.guardarCarreras = guardarCarreras;

        function trifInput (carrera) {
          carrera.cuat = null;
        }

        vm.trifInput = trifInput;

        function cuatInput (carrera) {
          carrera.trif = null;
        }

        vm.cuatInput = cuatInput;

        function keyListener (e) {
          if (e.keyCode == 38 || e.keyCode == 40) {
            e.preventDefault();
            var focusedId = document.activeElement.id;
            var split = focusedId.split('-');
            angular.element('#' + split[0] + '-' + (e.keyCode == 38 ? (parseInt(split[1]) - 1) : (parseInt(split[1]) + 1)))[0].focus();
          }
          if (e.keyCode == 37 || e.keyCode == 39) {
            e.preventDefault();
            var focusedId = document.activeElement.id;
            var split = focusedId.split('-');
            angular.element('#' + (e.keyCode == 37 ? (parseInt(split[0]) - 1) : (parseInt(split[0]) + 1)) + '-' + split[1])[0].focus();
          }
        }

        vm.keyListener = keyListener;

        function agregarCarrera () {
          if (!vm.jornada || !vm.jornada.id) {
            toastr.warning('Seleccioná una jornada primero');
            return;
          }
          vm.ajax = true;
          $http.post(ENV_VARS.apiUrl + 'carrera', {
            jid: vm.jornada.id
          }).then(function (response) {
            vm.jornada.carreras = response.data.carreras;
            GlobalHelpers.selectRefresh('.multiples-select');
            vm.ajax = false;
          });
        }

        vm.agregarCarrera = agregarCarrera;

    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('CierresController', CierresController);

    function CierresController($http, $timeout, ENV_VARS, GlobalHelpers, toastr) {

        var vm = this;
        vm.ready = false;

        getJornada().then(function () {
          Promise.all([getCarreras()]).then(function () {
            GlobalHelpers.selectRefresh('select');
            vm.ready = true;
          });
        });

        function getJornada () {
          return $http.get(ENV_VARS.apiUrl + 'jornada').then(function (response) {
            vm.jornada = response.data.jornadas[0];
            if (!vm.jornada) {
              toastr.error('No se cargó una jornada para hoy');
            }
          });
        }

        function getCarreras () {
          return $http.get(ENV_VARS.apiUrl + 'carrera', {
            params: {
              jid: vm.jornada.id
            }
          }).then(function (response) {
            vm.jornada.carreras = response.data.carreras;
            for (var i = 0; i < vm.jornada.carreras.length; i++) {
              if (vm.jornada.carreras[i].abierta) {
                vm.selectedCarrera = vm.jornada.carreras[i];
                break;
              } else {
                vm.selectedCarrera = vm.jornada.carreras[vm.jornada.carreras.length - 1];
              }
            }
          });
        }

        vm.carreraStatus = function (carrera) {
          if (vm.selectedCarrera) {
            return {
              'btn-warning' : carrera.cerrando,
              'btn-success' : carrera.abierta,
              'btn-danger'  : !carrera.abierta
            };
          }
        };

        vm.cerrarCarrera = function (carrera) {
            carrera.abierta = false;
            carrera.cerrando = false;
            $http.patch(ENV_VARS.apiUrl + 'carrera/' + carrera.id, carrera).then(function (response) {
                // vm.carreras = response.data.carreras;
                // toastr.success(response.data.msg);
            });
        };

        vm.cerrarCarreraDiferido = function (carrera) {
            carrera.cerrando = true;
            $http.patch(ENV_VARS.apiUrl + 'carrera/' + carrera.id, carrera, {
                params: {
                    closingTime: vm.closingTime
                }
            }).then(function(response) {
                // vm.carreras = response.data.carreras;
                // toastr.success(response.data.msg);
            });
            vm.closingTimer = $timeout(function() {
                carrera.cerrando = false;
                carrera.abierta = false;
                $http.patch(ENV_VARS.apiUrl + 'carrera/' + carrera.id, carrera).then(function(response) {
                    // vm.carreras = response.data.carreras;
                    // toastr.success(response.data.msg);
                });
            }, vm.closingTime);
        };

        vm.abrirCarrera = function (carrera) {
            $timeout.cancel(vm.closingTimer);
            carrera.cerrando = false;
            carrera.abierta = true;
            $http.patch(ENV_VARS.apiUrl + 'carrera/' + carrera.id, carrera).then(function(response) {
                // vm.carreras = response.data.carreras;
                // toastr.success(response.data.msg);
            });
        };
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .filter('money', moneyFilter);

    /** Montos en pesos: separador de miles (locale es-AR) sin decimales. */
    function moneyFilter($filter) {
        return function (value) {
            if (value == null || value === '') {
                return value;
            }
            var n = Number(value);
            if (!isFinite(n)) {
                return value;
            }
            return $filter('number')(Math.round(n), 0);
        };
    }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.turf')
    .controller('GruposController', GruposController);

  function GruposController ($http, $uibModal, ENV_VARS, GlobalHelpers, toastr) {

    var vm = this;
    vm.ajax = false;
    vm.ready = false;

    vm.GlobalHelpers = GlobalHelpers;

    Promise.all([getLugares(), getTarifas(), getIncrementos(), getLimites()]).then(function () {
      vm.ready = true;
      GlobalHelpers.selectRefresh('select');
    });

    function getLugares () {
      return $http.get(ENV_VARS.apiUrl + 'lugar').then(function (response) {
        vm.lugares = response.data.lugares;
      });
    }

    function getTarifas () {
      return $http.get(ENV_VARS.apiUrl + 'tarifa').then(function (response) {
        vm.tarifas = response.data.tarifas;
      });
    }

    function getIncrementos () {
      return $http.get(ENV_VARS.apiUrl + 'incremento').then(function (response) {
        vm.incrementos = response.data.incrementos;
      });
    }

    function getLimites () {
      return $http.get(ENV_VARS.apiUrl + 'limite').then(function (response) {
        vm.limites = response.data.limites;
      });
    }

    function lugarChange () {
      vm.lugar.tarifa = vm.tarifas[vm.lugar.tarifa];
      vm.lugar.incremento = vm.incrementos[vm.lugar.incremento];
      vm.lugar.limite = vm.limites[vm.lugar.limite];
      angular.forEach(vm.lugar.clientes, function (cliente) {
        cliente.tarifaObj = vm.tarifas[cliente.tarifa];
        cliente.incrementoObj = vm.incrementos[cliente.incremento];
        cliente.limiteObj = vm.limites[cliente.limite];
      });
      GlobalHelpers.selectRefresh('select');
    }

    vm.lugarChange = lugarChange;

    function agregarLugar () {
      vm.ajax = true;
      $http.post(ENV_VARS.apiUrl + 'lugar', {
        nombre: vm.nombre,
        particular: vm.particular
      }).then(function (response) {
        vm.nombre = ''
        vm.particular = false
        vm.lugares = response.data.lugares;
        GlobalHelpers.selectRefresh('#lugarSelect');
        vm.ajax = false;
      });
    }

    vm.agregarLugar = agregarLugar;

    function guardarLugar () {
      vm.ajax = true;
      $http.patch(ENV_VARS.apiUrl + 'lugar/' + vm.lugar.id, {
        tarifa: vm.lugar.tarifa,
        incremento: vm.lugar.incremento,
        limite: vm.lugar.limite
      }).then(function (response) {
        vm.ajax = false;
        // vm.lugares = response.data.lugares;
        // GlobalHelpers.selectRefresh('#lugarSelect');
      });
    }

    vm.guardarLugar = guardarLugar;

    function eliminarLugar () {
      if (!vm.lugar || !vm.lugar.id) {
        return;
      }
      if (!window.confirm('¿Eliminar este grupo? Esta acción lo ocultará del sistema.')) {
        return;
      }
      vm.ajax = true;
      $http.delete(ENV_VARS.apiUrl + 'lugar/' + vm.lugar.id).then(function () {
        toastr.success('Grupo eliminado');
        vm.lugar = null;
        return getLugares().then(function () {
          GlobalHelpers.selectRefresh('select');
        });
      }, function (res) {
        if (res.status === 422 && res.data && res.data.message) {
          toastr.error(res.data.message);
        } else if (res.data && res.data.message) {
          toastr.error(res.data.message);
        } else {
          toastr.error('No se pudo eliminar el grupo');
        }
      }).finally(function () {
        vm.ajax = false;
      });
    }

    vm.eliminarLugar = eliminarLugar;

    function addCliente () {
      vm.ajax = true;
      $http.post(ENV_VARS.apiUrl + 'cliente', {
        lugar_id: vm.lugar.id,
        nickname: vm.newCliente
      }).then(function(response) {
        vm.lugar.clientes = response.data.clientes;
        GlobalHelpers.selectRefresh('select');
        vm.ajax = false;
      });
    }

    vm.addCliente = addCliente;

    function guardarCliente (cliente) {
      vm.ajax = true;
      $http.put(ENV_VARS.apiUrl + 'cliente/' + cliente.id, cliente).then(function (response) {
        vm.lugar.clientes = response.data.clientes;
        angular.forEach(vm.lugar.clientes, function (cliente) {
          cliente.tarifaObj = vm.tarifas[cliente.tarifa];
          cliente.incrementoObj = vm.incrementos[cliente.incremento];
          cliente.limiteObj = vm.limites[cliente.limite];
        });
        GlobalHelpers.selectRefresh('select');
        vm.ajax = false;
      });
    }

    vm.guardarCliente = guardarCliente;

    function deleteCliente (cliente) {
      vm.ajax = true;
      $http.delete(ENV_VARS.apiUrl + 'cliente/' + cliente.id).then(function (response) {
        vm.lugar.clientes = response.data.clientes;
        angular.forEach(vm.lugar.clientes, function (cliente) {
          cliente.tarifaObj = vm.tarifas[cliente.tarifa];
          cliente.incrementoObj = vm.incrementos[cliente.incremento];
          cliente.limiteObj = vm.limites[cliente.limite];
        });
        GlobalHelpers.selectRefresh('select');
        vm.ajax = false;
      });
    }

    vm.deleteCliente = deleteCliente;
  }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('HipodromosController', HipodromosController);

    function HipodromosController ($http, ENV_VARS, toastr) {

        var vm = this;
        vm.ajax = false;

        $http.get(ENV_VARS.apiUrl + 'hipodromo').then(function (response) {
            vm.hipodromos = response.data.hipodromos;
        });

        function guardarHipodromos () {
            if (!vm.hipodromos || !vm.hipodromos.length) {
                return;
            }
            vm.ajax = true;
            Promise.all(vm.hipodromos.map(function (hipodromo) {
                return $http.patch(ENV_VARS.apiUrl + 'hipodromo/' + hipodromo.id, hipodromo);
            })).then(function () {
                return $http.get(ENV_VARS.apiUrl + 'hipodromo');
            }).then(function (response) {
                vm.hipodromos = response.data.hipodromos;
                toastr.success('Cambios guardados correctamente');
            }).catch(function () {
                toastr.error('Error al guardar');
            }).finally(function () {
                vm.ajax = false;
            });
        }

        vm.guardarHipodromos = guardarHipodromos;

    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('IncrementosController', IncrementosController);

    function IncrementosController ($http, $uibModal, ENV_VARS, GlobalHelpers, toastr) {

        var vm = this;

        vm.ajax = false;

        vm.GlobalHelpers = GlobalHelpers

        function ensureIntervalosArray (entidad) {
            if (!entidad) {
                return;
            }
            if (!Array.isArray(entidad.intervalos)) {
                entidad.intervalos = [];
            }
        }

        function normalizeIntervalosEnGrupos (grupos) {
            if (!grupos) {
                return;
            }
            angular.forEach(grupos, function (filas) {
                if (angular.isArray(filas)) {
                    angular.forEach(filas, ensureIntervalosArray);
                } else {
                    ensureIntervalosArray(filas);
                }
            });
        }

        $http.get(ENV_VARS.apiUrl + 'incremento').then(function (response) {
            vm.incrementos = response.data.incrementos;
            normalizeIntervalosEnGrupos(vm.incrementos);
            GlobalHelpers.selectRefresh('#incrementoSelect');
        });

        $http.get(ENV_VARS.apiUrl + 'tipo').then(function(response) {
            vm.tipos = response.data.tipos;
        });

        function updateIncrementos (incremento) {
            vm.ajax = true;
            vm.selectedIncremento.forEach(function (incremento, index, array) {
                $http.patch(ENV_VARS.apiUrl + 'incremento/' + incremento.id, incremento).then(function (response) {
                    if (index == array.length - 1) {
                        // vm.incrementos = response.data.incrementos;
                        toastr.success('Incrementos guardados correctamente');
                        vm.ajax = false;
                    }
                });
            });
        }

        vm.updateIncrementos = updateIncrementos;

        function agregarIntervaloModal (incremento) {
            ensureIntervalosArray(incremento);
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/incrementos/modals/agregarIntervalo.html',
                size: 'md',
                controllerAs: 'vm',
                controller: function ($http, $uibModalInstance) {
                    var vm = this;

                    function agregarIntervalo () {
                        ensureIntervalosArray(incremento);
                        incremento.intervalos.push({
                            minimo: vm.minimo,
                            maximo: vm.maximo,
                            factor: vm.factor
                        });
                        $uibModalInstance.close();
                    }

                    vm.agregarIntervalo = agregarIntervalo;
                }
            });
        }

        vm.agregarIntervaloModal = agregarIntervaloModal;

        function editarIntervaloModal (intervalo) {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/incrementos/modals/editarIntervalo.html',
                size: 'md',
                controllerAs: 'vm',
                controller: function ($http, $uibModalInstance) {
                    var vm = this;

                    vm.intervalo = intervalo;

                    function editarIntervalo () {
                        intervalo.minimo = vm.minimo;
                        intervalo.maximo = vm.maximo;
                        intervalo.factor = vm.factor;
                        $uibModalInstance.close();
                    }

                    vm.editarIntervalo = editarIntervalo;
                }
            });
        }

        vm.editarIntervaloModal = editarIntervaloModal;

        function nuevoIncrementoModal () {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/incrementos/modals/nuevoIncremento.html',
                resolve: {
                    parent: function () { return vm }
                },
                size: 'md',
                controllerAs: 'vm',
                controller: function (parent, $http, $uibModalInstance) {
                    var vm = this;

                    function nuevoIncremento () {
                        $http.post(ENV_VARS.apiUrl + 'incremento', {
                            nombre: vm.nombre
                        }).then(function (response) {
                            parent.incrementos = response.data.incrementos;
                            normalizeIntervalosEnGrupos(parent.incrementos);
                            GlobalHelpers.selectRefresh('#incrementoSelect');
                            $uibModalInstance.close();
                        });
                    }

                    vm.nuevoIncremento = nuevoIncremento;
                }
            });
        }

        vm.nuevoIncrementoModal = nuevoIncrementoModal;

        function eliminarIncremento () {
            if (!vm.selectedIncremento || !vm.selectedIncremento.length) {
                toastr.warning('Seleccioná un incremento');
                return;
            }
            var nombre = vm.selectedIncremento[0].nombre;
            if (!window.confirm('¿Eliminar el incremento "' + nombre + '"?')) {
                return;
            }
            vm.ajax = true;
            $http.delete(ENV_VARS.apiUrl + 'incremento-grupo', {
                params: { nombre: nombre, confirm: 0 }
            }).then(function (res) {
                if (res.data.needs_confirm) {
                    $uibModal.open({
                        animation: true,
                        backdrop: 'static',
                        templateUrl: 'app/pages/turf/modals/eliminarConfigGrupo.html',
                        size: 'md',
                        controllerAs: 'vm',
                        resolve: {
                            referencias: function () {
                                return res.data.referencias;
                            },
                            nombre: function () {
                                return nombre;
                            },
                            parent: function () {
                                return vm;
                            }
                        },
                        controller: ['$http', '$uibModalInstance', 'ENV_VARS', 'referencias', 'nombre', 'parent', 'GlobalHelpers', 'toastr',
                            function ($http, $uibModalInstance, ENV_VARS, referencias, nombre, parent, GlobalHelpers, toastr) {
                                var m = this;
                                m.nombre = nombre;
                                m.referencias = referencias;
                                m.ajax = false;
                                m.ejecutar = function () {
                                    m.ajax = true;
                                    $http.delete(ENV_VARS.apiUrl + 'incremento-grupo', {
                                        params: { nombre: nombre, confirm: 1 }
                                    }).then(function (r2) {
                                        parent.incrementos = r2.data.incrementos;
                                        normalizeIntervalosEnGrupos(parent.incrementos);
                                        parent.selectedIncremento = null;
                                        toastr.success('Incremento eliminado');
                                        GlobalHelpers.selectRefresh('#incrementoSelect');
                                        $uibModalInstance.close();
                                    }, function () {
                                        toastr.error('No se pudo eliminar el incremento');
                                    }).finally(function () {
                                        m.ajax = false;
                                    });
                                };
                            }]
                    });
                    return;
                }
                if (res.data.success) {
                    vm.incrementos = res.data.incrementos;
                    normalizeIntervalosEnGrupos(vm.incrementos);
                    vm.selectedIncremento = null;
                    toastr.success('Incremento eliminado');
                    GlobalHelpers.selectRefresh('#incrementoSelect');
                }
            }, function (res) {
                if (res.status === 404) {
                    toastr.error('Incremento no encontrado');
                } else if (res.data && res.data.error === 'nombre_vacio') {
                    toastr.error('Nombre inválido');
                } else {
                    toastr.error('No se pudo eliminar el incremento');
                }
            }).finally(function () {
                vm.ajax = false;
            });
        }

        vm.eliminarIncremento = eliminarIncremento;

        vm.keyListener = function (e) {
            if (e.keyCode == 38 || e.keyCode == 40) {
                e.preventDefault();
                var focusedId = document.activeElement.id;
                var split = focusedId.split('-');
                angular.element('#' + split[0] + '-' + (e.keyCode == 38 ? (parseInt(split[1]) - 1) : (parseInt(split[1]) + 1)))[0].focus();
            }
            if (e.keyCode == 37 || e.keyCode == 39) {
                e.preventDefault();
                var focusedId = document.activeElement.id;
                var split = focusedId.split('-');
                angular.element('#' + (e.keyCode == 37 ? (parseInt(split[0]) - 1) : (parseInt(split[0]) + 1)) + '-' + split[1])[0].focus();
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('JornadasController', JornadasController);

    function JornadasController($http, $state, $timeout, ENV_VARS, GlobalHelpers, toastr) {

        var vm = this;

        vm.jornada = {};
        vm.ajax = false;
        vm.ready = false;

        var ahora = new Date();
        vm.jornada.fecha = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate());

        $http.get(ENV_VARS.apiUrl + 'hipodromo').then(function(response) {
            vm.hipodromos = response.data.hipodromos;
            GlobalHelpers.selectRefresh('#jornadaSelect');
            vm.ready = true;
        });

        vm.sendJornada = function() {
            var msg = '';
            if (!vm.jornada.hipodromo) {
                msg += 'Debe seleccionar un hipódromo. ';
            }
            if (!vm.jornada.carreras) {
                msg += 'Debe ingresar la cantidad de carreras. ';
            }
            if (msg != '') {
                toastr.warning(msg.trim());
            } else {
                vm.ajax = true;
                var payload = angular.copy(vm.jornada);
                // Evita corrimientos por TZ: mandar fecha "YYYY-MM-DD" en hora local.
                if (payload.fecha instanceof Date && !isNaN(payload.fecha.getTime())) {
                    payload.fecha = payload.fecha.getFullYear() + '-' +
                        String(payload.fecha.getMonth() + 1).padStart(2, '0') + '-' +
                        String(payload.fecha.getDate()).padStart(2, '0');
                }

                $http.post(ENV_VARS.apiUrl + 'jornada', payload).then(function(response) {
                    if (response.data.status == 'ok') {
                        toastr.success(response.data.msg);
                        $state.go('turf.carreras');
                    } else {
                        toastr.error(response.data.msg);
                    }
                }).catch(function (error) {
                    console.log(error)
                }).finally(function () {
                    vm.ajax = false;
                });
            }
        };

    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('JugarController', JugarController);

    function JugarController ($http, $location, $scope, $state, $timeout, $uibModal, ENV_VARS, GlobalHelpers, localStorageService, SessionService, toastr, TurfSocket) {

        String.prototype.endsWith = function (suffix) {
            return this.indexOf(suffix, this.length - suffix.length) !== -1;
        };

        // eventos
        function onCarreraCerrada (data) {
            if ($location.path() == '/turf/jugar') {
                console.log('Evento: CarreraCerrada');
                var index = GlobalHelpers.findWithAttr(vm.jornada.carreras, 'id', data.carrera.id)
                var carrera = vm.jornada.carreras[index];
                carrera.abierta = false;
                carrera.cerrando = false;
                if (index + 1 <= vm.jornada.carreras.length && vm.selectedCarrera.orden == data.carrera.orden) {
                    vm.selectedCarrera = vm.jornada.carreras[index + 1];
                }
                GlobalHelpers.selectRefresh('.carreraSelect');
                vm.paso = 1;
                carreraCerrada(carrera);
                $state.go('turf.apuestas');
            }
        }

        function onCarreraAbierta (data) {
            if ($location.path() == '/turf/jugar') {
                console.log('Evento: CarreraAbierta');
                var index = GlobalHelpers.findWithAttr(vm.jornada.carreras, 'id', data.carrera.id)
                var carrera = vm.jornada.carreras[index];
                carrera.abierta = true;
                vm.selectedCarrera = vm.jornada.carreras[index];
                GlobalHelpers.selectRefresh('.carreraSelect');
                carreraAbierta(carrera);
            }
        }

        function onCarreraCerrando (data) {
            if ($location.path() == '/turf/jugar') {
                console.log('Evento: CarreraCerrando');
                var index = GlobalHelpers.findWithAttr(vm.jornada.carreras, 'id', data.carrera.id)
                var carrera = vm.jornada.carreras[index];
                carrera.cerrando = true;
                carreraCerrando(carrera, data.closingTime);
            }
        }

        function onCarreraUpdate (data) {
            if ($location.path() == '/turf/jugar') {
                console.log('Evento: CarreraUpdate');
                var carrera = vm.jornada.carreras[GlobalHelpers.findWithAttr(vm.jornada.carreras, 'id', data.carrera.id)];
                carrera.caballos = data.carrera.caballos;
                carrera.gan = data.carrera.gan;
                carrera.seg = data.carrera.seg;
                carrera.ter = data.carrera.ter;
                carrera.exa = data.carrera.exa;
                carrera.imp = data.carrera.imp;
                carrera.trif = data.carrera.trif;
                carrera.cuat = data.carrera.cuat;
                carrera.dob = data.carrera.dob;
                carrera.tlo = data.carrera.tlo;
                carrera.cna = data.carrera.cna;
                carrera.pck5 = data.carrera.pck5;
                carrera.pck6 = data.carrera.pck6;
                carrera.tle = data.carrera.tle;
            }
        }

        function onRetiradosUpdate (data) {
            if ($location.path() == '/turf/jugar') {
                console.log('Evento: RetiradosUpdate');
                var carrera = vm.jornada.carreras[GlobalHelpers.findWithAttr(vm.jornada.carreras, 'id', data.carrera.id)];
                carrera.retirados = data.carrera.retirados;
            }
        }

        TurfSocket.removeAllListeners("TurfSocket:App\\Events\\CarreraCerrada");
        TurfSocket.removeAllListeners("TurfSocket:App\\Events\\CarreraAbierta");
        TurfSocket.removeAllListeners("TurfSocket:App\\Events\\CarreraCerrando");
        TurfSocket.removeAllListeners("TurfSocket:App\\Events\\CarreraUpdate");
        TurfSocket.removeAllListeners("TurfSocket:App\\Events\\RetiradosUpdate");
        TurfSocket.on("TurfSocket:App\\Events\\CarreraCerrada", onCarreraCerrada);
        TurfSocket.on("TurfSocket:App\\Events\\CarreraAbierta", onCarreraAbierta);
        TurfSocket.on("TurfSocket:App\\Events\\CarreraCerrando", onCarreraCerrando);
        TurfSocket.on("TurfSocket:App\\Events\\CarreraUpdate", onCarreraUpdate);
        TurfSocket.on("TurfSocket:App\\Events\\RetiradosUpdate", onRetiradosUpdate);
        // fin eventos

        // init
        var vm = this;
        vm.ready = false;

        vm.GlobalHelpers = GlobalHelpers;
        vm.SessionService = SessionService;

        getJornada().then(function (response) {
          vm.jornada = response.data.jornadas[0];
          if (!vm.jornada) {
            toastr.error('No se cargó una jornada para hoy');
          } else {
            Promise.all([getCarreras(), getTipos()]).then(function () {
              vm.ready = true;
              GlobalHelpers.selectRefresh('select');
            });
          }
        });

        // if (SessionService.lugar) {
        //   getClientes();
        // }

        vm.apuestas = [];
        vm.total = { combinations: 0, pagar: 0 };
        vm.nextIsAbierta = true;
        vm.nextIsCerrando = false;
        initJugada();
        // fin init

        function getJornada () {
          return $http.get(ENV_VARS.apiUrl + 'jornada')
        }

        function getCarreras () {
          return $http.get(ENV_VARS.apiUrl + 'carrera', {
            params: {
              jid: vm.jornada.id,
              auid: SessionService.currentUser.id,
              alid: SessionService.lugar ? SessionService.lugar.id : (SessionService.currentUser.tipo == 'particular' ? SessionService.currentUser.cliente.lugar_id : null)
            }
          }).then(function (response) {
            vm.jornada.carreras = response.data.carreras;
            for (var i = 0; i < vm.jornada.carreras.length; i++) {
              if (vm.jornada.carreras[i].abierta) {
                vm.selectedCarrera = vm.jornada.carreras[i];
                break;
              } else {
                vm.selectedCarrera = vm.jornada.carreras[vm.jornada.carreras.length - 1];
              }
            }

            vm.updateCarreras();
            vm.getActiveApuestas();
          });
        }

        function getTipos () {
          return $http.get(ENV_VARS.apiUrl + 'tipo').then(function (response) {
            vm.tipos = response.data.tipos;
            vm.tipos[GlobalHelpers.findWithAttr(vm.tipos, 'code', 'tle')].carreras = 1;
          });
        }

        function getClientes () {
          return $http.get(ENV_VARS.apiUrl + 'cliente', {
            params: {
              lid: SessionService.lugar.id
            }
          }).then(function (response) {
            SessionService.lugar.clientes = response.data.clientes;
          });
        }

        function getActiveApuestas (success, error) {
          if (SessionService.currentUser.tipo != 'particular') {
            if (vm.selectedCliente) {
              $http.get(ENV_VARS.apiUrl + 'combination', {
                params: {
                  cid: SessionService.currentUser.tipo != 'particular' ? vm.selectedCliente.id : SessionService.currentUser.cliente_id,
                  rid: vm.selectedCarrera.id,
                  resumen: true
                }
              }).then(function(response) {
                vm.combinations = response.data.combinations;
                vm.total = response.data.total;
              });
            } else {
              vm.combinations = [];
              vm.total = { combinations: 0, pagar: 0 };
            }
          } else {
            $http.get(ENV_VARS.apiUrl + 'combination', {
              params: {
                uid: SessionService.currentUser.id,
                rid: vm.selectedCarrera.id,
                resumen: true
              }
            }).then(function (response) {
              vm.combinations = response.data.combinations;
              vm.total = response.data.total;
            });
          }
          // updateApuHeight();
        }

        vm.getActiveApuestas = getActiveApuestas;

        function updateCarreras () {
          var from = vm.jornada.carreras.indexOf(vm.selectedCarrera);
          var carreras = vm.selectedTipos.length > 0 ? vm.selectedTipos[0].carreras : 1;
          vm.carrerasParaJugar = vm.jornada.carreras.slice(from, from + carreras);
        }

        vm.updateCarreras = updateCarreras;

        // function updateApuHeight () {
        //     if (angular.element('.bet-apuestas').offset().top != '0') {
        //         vm.apuHeight = 591 - angular.element('.bet-apuestas').offset().top;
        //     } else {
        //         vm.apuHeight = 314;
        //     }
        // }

        var PUESTO_LABELS = ['1º', '2º', '3º', '4º'];

        function selectionLegCount () {
          if (!vm.selectedTipos.length) {
            return 1;
          }
          var t = vm.selectedTipos[0];
          if (t.carreras > 1) {
            return t.carreras;
          }
          if (t.caballos > 1) {
            return t.caballos;
          }
          return 1;
        }

        vm.selectionLegCount = selectionLegCount;

        vm.carreraIndexForLeg = function (leg) {
          return vm.selectedTipos.length && vm.selectedTipos[0].carreras > 1 ? leg : 0;
        };

        vm.puestoLabel = function (leg) {
          return PUESTO_LABELS[leg] || ((leg + 1) + 'º');
        };

        function resetSelectedCaballos () {
          var n = selectionLegCount();
          vm.selectedCaballos = [];
          for (var i = 0; i < n; i++) {
            vm.selectedCaballos[i] = [];
          }
        }

        vm.resetSelectedCaballos = resetSelectedCaballos;

        function flattenCartesianRows (arr) {
          arr.forEach(function (item, index) {
            arr[index] = item.reduce(function (a, b) {
              return a.concat(b);
            }, []);
          });
          return arr;
        }

        function cartesianFromPiernas (piernas) {
          var arr;
          switch (piernas.length) {
            case 1:
              arr = Combinatorics.cartesianProduct(piernas[0]).toArray();
              break;
            case 2:
              arr = Combinatorics.cartesianProduct(piernas[0], piernas[1]).toArray();
              break;
            case 3:
              arr = Combinatorics.cartesianProduct(piernas[0], piernas[1], piernas[2]).toArray();
              break;
            case 4:
              arr = Combinatorics.cartesianProduct(piernas[0], piernas[1], piernas[2], piernas[3]).toArray();
              break;
            case 5:
              arr = Combinatorics.cartesianProduct(piernas[0], piernas[1], piernas[2], piernas[3], piernas[4]).toArray();
              break;
            case 6:
              arr = Combinatorics.cartesianProduct(piernas[0], piernas[1], piernas[2], piernas[3], piernas[4], piernas[5]).toArray();
              break;
            default:
              return [];
          }
          return flattenCartesianRows(arr);
        }

        function filterDuplicateHorsesInJugada (jugadas) {
          return jugadas.filter(function (caballos) {
            var flag = true;
            caballos.forEach(function (caballo, index, self) {
              for (var i = 0; i < self.length; i++) {
                if (i !== index && angular.equals(caballo, self[i])) {
                  flag = false;
                }
              }
            });
            return flag;
          });
        }

        function dedupeImperfectaJugadas (jugadas) {
          var finalSorted = [];
          for (var i = 0; i < jugadas.length; i++) {
            finalSorted[i] = jugadas[i].slice().sort(function (a, b) { return a - b; });
          }
          return finalSorted.filter(function (elem, index, arr) {
            for (var j = 0; j < arr.length; j++) {
              if (j > index && angular.equals(arr[j], arr[index])) {
                return false;
              }
            }
            return true;
          });
        }

        function buildJugadasFromPiernas (piernas, options) {
          options = options || {};
          if (!piernas.length || !piernas.every(function (leg) { return leg && leg.length > 0; })) {
            return null;
          }
          var arr = cartesianFromPiernas(piernas);
          if (options.filterDuplicateHorses) {
            arr = filterDuplicateHorsesInJugada(arr);
          }
          if (options.imperfecta) {
            arr = dedupeImperfectaJugadas(arr);
          }
          return arr;
        }

        function piernasFromSelection () {
          var piernas = [];
          var legCount = selectionLegCount();
          for (var l = 0; l < legCount; l++) {
            piernas.push(vm.selectedCaballos[l] || []);
          }
          return piernas;
        }

        function updateVale () {
          vm.vale = [];
          vm.selectedTipos.forEach(function (tipo, index) {
            if (tipo.jugadas && tipo.jugadas.length > 0) {
              vm.vale[index] = tipo.jugadas.length * vm.selectedCarrera[tipo.code];
            }
          });
        }

        // vm.updateVale = updateVale;

        function initJugada () {
          vm.inputtedCaballos = [];
          vm.selectedCaballos = [];
          vm.selectedTipos = [];
          vm.tiposForImporte = [];
          vm.caballosForTriple = [];
          vm.selectedTriple = undefined;
          vm.inputtedImporte = '';
          vm.validBet = false;
          vm.vale = [];
          vm.deuda = false;
          if (vm.tipos) {
            vm.tipos.forEach(function (tipo) {
              delete tipo.importe;
              delete tipo.jugadas;
            });
          }
        }

        // vm.initJugada = initJugada;

        // vm.getAvailableCarreras = function (callback) {
        //     JugarHelpers.getCarreras(function (response) {
        //         if (SessionService.currentUser.tipo == 'superadmin' || SessionService.currentUser.tipo == 'admin') {
        //             vm.jornada.availableCarreras = vm.jornada.carreras;
        //         } else {
        //             vm.jornada.availableCarreras = response.data.carreras;
        //         }
        //         vm.selectedCarrera = vm.jornada.availableCarreras[GlobalHelpers.findWithAttr(vm.jornada.availableCarreras, 'id', response.data.carreras[0].id)];
        //         GlobalHelpers.selectRefresh('#carreraSelect');
        //         GlobalHelpers.selectRefresh('#clienteSelect');
        //         vm.updateCarreras();
        //         vm.getActiveApuestas();
        //         if (!vm.ready) {
        //             vm.ready = true;
        //         }
        //     }, function () {}, {
        //         uid: SessionService.currentUser.id,
        //         lid: SessionService.lugar ? SessionService.lugar.id : null
        //     });
        // };

        function carreraFilter (carrera) {
          if (SessionService.currentUser.tipo == 'empleado' || SessionService.currentUser.tipo == 'particular') {
            return carrera.abierta;
          }
          return true;
        }

        vm.carreraFilter = carreraFilter;

        vm.paso = 1;

        function prevPaso () {
            switch (vm.paso) {
                case 2:
                    vm.paso = 1;
                    break;
                case 3:
                    vm.paso = 2;
                    break;
            }
        }

        vm.prevPaso = prevPaso;

        function nextPaso () {
            switch (vm.paso) {
                case 1:
                    vm.paso = 2;
                    break;
                case 2:
                    vm.paso = 3;
                    break;
            }
        }

        vm.nextPaso = nextPaso;

        // triples.html
        vm.setTriple = function (triple) {
          vm.selectedTipos = [];
          vm.tiposForImporte = [];

          if (vm.selectedTriple == triple) {
            vm.selectedTriple = undefined;
            vm.selectedCliente = undefined;
          } else {
            vm.selectedTipos.push(vm.tipos[GlobalHelpers.findWithAttr(vm.tipos, 'code', 'tle')]);
            vm.tiposForImporte.push(vm.tipos[GlobalHelpers.findWithAttr(vm.tipos, 'code', 'tle')]);
            vm.selectedTipos[0].vales = [];

            vm.selectedTriple = triple;
            vm.selectedCliente = SessionService.lugar.clientes[GlobalHelpers.findWithAttr(SessionService.lugar.clientes, 'id', parseInt(triple.cliente_id))];
          }

          GlobalHelpers.selectRefresh('#clienteSelect');

          vm.jugadaMaker();
          vm.getActiveApuestas();

          vm.paso = vm.selectedTipos.length > 0 ? 2 : 1;
        };

        vm.tripleClass = function (triple) {
          if (vm.selectedTriple == triple) { return 'btn-success' }
          else { return 'btn-default' }
        };

        // cliente.html
        vm.clienteIsFav = function () {
          return function (item) {
            if (vm.clientesFavoritos.indexOf(item.id) != -1) {
              return true;
            }
            return false;
          };
        };

        function clienteChange () {
          vm.selectedTriple = undefined;
          vm.getActiveApuestas();
        }

        vm.clienteChange = clienteChange;

        vm.clientesFavoritos = localStorageService.get('clientesFavoritos') || [];

        // recientes.html
        vm.setCliente = function (cliente) {
          vm.selectedTriple = undefined;
          vm.selectedTipos = [];
          vm.tiposForImporte = [];
          vm.selectedCliente = SessionService.lugar.clientes[GlobalHelpers.findWithAttr(SessionService.lugar.clientes, 'id', cliente.id)];
          GlobalHelpers.selectRefresh('#clienteSelect');
          vm.clienteChange();
        };

        // vm.toggleDeudor = function (cliente) {
        //     var cliente = SessionService.lugar.clientes[GlobalHelpers.findWithAttr(SessionService.lugar.clientes, 'id', cliente.id)];
        //     cliente.deudor = cliente.deudor || false;
        //     cliente.deudor = !cliente.deudor;
        // };

        // vm.isDeudor = function (cliente) {
        //     var cliente = SessionService.lugar.clientes[GlobalHelpers.findWithAttr(SessionService.lugar.clientes, 'id', cliente.id)];
        //     if (cliente.deudor) {
        //         return 'btn-warning';
        //     }
        // };

        // carrera.html
        vm.carreraChange = function () {
          // if (vm.selectedCliente) {
            vm.getActiveApuestas();
          // }
          vm.updateCarreras();
          resetSelectedCaballos();
          vm.selectedTriple = [];
        };

        // preview.html
        vm.enviarClass = function () {
          if (vm.nextIsCerrando) { return 'btn-warning' }
          if (!vm.nextIsAbierta) { return 'btn-danger' }
          if (vm.nextIsAbierta) { return 'btn-primary' }
        };

        // importe.html
        vm.importesRapidos = [
          { monto: 1000, label: '1.000' },
          { monto: 2000, label: '2.000' },
          { monto: 5000, label: '5.000' },
          { monto: 10000, label: '10.000' }
        ];

        vm.caballosListos = function () {
          return vm.validBet && vm.selectedTipos.length > 0;
        };

        vm.addImporteRapido = function (monto) {
          vm.tiposForImporte.forEach(function (tipo) {
            tipo.importe = tipo.importe ? parseFloat(tipo.importe) : 0;
            tipo.importe += monto;
          });
        };

        vm.btnCalculadora = function (num) {
          if (!(!vm.inputtedImporte && num == 0)) {
            vm.inputtedImporte += num;
          }

          if (vm.selectedTriple) {
            vm.caballosForTriple.forEach(function (caballo, index) {
              vm.selectedTipos[0].importe[index] = vm.inputtedImporte;
            });
          } else {
            vm.tiposForImporte.forEach(function (tipo) {
              tipo.importe = vm.inputtedImporte;
            });
          }
          // updateApuHeight();
        };

        vm.addVale = function (multiplier) {
          vm.tiposForImporte.forEach(function (tipo, index) {
            tipo.importe = tipo.importe ? parseFloat(tipo.importe) : 0;
            tipo.importe += multiplier * vm.vale[index];
          });
          // updateApuHeight();
        };

        vm.addValeTriple = function (multiplier, distribute) {
          if (vm.selectedTriple) {
            if (vm.selectedTriple.availableVales >= multiplier) {
              // var vale = vm.selectedCarrera.valorTriple;
              if (vm.caballosForTriple.length > 0) {
                vm.caballosForTriple.forEach(function (caballo, index) {
                  // var index = vm.selectedTipos[0].jugadas.indexOf(caballo);
                  vm.selectedTipos[0].vales[index] = vm.selectedTipos[0].vales[index] ? parseFloat(vm.selectedTipos[0].vales[index]) : 0;
                  vm.selectedTipos[0].vales[index] += distribute ? multiplier / vm.caballosForTriple.length : multiplier;
                });
              } else {
                vm.selectedTipos[0].vales[0] = vm.selectedTipos[0].vales[0] ? parseFloat(vm.selectedTipos[0].vales[0]) : 0;
                vm.selectedTipos[0].vales[0] += multiplier;
              }
              vm.selectedTriple.availableVales -= multiplier;
            }
          } else {
            vm.selectedTipos[0].importe = vm.selectedTipos[0].importe ? parseFloat(vm.selectedTipos[0].importe) : 0;
            vm.selectedTipos[0].importe += multiplier * vm.selectedCarrera.eng;
          }
          // updateApuHeight();
        };

        vm.btnClear = function () {
          vm.inputtedImporte = '';

          vm.tiposForImporte.forEach(function (tipo) {
            if (vm.selectedTriple) {
              // var vale = vm.selectedCarrera.valorTriple;
              vm.caballosForTriple.forEach(function (caballo) {
                var index = vm.selectedTipos[0].jugadas.indexOf(caballo);
                vm.selectedTriple.availableVales += tipo.vales[index];
              });
              tipo.vales = [];
            } else {
              tipo.importe = vm.inputtedImporte;
            }
          });
          // updateApuHeight();
        };

        vm.btnDelete = function () {
          vm.inputtedImporte = vm.inputtedImporte.toString().slice(0, -1);

          if (vm.inputtedImporte.length == 0) {
            vm.inputtedImporte = '';
          }

          vm.tiposForImporte.forEach(function (tipo) {
            tipo.importe = vm.inputtedImporte;
          });
          // updateApuHeight();
        };

        vm.setTipoForImporte = function (tipo) {
          vm.inputtedImporte = '';
          vm.tiposForImporte = [];
          GlobalHelpers.pushPop(vm.tiposForImporte, tipo);
          vm.tiposForImporte.forEach(function (tipo) {
            tipo.importe = '';
          });
        };

        vm.tipoForImporteClass = function (tipo) {
          if (vm.tiposForImporte.indexOf(tipo) != -1) { return 'btn-success' }
          else { return 'btn-default' }
        };

        vm.setCaballoForTriple = function (caballo) {
          vm.inputtedImporte = '';
          vm.caballosForTriple = [];
          GlobalHelpers.pushPop(vm.caballosForTriple, caballo);
          vm.caballosForTriple.forEach(function (caballo, index) {
            vm.selectedTipos[0].importe[index] = '';
          });
        };

        vm.caballoForTripleClass = function (caballo) {
          if (vm.caballosForTriple.indexOf(caballo) != -1) { return 'btn-success' }
          else { return 'btn-default' }
        };

        // tipo.html
        var TIPOS_SIN_AUTO_AVANCE = ['gan', 'seg', 'ter'];

        function updatePasoAfterTipoSelect () {
          if (!vm.selectedTipos.length) {
            vm.paso = 1;
            return;
          }

          var soloGanSegTer = vm.selectedTipos.every(function (selectedTipo) {
            return TIPOS_SIN_AUTO_AVANCE.indexOf(selectedTipo.code) !== -1;
          });

          if (!soloGanSegTer) {
            vm.paso = 2;
          }
        }

        vm.toggleTipo = function (tipo) {
          if ((vm.selectedTipos.length > 0 &&
            (tipo.caballos != vm.selectedTipos[0].caballos ||
            tipo.carreras != vm.selectedTipos[0].carreras ||
            tipo.normal != vm.selectedTipos[0].normal)
          ) || vm.selectedTriple) {
            vm.selectedTipos = [];
            vm.tiposForImporte = [];
          }

          vm.selectedTriple = undefined;
          GlobalHelpers.pushPop(vm.selectedTipos, tipo);
          GlobalHelpers.pushPop(vm.tiposForImporte, tipo);

          if (vm.selectedTipos.length === 0) {
            vm.selectedCaballos = [];
          } else {
            var neededLegs = selectionLegCount();
            if (vm.selectedCaballos.length !== neededLegs) {
              resetSelectedCaballos();
              if (vm.selectedTipos[0].carreras === 1 && vm.selectedTipos[0].caballos === 1) {
                vm.selectedCaballos[0] = vm.inputtedCaballos.slice();
              }
            }
          }

          vm.selectedTipos.forEach(function (tipo) {
            tipo.importe = vm.inputtedImporte ? vm.inputtedImporte : '';
          });

          vm.updateCarreras();
          vm.jugadaMaker();
          updateVale();
          // updateApuHeight();

          // Mobile: auto-avanzar a caballos salvo GAN/SEG/TER (el usuario toca SIGUIENTE).
          updatePasoAfterTipoSelect();
        };

        vm.tipoClass = function (tipo) {
          var selected = vm.selectedTipos.indexOf(tipo) !== -1 && !vm.selectedTriple;
          var isPick = tipo.code === 'pck5' || tipo.code === 'pck6';
          return {
            'btn-success': selected,
            'bet-tipo-pick': !selected && isPick
          };
        };

        vm.tipoDisponible = function (tipo) {
          if (!vm.selectedCarrera || !vm.selectedCarrera[tipo.code]) {
            return false;
          }
          if (!vm.SessionService.currentUser.cliente || !vm.SessionService.currentUser.cliente.limite) {
            return true;
          }

          var limite = vm.SessionService.currentUser.cliente.limite[tipo.code];
          return !limite || limite.maximo !== '0';
        };

        // vm.redoblonaClass = function () {
        //     return vm.redoblona ? 'btn-success' : 'btn-default';
        // };

        // vm.redoblona = false;
        // vm.toggleRedoblona = function () {
        //     vm.redoblona = !vm.redoblona;
        // };

        // caballos.html
        vm.clickCaballo = function (leg, i) {
          var tipo = vm.selectedTipos[0];
          if (!tipo) {
            return;
          }

          if (tipo.carreras === 1 && tipo.caballos === 1) {
            GlobalHelpers.pushPop(vm.inputtedCaballos, i);
            vm.selectedCaballos[0] = vm.inputtedCaballos;
            vm.caballosForTriple = vm.selectedCaballos[0];
          } else {
            vm.selectedCaballos[leg] = vm.selectedCaballos[leg] || [];
            GlobalHelpers.pushPop(vm.selectedCaballos[leg], i);
          }

          vm.jugadaMaker();
          updateVale();
        };

        vm.caballoClass = function (leg, i) {
          var c = vm.carreraIndexForLeg(leg);
          if (vm.carrerasParaJugar[c].retirados.indexOf(i) != -1) { return 'btn-danger'; }
          if ((vm.selectedCaballos[leg] || []).indexOf(i) != -1) { return 'btn-success'; }
        };

        vm.caballoDisabled = function (leg, i) {
          var c = vm.carreraIndexForLeg(leg);
          if (vm.carrerasParaJugar[c].retirados.indexOf(i) != -1) { return true; }
        };

        vm.caballosClear = function () {
          resetSelectedCaballos();
          vm.inputtedCaballos = [];
          vm.jugadaMaker();
          updateVale();
        };

        vm.jugadaMaker = function () {
            if (vm.selectedTipos.length > 0) {
                if (vm.selectedTipos[0].normal == true) {
                    if (vm.selectedTipos[0].carreras === 1 && vm.selectedTipos[0].caballos > 1) { // exa imp trif cuat
                        var piernasExa = piernasFromSelection();
                        var finalExa = buildJugadasFromPiernas(piernasExa, { filterDuplicateHorses: true });
                        if (finalExa) {
                            vm.selectedTipos.forEach(function (tipo) {
                                tipo.jugadas = buildJugadasFromPiernas(piernasExa, {
                                    filterDuplicateHorses: true,
                                    imperfecta: tipo.code === 'imp'
                                });
                            });
                            vm.validBet = true;
                            updateVale();
                        } else {
                            vm.validBet = false;
                            vm.selectedTipos.forEach(function (tipo) {
                                tipo.jugadas = [];
                            });
                            updateVale();
                        }
                    }

                    if (vm.selectedTipos[0].carreras > 1) { // dob tlo cna pck
                        var piernasMulti = piernasFromSelection();
                        var finalMulti = buildJugadasFromPiernas(piernasMulti, {});
                        if (finalMulti) {
                            vm.selectedTipos[0].jugadas = finalMulti;
                            vm.validBet = true;
                            updateVale();
                        } else {
                            vm.selectedTipos[0].jugadas = [];
                            vm.validBet = false;
                            updateVale();
                        }
                    }

                    if (vm.selectedTipos[0].carreras == 1 && vm.selectedTipos[0].caballos == 1) { // gan seg ter
                        vm.selectedTipos.forEach(function (tipo) {
                            if (vm.selectedCaballos[0].length > 0) {
                                tipo.jugadas = [];
                                vm.selectedCaballos[0].forEach(function (caballo) {
                                    tipo.jugadas.push([caballo]);
                                });
                                vm.validBet = true;
                            } else {
                                vm.validBet = false;
                            }
                        });
                    }
                } else {
                    if (vm.selectedTipos[0].code == 'tle' || 'eng') {
                        if (vm.selectedCaballos[0] && vm.selectedCaballos[0].length > 0) {
                            vm.selectedTipos[0].jugadas = [];
                            vm.selectedCaballos[0].forEach(function (caballo) {
                                vm.selectedTipos[0].jugadas.push([caballo]);
                            });
                            vm.validBet = true;
                        } else {
                            vm.validBet = false;
                        }
                    }
                }
            } else {
                vm.validBet = false
            }
        };

        vm.combinationString = function () {
            var caballos = '',
            tipos = '',
            importes = '';

            function formatImporte(value) {
                if (value === '' || value == null) {
                    return '';
                }
                return GlobalHelpers.formatMoney(value);
            }

            if (vm.selectedTipos.length && (vm.selectedTipos[0].caballos > 1 || vm.selectedTipos[0].carreras > 1)) {
                var legCount = selectionLegCount();
                for (var idx = 0; idx < legCount; idx++) {
                    if (vm.selectedCaballos[idx] && vm.selectedCaballos[idx].length) {
                        caballos += vm.selectedCaballos[idx].join('.');
                        if (idx < legCount - 1) {
                            caballos += ' // ';
                        }
                    }
                }
            } else if (vm.selectedCaballos[0] && vm.selectedCaballos[0].length) {
                caballos = vm.selectedCaballos[0].join('.');
            }

            if (vm.selectedTipos) {
                vm.selectedTipos.forEach(function (tipo, index, selectedTipos) {
                    tipos += tipo.code.toUpperCase();
                    if (index != selectedTipos.length - 1) {
                        tipos += '.';
                    }
                });
            }

            if (vm.selectedTipos.length == 0) {
                importes = '$ ' + formatImporte(vm.inputtedImporte);
            } else {
                if (vm.selectedTriple) {
                    // var vale = vm.selectedCarrera.valorTriple;
                    if (vm.selectedTipos[0].vales.length > 0) {
                        vm.selectedTipos[0].vales.forEach(function (vale, index, vales) {
                            importes += vale;
                            if (index != vales.length - 1) {
                                importes += '.';
                            }
                        });
                        importes += (importes == 1 ? ' VALE' : ' VALES');
                    }
                } else {
                    importes += '$ ';
                    vm.selectedTipos.forEach(function (tipo, index, selectedTipos) {
                        importes += formatImporte(tipo.importe);
                        if (index != selectedTipos.length - 1) {
                            importes += '.';
                        }
                    });
                }
            }

            return (caballos + ' ' + tipos + ' ' + importes).trim();
        };

        // apuestas.html
        var TIPOS_IMPORTE_REPARTIDO = ['exa', 'imp', 'trif', 'cuat', 'dob', 'tlo', 'cna', 'pck5', 'pck6'];
        var TIPOS_IMPORTE_POR_JUGADA = ['gan', 'seg', 'ter', 'tle', 'eng'];

        function importeRepartidoEntreJugadas (code) {
          return TIPOS_IMPORTE_REPARTIDO.indexOf(code) !== -1;
        }

        function formatJugadaCaballosPreview (jugada) {
          return jugada.join(', ');
        }

        function countApuestasEnEnvio () {
          var total = 0;
          vm.selectedTipos.forEach(function (tipo) {
            if (tipo.jugadas && tipo.jugadas.length > 0) {
              total += tipo.jugadas.length;
            }
          });
          return total;
        }

        function envioEsCombinado () {
          return countApuestasEnEnvio() > 1;
        }

        function buildCombinacionPreview () {
          var apuestas = [];
          var total = 0;

          vm.selectedTipos.forEach(function (tipo) {
            if (!tipo.jugadas || tipo.jugadas.length === 0) {
              return;
            }

            var importeTipo = parseFloat(tipo.importe) || 0;
            var reparte = importeRepartidoEntreJugadas(tipo.code);
            var importePorApuesta = reparte
              ? importeTipo / tipo.jugadas.length
              : importeTipo;

            if (reparte) {
              total += importeTipo;
            } else {
              total += importeTipo * tipo.jugadas.length;
            }

            tipo.jugadas.forEach(function (jugada) {
              apuestas.push({
                caballos: formatJugadaCaballosPreview(jugada),
                tipo: tipo.code.toUpperCase(),
                importe: importePorApuesta
              });
            });
          });

          return {
            total: total,
            totalApuestas: countApuestasEnEnvio(),
            apuestas: apuestas
          };
        }

        function buildApuestaPayload () {
          var payloadTipos = vm.selectedTipos.map(function (tipo) {
            if (['pck5', 'pck6'].indexOf(tipo.code) !== -1 &&
                vm.selectedCaballos &&
                vm.selectedCaballos.length === tipo.carreras) {
              var light = angular.copy(tipo);
              light.piernas = vm.selectedCaballos.map(function (leg) {
                return leg.slice();
              });
              delete light.jugadas;
              return light;
            }
            return tipo;
          });

          var apuesta = {
            rid: vm.selectedCarrera.id,
            uid: SessionService.currentUser.id,
            cid: SessionService.currentUser.tipo != 'particular' ? vm.selectedCliente.id : SessionService.currentUser.cliente_id,
            tipos: payloadTipos,
            string: vm.combinationString(),
            triple_id: vm.selectedTriple ? vm.selectedTriple.triple_id : null
          };

          var total = 0;
          apuesta.tipos.forEach(function (tipo) {
            if (TIPOS_IMPORTE_POR_JUGADA.indexOf(tipo.code) !== -1) {
              tipo.jugadas.forEach(function () {
                total += parseInt(tipo.importe, 10);
              });
            }
            if (TIPOS_IMPORTE_REPARTIDO.indexOf(tipo.code) !== -1) {
              total += parseInt(tipo.importe, 10);
            }
          });

          apuesta.total = total;
          return { apuesta: apuesta, total: total };
        }

        vm.sendingApuesta = false;

        function postCombination (apuesta) {
          $http.post(ENV_VARS.apiUrl + 'combination', apuesta, {
            headers: {
              'Authorization': 'Bearer ' + SessionService.token
            }
          }).then(function (response) {
            if (response.data.status == 'ok') {
              vm.selectedCarrera.clientes = response.data.clientes;
              vm.updateCarreras();
              initJugada();
              vm.getActiveApuestas();
              vm.sendingApuesta = false;
              vm.paso = 1;
            } else {
              vm.sendingApuesta = false;
              switch (response.data.error) {
                case 'carrera_cerrada':
                  carreraCerrada(response.data.carrera);
                  getCarreras();
                  break;
                case 'fuera_de_limite':
                  toastr.error('El importe de la apuesta está fuera del límite permitido');
                  break;
                case 'saldo_insuficiente':
                  toastr.error('El saldo es insuficiente para hacer esta jugada');
                  break;
              }
            }
          }).catch(function (err) {
            vm.sendingApuesta = false;
            if (err.status == 401) {
              toastr.error('Sesión expirada, vuelva a ingresar');
              SessionService.flush();
              $timeout(function () {
                $state.go('login');
              }, 0);
            }
          });
        }

        vm.postCombination = postCombination;

        function openConfirmCombinadaModal (preview, apuesta) {
          var modalInstance = $uibModal.open({
            animation: true,
            backdrop: 'static',
            windowClass: 'confirm-combinada-window',
            templateUrl: 'app/pages/turf/jugar/modals/confirmCombinada.html',
            resolve: {
              parent: function () { return vm; },
              preview: function () { return preview; },
              apuesta: function () { return apuesta; }
            },
            size: 'sm',
            controllerAs: 'vm',
            controller: function ($uibModalInstance, parent, preview, apuesta) {
              var modalVm = this;
              modalVm.preview = preview;
              modalVm.parent = parent;
              modalVm.confirm = function () {
                $uibModalInstance.close();
                parent.sendingApuesta = true;
                postCombination(apuesta);
              };
              modalVm.cancel = function () {
                $uibModalInstance.dismiss('cancel');
              };
            }
          });

          modalInstance.result.then(angular.noop, function () {
            vm.sendingApuesta = false;
          });
        }

        function addCombination () {
            if (vm.sendingApuesta) {
                return;
            }

            var msg = '';
            if (!vm.validBet) {
                msg += 'La jugada no es válida.';
            }
            if (vm.selectedTipos.length == 0) {
                msg += 'Debe seleccionar un tipo de apuesta. ';
            } else {
                vm.selectedTipos.forEach(function (tipo) {
                    if (!tipo.importe && !tipo.vales) {
                        msg += 'Falta ingresar el importe de ' + tipo.code.toUpperCase() + '. ';
                    }

                    if (!tipo.jugadas || tipo.jugadas.length == 0) {
                        msg += 'Debe elegir los caballos. ';
                    }
                });
            }
            if (!vm.selectedCliente && SessionService.currentUser.tipo == 'empleado') {
                msg += 'Debe seleccionar un cliente. ';
            }

            if (msg != '') {
                vm.sendingApuesta = false;
                toastr.warning(msg.trim());
                return;
            }

            var built = buildApuestaPayload();
            var apuesta = built.apuesta;
            var total = built.total;

            var cliente;
            if (SessionService.currentUser.tipo == 'particular') {
              cliente = SessionService.currentUser.cliente;
            } else if (SessionService.lugar.particular && vm.selectedCliente) {
              cliente = vm.selectedCliente;
            }
            if (cliente) {
              if (cliente.saldo - total < cliente.descubierto) {
                toastr.error('El saldo es insuficiente para hacer esta jugada');
                vm.sendingApuesta = false;
                return;
              }
            }

            if (envioEsCombinado()) {
              openConfirmCombinadaModal(buildCombinacionPreview(), apuesta);
              return;
            }

            vm.sendingApuesta = true;
            postCombination(apuesta);
        }

        vm.addCombination = addCombination;

        function combinationClass (combination) {
          return {
            'deleted-combination' : combination.deleted_at
          }
        }

        vm.combinationClass = combinationClass;

        // modales
        vm.openClientesModal = function () {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/jugar/modals/clientes.html',
                resolve: {
                    parent: function () { return vm }
                },
                size: 'md',
                controllerAs: 'vm',
                controller: function ($http, $uibModalInstance, parent, GlobalHelpers, SessionService) {
                    var vm = this;

                    vm.GlobalHelpers = GlobalHelpers;
                    vm.SessionService = SessionService;
                    vm.parent = parent;

                    vm.clienteClass = function (cliente) {
                        if (parent.clientesFavoritos.indexOf(cliente.id) != -1) { return 'btn-success' }
                    }

                    vm.toggleFav = function (cliente) {
                        if (GlobalHelpers.pushPop(parent.clientesFavoritos, cliente.id)) {
                            parent.selectedCliente = SessionService.lugar.clientes[GlobalHelpers.findWithAttr(SessionService.lugar.clientes, 'id', cliente.id)];
                            parent.getActiveApuestas();
                        }
                        localStorageService.set('clientesFavoritos', parent.clientesFavoritos);
                        GlobalHelpers.selectRefresh('#clienteSelect');
                    }
                }
            });
        };

        vm.clienteNuevo = function () {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/jugar/modals/clienteNuevo.html',
                resolve: {
                    parent: function () { return vm }
                },
                size: 'md',
                controllerAs: 'vm',
                controller: function ($http, $uibModalInstance, parent) {
                    var vm = this;

                    vm.sendClienteNuevo = function () {
                        $http.post(ENV_VARS.apiUrl + 'cliente', {
                            nickname: vm.nickname,
                            lugar_id: parent.SessionService.lugar.id
                        }).then(function (response) {
                            $uibModalInstance.close();
                            parent.SessionService.lugar.clientes = response.data.clientes;
                            parent.selectedCliente = parent.SessionService.lugar.clientes[parent.GlobalHelpers.findWithAttr(parent.SessionService.lugar.clientes, 'id', response.data.cliente.id)];
                            parent.clientesFavoritos.push(response.data.cliente.id);
                            parent.GlobalHelpers.selectRefresh('#clienteSelect');
                        });
                    }
                }
            });
        };

        vm.deleteApuesta = function (comb) {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/jugar/modals/deleteApuesta.html',
                size: 'md',
                resolve: {
                    parent: function () { return vm }
                },
                controllerAs: 'vm',
                controller: function ($http, $uibModalInstance, parent) {
                    var vm = this;

                    vm.comb = comb;
                    vm.deleting = false

                    vm.confirmDelete = function(comb) {
                        vm.deleting = true
                        $http.delete(ENV_VARS.apiUrl + 'combination/' + comb.id, {
                            params: {
                                uid: SessionService.currentUser.id
                            }
                        }).then(function (response) {
                            if (response.data.status == 'ok') {
                                $uibModalInstance.close();
                                parent.getActiveApuestas();
                                parent.selectedCarrera.clientes = response.data.clientes;
                            } else {
                                $uibModalInstance.close();
                                toastr.error(response.data.msg);
                            }
                        }).finally(function () {
                          vm.deleting = false
                        });
                    }
                }
            });
        };

        function carreraCerrada (carrera) {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/jugar/modals/carreraCerrada.html',
                size: 'md',
                controllerAs: 'vm',
                controller: function () {
                    var vm = this;
                    vm.carrera = carrera;
                }
            });
        }

        function carreraAbierta (carrera) {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/jugar/modals/carreraAbierta.html',
                size: 'md',
                controllerAs: 'vm',
                controller: function () {
                    var vm = this;
                    vm.carrera = carrera;
                }
            });
        }

        function carreraCerrando (carrera, closingTime) {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/jugar/modals/carreraCerrando.html',
                size: 'md',
                controllerAs: 'vm',
                controller: function () {
                    var vm = this;
                    vm.carrera = carrera;
                    vm.closingTime = closingTime;
                }
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('LimitesController', LimitesController);

    function LimitesController ($http, $uibModal, ENV_VARS, GlobalHelpers, toastr) {

        var vm = this;

        vm.ajax = false;

        vm.GlobalHelpers = GlobalHelpers;

        function ensureIntervalosArray (entidad) {
            if (!entidad) {
                return;
            }
            if (!Array.isArray(entidad.intervalos)) {
                entidad.intervalos = [];
            }
        }

        function normalizeIntervalosEnGrupos (grupos) {
            if (!grupos) {
                return;
            }
            angular.forEach(grupos, function (filas) {
                if (angular.isArray(filas)) {
                    angular.forEach(filas, ensureIntervalosArray);
                } else {
                    ensureIntervalosArray(filas);
                }
            });
        }

        $http.get(ENV_VARS.apiUrl + 'limite').then(function (response) {
            vm.limites = response.data.limites;
            normalizeIntervalosEnGrupos(vm.limites);
            GlobalHelpers.selectRefresh('#limiteSelect');
        });

        $http.get(ENV_VARS.apiUrl + 'tipo').then(function (response) {
            vm.tipos = response.data.tipos;
        });

        function updateLimites (limite) {
            vm.ajax = true;
            vm.selectedLimite.forEach(function (limite, index, array) {
                $http.patch(ENV_VARS.apiUrl + 'limite/' + limite.id, limite).then(function (response) {
                    if (index == array.length - 1) {
                        // vm.limites = response.data.limites;
                        toastr.success('Límites guardadas correctamente');
                        vm.ajax = false;
                    }
                });
            });
        }

        vm.updateLimites = updateLimites;

        function agregarIntervaloModal (limite) {
            ensureIntervalosArray(limite);
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/limites/modals/agregarIntervalo.html',
                size: 'md',
                controllerAs: 'vm',
                controller: function ($http, $uibModalInstance) {
                    var vm = this;

                    function agregarIntervalo () {
                        ensureIntervalosArray(limite);
                        limite.intervalos.push({
                            minimo: vm.minimo,
                            maximo: vm.maximo
                            // valor: vm.valor
                        });
                        $uibModalInstance.close();
                    }

                    vm.agregarIntervalo = agregarIntervalo;
                }
            });
        }

        vm.agregarIntervaloModal = agregarIntervaloModal;

        function editarIntervaloModal (intervalo) {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/limites/modals/editarIntervalo.html',
                size: 'md',
                controllerAs: 'vm',
                controller: function ($http, $uibModalInstance) {
                    var vm = this;

                    vm.intervalo = intervalo;

                    function editarIntervalo () {
                        intervalo.minimo = vm.minimo;
                        intervalo.maximo = vm.maximo;
                        // intervalo.valor = vm.valor;
                        $uibModalInstance.close();
                    }

                    vm.editarIntervalo = editarIntervalo;
                }
            });
        }

        vm.editarIntervaloModal = editarIntervaloModal;

        function nuevoLimiteModal () {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/limites/modals/nuevoLimite.html',
                resolve: {
                    parent: function () { return vm }
                },
                size: 'md',
                controllerAs: 'vm',
                controller: function (parent, $http, $uibModalInstance) {
                    var vm = this;

                    function nuevoLimite () {
                        $http.post(ENV_VARS.apiUrl + 'limite', {
                            nombre: vm.nombre
                        }).then(function (response) {
                            parent.limites = response.data.limites;
                            normalizeIntervalosEnGrupos(parent.limites);
                            GlobalHelpers.selectRefresh('#limiteSelect');
                            $uibModalInstance.close();
                        });
                    }

                    vm.nuevoLimite = nuevoLimite;
                }
            });
        }

        vm.nuevoLimiteModal = nuevoLimiteModal;

        function eliminarLimite () {
            if (!vm.selectedLimite || !vm.selectedLimite.length) {
                toastr.warning('Seleccioná un límite');
                return;
            }
            var nombre = vm.selectedLimite[0].nombre;
            if (!window.confirm('¿Eliminar el límite "' + nombre + '"?')) {
                return;
            }
            vm.ajax = true;
            $http.delete(ENV_VARS.apiUrl + 'limite-grupo', {
                params: { nombre: nombre, confirm: 0 }
            }).then(function (res) {
                if (res.data.needs_confirm) {
                    $uibModal.open({
                        animation: true,
                        backdrop: 'static',
                        templateUrl: 'app/pages/turf/modals/eliminarConfigGrupo.html',
                        size: 'md',
                        controllerAs: 'vm',
                        resolve: {
                            referencias: function () {
                                return res.data.referencias;
                            },
                            nombre: function () {
                                return nombre;
                            },
                            parent: function () {
                                return vm;
                            }
                        },
                        controller: ['$http', '$uibModalInstance', 'ENV_VARS', 'referencias', 'nombre', 'parent', 'GlobalHelpers', 'toastr',
                            function ($http, $uibModalInstance, ENV_VARS, referencias, nombre, parent, GlobalHelpers, toastr) {
                                var m = this;
                                m.nombre = nombre;
                                m.referencias = referencias;
                                m.ajax = false;
                                m.ejecutar = function () {
                                    m.ajax = true;
                                    $http.delete(ENV_VARS.apiUrl + 'limite-grupo', {
                                        params: { nombre: nombre, confirm: 1 }
                                    }).then(function (r2) {
                                        parent.limites = r2.data.limites;
                                        normalizeIntervalosEnGrupos(parent.limites);
                                        parent.selectedLimite = null;
                                        toastr.success('Límite eliminado');
                                        GlobalHelpers.selectRefresh('#limiteSelect');
                                        $uibModalInstance.close();
                                    }, function () {
                                        toastr.error('No se pudo eliminar el límite');
                                    }).finally(function () {
                                        m.ajax = false;
                                    });
                                };
                            }]
                    });
                    return;
                }
                if (res.data.success) {
                    vm.limites = res.data.limites;
                    normalizeIntervalosEnGrupos(vm.limites);
                    vm.selectedLimite = null;
                    toastr.success('Límite eliminado');
                    GlobalHelpers.selectRefresh('#limiteSelect');
                }
            }, function (res) {
                if (res.status === 404) {
                    toastr.error('Límite no encontrado');
                } else if (res.data && res.data.error === 'nombre_vacio') {
                    toastr.error('Nombre inválido');
                } else {
                    toastr.error('No se pudo eliminar el límite');
                }
            }).finally(function () {
                vm.ajax = false;
            });
        }

        vm.eliminarLimite = eliminarLimite;

        vm.keyListener = function (e) {
            if (e.keyCode == 38 || e.keyCode == 40) {
                e.preventDefault();
                var focusedId = document.activeElement.id;
                var split = focusedId.split('-');
                angular.element('#' + split[0] + '-' + (e.keyCode == 38 ? (parseInt(split[1]) - 1) : (parseInt(split[1]) + 1)))[0].focus();
            }
            if (e.keyCode == 37 || e.keyCode == 39) {
                e.preventDefault();
                var focusedId = document.activeElement.id;
                var split = focusedId.split('-');
                angular.element('#' + (e.keyCode == 37 ? (parseInt(split[0]) - 1) : (parseInt(split[0]) + 1)) + '-' + split[1])[0].focus();
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('LiquidacionController', LiquidacionController);

    function LiquidacionController ($http, ENV_VARS, GlobalHelpers, SessionService) {

        var vm = this;
        vm.ready = false;
        vm.readyCount = 0;
        vm.ajax = false;

        vm.GlobalHelpers = GlobalHelpers;

        function readyMaker () {
            vm.readyCount++;
            if (vm.readyCount == 4) {
                vm.ready = true;
            }
        }

        function getJornada (success) {
            $http.get(ENV_VARS.apiUrl + 'jornada', {
                params: {
                    to: 'pasado'
                }
            }).then(success);
        }

        getJornada(function (response) {
            vm.jornadas = response.data.jornadas;
            vm.jornadaDesde = vm.jornadas[0];
            vm.jornadaHasta = vm.jornadas[0];
            vm.jornada = vm.jornadas[0];
            GlobalHelpers.selectRefresh('#jornadaDesdeSelect');
            GlobalHelpers.selectRefresh('#jornadaHastaSelect');
            if (vm.jornada) {
                for (var i = 0; i < vm.jornada.carreras.length; i++) {
                    if (vm.jornada.carreras[i].abierta) {
                        vm.carrera = vm.jornada.carreras[i];
                        break;
                    } else {
                        vm.carrera = vm.jornada.carreras[vm.jornada.carreras.length - 1];
                    }
                }
            }
            GlobalHelpers.selectRefresh('#carreraSelect');
            readyMaker();
        });

        $http.get(ENV_VARS.apiUrl + 'user', {
            params: {
                t: SessionService.currentUser.tipo == 'empleado' ? 'empleado' : 'superadmin-admin-empleado'
            }
        }).then(function (response) {
            vm.users = response.data.users;
            vm.user = SessionService.currentUser.tipo == 'empleado' ? vm.users[GlobalHelpers.findWithAttr(vm.users, 'id', SessionService.currentUser.id)] : undefined;
            GlobalHelpers.selectRefresh('#userSelect');
            readyMaker();
        });

        $http.get(ENV_VARS.apiUrl + 'lugar').then(function (response) {
            vm.lugares = response.data.lugares;
            vm.lugar = SessionService.currentUser.tipo == 'empleado' ? vm.lugares[GlobalHelpers.findWithAttr(vm.lugares, 'id', SessionService.lugar.id)] : undefined;
            GlobalHelpers.selectRefresh('#lugarSelect');
            readyMaker();
        });

        $http.get(ENV_VARS.apiUrl + 'cliente').then(function (response) {
            vm.clientes = response.data.clientes;
            GlobalHelpers.selectRefresh('#clienteSelect');
            readyMaker();
        });

        function getAciertos () {
            vm.ajax = true;
            $http.get(ENV_VARS.apiUrl + 'apuesta', {
                params: {
                    jidf: vm.jornadaDesde ? vm.jornadaDesde.id : null,
                    jidt: vm.jornadaHasta ? vm.jornadaHasta.id : null,
                    rid: vm.carrera ? vm.carrera.id : null,
                    uid: vm.user ? vm.user.id : null,
                    lid: vm.lugar ? vm.lugar.id : null,
                    cid: vm.cliente ? vm.cliente.id : null,
                    w: true
                }
            }).then(function (response) {
                vm.grupos = response.data.grupos;
                vm.gruposArray = [];
                angular.forEach(vm.grupos, function (value, key) {
                    vm.gruposArray.push(value);
                });
                vm.total = 0;
                vm.gruposArray.forEach(function (grupo) {
                    grupo.forEach(function (apuesta) {
                        vm.total += apuesta.aPagar;
                    });
                });
                vm.ajax = false;
            });
        }

        vm.getAciertos = getAciertos;

        function getTotal (grupo) {
            return grupo.reduce(function (acc, obj) {
                return acc + obj.aPagar;
            }, 0);

        }

        vm.getTotal = getTotal;

        vm.formatJugadaDetalle = function (apuesta) {
            var detalle = apuesta.caballos.join('.') + ' ' + apuesta.tipo_code;
            if (apuesta.vales) {
                detalle += ' ' + apuesta.vales + ' VALES';
            } else {
                detalle += ' $ ' + GlobalHelpers.formatMoney(apuesta.importe);
            }
            return detalle.toUpperCase();
        };

        vm.filterChange = function (campo) {
            vm.grupos = undefined;
            vm.gruposArray = undefined;
            vm.total = 0;
            GlobalHelpers.selectRefresh('select');
            switch (campo) {
                case 'jornada':
                    if (vm.jornadaDesde == vm.jornadaHasta) {
                        vm.jornada = vm.jornadaDesde;
                    } else {
                        vm.jornada = undefined;
                    }
                    GlobalHelpers.selectRefresh('#carreraSelect');
                    break;
                case 'carrera':
                    $http.get(ENV_VARS.apiUrl + 'user', {
                        params: {
                            rid: vm.carrera ? vm.carrera.id : null
                        }
                    }).then(function (response) {
                        vm.users = response.data.users;
                        GlobalHelpers.selectRefresh('#userSelect');
                    });
                    $http.get(ENV_VARS.apiUrl + 'lugar', {
                        params: {
                            rid: vm.carrera ? vm.carrera.id : null
                        }
                    }).then(function (response) {
                        vm.lugares = response.data.lugares;
                        GlobalHelpers.selectRefresh('#lugarSelect');
                    });
                    $http.get(ENV_VARS.apiUrl + 'cliente', {
                        params: {
                            rid: vm.carrera ? vm.carrera.id : null
                        }
                    }).then(function (response) {
                        vm.clientes = response.data.clientes;
                        GlobalHelpers.selectRefresh('#clienteSelect');
                    });
                    break;
                case 'user':
                    $http.get(ENV_VARS.apiUrl + 'lugar', {
                        params: {
                            rid: vm.carrera ? vm.carrera.id : null,
                            uid: vm.user ? vm.user.id : null
                        }
                    }).then(function (response) {
                        vm.lugares = response.data.lugares;
                        GlobalHelpers.selectRefresh('#lugarSelect');
                    });
                    $http.get(ENV_VARS.apiUrl + 'cliente', {
                        params: {
                            rid: vm.carrera ? vm.carrera.id : null,
                            uid: vm.user ? vm.user.id : null
                        }
                    }).then(function (response) {
                        vm.clientes = response.data.clientes;
                        GlobalHelpers.selectRefresh('#clienteSelect');
                    });
                    break;
                case 'lugar':
                    $http.get(ENV_VARS.apiUrl + 'cliente', {
                        params: {
                            rid: vm.carrera ? vm.carrera.id : null,
                            uid: vm.user ? vm.user.id : null,
                            lid: vm.lugar ? vm.lugar.id : null
                        }
                    }).then(function (response) {
                        vm.clientes = response.data.clientes;
                    });
                    break;
                case 'cliente':
                    break;
            }
        };

    }

})();

(function () {
  'use strict'

  angular.module('BlurAdmin.pages.turf')
    .controller('MovimientosController', MovimientosController);

  function MovimientosController ($http, $location, $scope, $timeout, ENV_VARS, GlobalHelpers, SessionService, TurfSocket) {
    var vm = this

    vm.ready = false
    vm.ajax  = false

    vm.SessionService = SessionService
    vm.GlobalHelpers  = GlobalHelpers

    vm.agruparAdmin = false
    vm.agruparAgente = false
    vm.agruparParticular = false

    getJornadas().then(function () {
      Promise.all([getAdmins(), getAgentes(), getParticulares()]).then(function () {
        vm.ready = true
        GlobalHelpers.selectRefresh('select')
      })
    });

    function getJornadas () {
      return $http.get(ENV_VARS.apiUrl + 'jornada', {
        params: {
          d: 'p'
        }
      }).then(function (response) {
        vm.jornadas = response.data.jornadas
        vm.jornada = vm.jornadas[0]
      })
    }

    function getAdmins () {
      return $http.get(ENV_VARS.apiUrl + 'user', {
        params: {
          t: 'superadmin-admin'
        }
      }).then(function (response) {
        vm.admins = response.data.users
      })
    }

    function getAgentes () {
      return $http.get(ENV_VARS.apiUrl + 'user', {
        params: {
          t: 'agente'
        }
      }).then(function (response) {
        vm.agentes = response.data.users
      })
    }

    function getParticulares () {
      return $http.get(ENV_VARS.apiUrl + 'user', {
        params: {
          t: 'particular'
        }
      }).then(function (response) {
        vm.particulares = response.data.users
      })
    }

    function updateList () {
      vm.ajax = true
      $http.get(ENV_VARS.apiUrl + 'movimiento', {
        params: {
          d: vm.jornada ? vm.jornada.fecha : null,
          uid: vm.admin ? vm.admin.id : null,
          aid: vm.agente ? vm.agente.id : null,
          cid: vm.particular ? vm.particular.cliente_id : null,
          t: vm.selectedTiposMovimientos ? vm.selectedTiposMovimientos.join('-') : null,
          ga: vm.agruparAdmin,
          gg: vm.agruparAgente,
          gp: vm.agruparParticular
        }
      }).then(function (response) {
        vm.movimientos = response.data.movimientos
      }).finally(function () {
        vm.ajax = false
      })
    }

    vm.updateList = updateList;

    vm.tiposMovimientos = [ 'recarga', 'retira', 'jugada', 'acierto', 'elimina', 'corrección', 'establecer' ]

    vm.selectedTiposMovimientos = [ vm.tiposMovimientos[0], vm.tiposMovimientos[1] ]

    vm.reset = function () {
      vm.movimientos = null
    }

  }

})();

(function () {
  'use strict'

  angular.module('BlurAdmin.pages.turf')
    .controller('NetwinController', NetwinController);

  function NetwinController ($http, ENV_VARS, GlobalHelpers, toastr) {
    var vm = this

    vm.ready = false
    vm.ajax = false
    vm.reporte = null
    vm.consulta = null

    vm.tipos = []
    vm.grupos = []
    vm.usuarios = []
    vm.clientes = []
    vm.hipodromos = []
    vm.agrupar = {
      tipo: false,
      grupo: false,
      usuario: false,
      cliente: false,
      hipodromo: false
    }
    vm.etiquetas = {
      grupo: 'GRUPO',
      usuario: 'USUARIO',
      cliente: 'CLIENTE',
      hipodromo: 'HIPÓDROMO',
      tipo: 'TIPO'
    }

    vm.desde = new Date()
    vm.hasta = new Date()

    vm.buscar = buscar
    vm.descargar = descargar
    vm.monto = monto

    cargarFiltros()

    function cargarFiltros () {
      $http.get(ENV_VARS.apiUrl + 'reporte-netwin/filtros').then(function (response) {
        vm.catalogoTipos = response.data.tipos
        vm.catalogoGrupos = response.data.grupos
        vm.catalogoUsuarios = response.data.usuarios
        vm.catalogoClientes = response.data.clientes
        vm.catalogoHipodromos = response.data.hipodromos
        vm.ready = true
        GlobalHelpers.selectRefresh('select')
      }, function (response) {
        toastr.error((response.data && response.data.mensaje) || 'No se pudieron cargar los filtros')
      })
    }

    function buscar () {
      if (!vm.desde || !vm.hasta) {
        toastr.error('Indicá un rango de fechas')
        return
      }
      var params = armarParams()
      vm.ajax = true
      $http.get(ENV_VARS.apiUrl + 'reporte-netwin', {
        params: params
      }).then(function (response) {
        vm.consulta = params
        vm.reporte = response.data
      }, function (response) {
        toastr.error((response.data && response.data.mensaje) || 'No se pudo armar el reporte')
      }).finally(function () {
        vm.ajax = false
      })
    }

    function descargar (format) {
      if (!vm.consulta) {
        return
      }
      var params = angular.extend({}, vm.consulta, { format: format })
      vm.ajax = true
      $http.get(ENV_VARS.apiUrl + 'reporte-netwin', {
        params: params,
        responseType: 'blob'
      }).then(function (response) {
        var blob = new Blob([response.data], { type: response.headers('content-type') })
        var url = URL.createObjectURL(blob)
        var link = document.createElement('a')
        link.href = url
        link.download = 'netwin-' + vm.consulta.desde + '-' + vm.consulta.hasta + (format === 'pdf' ? '.pdf' : '.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      }, function () {
        toastr.error('No se pudo descargar el reporte')
      }).finally(function () {
        vm.ajax = false
      })
    }

    function armarParams () {
      var agrupar = []
      if (vm.agrupar.grupo) agrupar.push('grupo')
      if (vm.agrupar.usuario) agrupar.push('usuario')
      if (vm.agrupar.cliente) agrupar.push('cliente')
      if (vm.agrupar.hipodromo) agrupar.push('hipodromo')
      if (vm.agrupar.tipo) agrupar.push('tipo')

      return {
        desde: fechaParam(vm.desde),
        hasta: fechaParam(vm.hasta),
        tipos: (vm.tipos || []).join(','),
        grupos: (vm.grupos || []).join(','),
        usuarios: (vm.usuarios || []).join(','),
        clientes: (vm.clientes || []).join(','),
        hipodromos: (vm.hipodromos || []).join(','),
        agrupar: agrupar.join(',')
      }
    }

    function monto (value) {
      if (value == null) {
        return '—'
      }
      return '$ ' + GlobalHelpers.formatMoney(value)
    }

    function fechaParam (value) {
      var d = value instanceof Date ? value : new Date(value)
      if (!value || isNaN(d.getTime())) {
        return null
      }
      var m = ('0' + (d.getMonth() + 1)).slice(-2)
      var day = ('0' + d.getDate()).slice(-2)
      return d.getFullYear() + '-' + m + '-' + day
    }
  }
})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('ResultadosController', ResultadosController);

    function ResultadosController($http, $state, ENV_VARS, GlobalHelpers, HIPODROMO, toastr, $uibModal, $timeout, SessionService) {

        var vm = this;
        vm.ready = false;
        vm.ajax = false;
        vm.guardandoRetirados = false;
        vm.GlobalHelpers = GlobalHelpers;
        vm.SessionService = SessionService;

        vm.resultadosEsAdminTipo = function () {
            var t = SessionService.currentUser && SessionService.currentUser.tipo;
            return t === 'admin' || t === 'superadmin';
        };

        vm.posiciones = [];
        vm.ganadoras = [];
        vm.caballosSelectRetirados = [];
        vm.caballosCarreraTotal = 0;
        vm.retiradosListaOrdenada = [];
        vm.retiradoSelectModel = null;
        vm.editandoResultado = false;
        /** Evita volver a copiar ganadoras desde API en cada ganadorasMaker; no pisar vm.carrera.resultado (compartido con vm.carreras). */
        vm._ganadorasSnapshotAplicado = false;
        vm._ganadorasCtxCarreraId = undefined;

        /** Mantiene bootstrap-select alineado con ng-options cuando cambia vm.caballosSelectRetirados. */
        function syncRetiradosSelectpicker() {
            $timeout(function () {
                var node = document.getElementById('resultadosRetiradosSelect');
                if (!node) {
                    return;
                }
                var el = angular.element(node);
                if (typeof el.selectpicker !== 'function') {
                    return;
                }
                try {
                    if (el.data('selectpicker')) {
                        el.selectpicker('refresh');
                    }
                } catch (ignore) {
                }
            }, 0);
        }

        getJornada().then(function () {
          return getTipos();
        }).then(function () {
          return getCarreras();
        }).then(function () {
          vm.ready = true;
          GlobalHelpers.selectRefresh('select.selectpicker');
        });

        function jornadaChange () {
          vm.ajax = true;
          vm.carrera = undefined;
          getCarreras().then(function () {
            vm.ajax = false;
            GlobalHelpers.selectRefresh('select.selectpicker');
          });
        }

        vm.jornadaChange = jornadaChange;

        function getJornada () {
          return $http.get(ENV_VARS.apiUrl + 'jornada', {
            params: {
              d: 'p'
            }
          }).then(function (response) {
            vm.jornadas = response.data.jornadas;
            vm.jornada = vm.jornadas[0];
            if (!vm.jornada) {
              toastr.error('No se cargó una jornada para hoy');
            }
          });
        }

        function getTipos () {
          return $http.get(ENV_VARS.apiUrl + 'tipo').then(function (response) {
            vm.tipos = response.data.tipos;
            vm.tipos[GlobalHelpers.findWithAttr(vm.tipos, 'code', 'tle')].carreras = 1;
          });
        }

        function getCarreras () {
          return $http.get(ENV_VARS.apiUrl + 'carrera', {
            params: {
              jid: vm.jornada.id
            }
          }).then(function (response) {
            vm.carreras = response.data.carreras;
            for (var i = 0; i < vm.carreras.length ; i++) {
              if (!vm.carreras[i].resultado && !vm.carreras[i].abierta) {
                vm.carrera = vm.carreras[i];
                vm.carreraIndex = i;
                break;
              }
            }

            if (vm.carrera) {
              vm.updateStatus();
            }
          });
        }

        vm.toggleCaballo = function (caballo) {
            if (!vm.resultadosEsAdminTipo()) {
                return;
            }
            GlobalHelpers.pushPop(vm.availableCaballos, caballo);
            GlobalHelpers.pushPop(vm.posiciones, caballo);
            vm.ganadorasMaker();
        };

        vm.corregirOrden = function (index) {
            if (!vm.resultadosEsAdminTipo()) {
                return;
            }
            if (vm.llegada[index] == 1 || vm.llegada[index] == vm.llegada[index - 1]) {
                vm.llegada[index] = index + 1;
            } else {
                vm.llegada[index] = vm.llegada[index] - 1;
            }
            vm.ganadorasMaker();
        };

        /** Caballos elegibles para la mesa de posiciones: no retirados y aún no asignados. */
        function availableCaballosParaElegirPosicion() {
            vm.carrera.retirados = vm.carrera.retirados || [];
            var pos = vm.posiciones || [];
            return GlobalHelpers.makeArray(vm.carrera.caballos).filter(function (caballo) {
                return vm.carrera.retirados.indexOf(caballo) === -1 && pos.indexOf(caballo) === -1;
            });
        }

        /**
         * Cantidad de caballos en la carrera (columna caballos: entero en API).
         * Tolera respuestas viejas: número, string numérico o array (legacy).
         */
        /**
         * Activa trazas en consola para el select de retirados:
         *   localStorage.setItem('DEBUG_RETIRADOS_SELECT', '1')  → recargar
         * o en consola: window.__DEBUG_RETIRADOS_SELECT = true
         *
         * Origen de datos: vm.carrera viene del listado GET /carrera?jid=… (mismo objeto que vm.carreras[i]).
         * caballos = cantidad N de caballos en carrera (entero en DB); se expande a [1..N] y se excluyen retirados.
         * Se repuebla en: updateCaballoData (todas las ramas), updateStatus (al final), tras PATCH retirados (updateCaballoData).
         */
        function logRetiradosSelect(phase, payload) {
            if (typeof window === 'undefined') {
                return;
            }
            var on = window.__DEBUG_RETIRADOS_SELECT ||
                (window.localStorage && window.localStorage.getItem('DEBUG_RETIRADOS_SELECT') === '1');
            if (!on) {
                return;
            }
            console.warn('[Resultados][retirados-select]', phase, payload || {});
        }

        function caballosEnCarreraTotal(carrera) {
            if (!carrera || carrera.caballos == null || carrera.caballos === '') {
                return 0;
            }
            var c = carrera.caballos;
            if (typeof c === 'number' && !isNaN(c) && c > 0) {
                return Math.floor(c);
            }
            if (typeof c === 'string' && String(c).trim() !== '') {
                var parsed = parseInt(c, 10);
                if (!isNaN(parsed) && parsed > 0) {
                    return parsed;
                }
            }
            if (Array.isArray(c) && c.length > 0) {
                return c.length;
            }
            return 0;
        }

        function refreshCaballosSelectRetirados() {
            if (!vm.carrera) {
                vm.caballosSelectRetirados = [];
                vm.caballosCarreraTotal = 0;
                vm.retiradosListaOrdenada = [];
                logRetiradosSelect('refresh(sin-carrera)', {});
                return;
            }
            ensureCarreraListas(vm.carrera);
            var rawCaballos = vm.carrera.caballos;
            var todos = GlobalHelpers.makeArray(rawCaballos);
            var usedFallback = false;
            if (!todos.length) {
                var fallbackN = caballosEnCarreraTotal(vm.carrera);
                if (fallbackN > 0) {
                    todos = GlobalHelpers.makeArray(fallbackN);
                    usedFallback = true;
                }
            }
            vm.caballosCarreraTotal = todos.length;
            vm.caballosSelectRetirados = todos.filter(function (n) {
                return vm.carrera.retirados.indexOf(n) === -1;
            });
            vm.retiradosListaOrdenada = vm.carrera.retirados.slice(0).map(Number).sort(function (a, b) {
                return a - b;
            });
            logRetiradosSelect('refresh', {
                carreraId: vm.carrera.id,
                orden: vm.carrera.orden,
                caballosRaw: rawCaballos,
                caballosTypeof: typeof rawCaballos,
                caballosIsArray: Array.isArray(rawCaballos),
                arrayLength: Array.isArray(rawCaballos) ? rawCaballos.length : null,
                retirados: vm.carrera.retirados.slice(0),
                todosLength: todos.length,
                todosHead: todos.slice(0, 20),
                usedFallback: usedFallback,
                selectLength: vm.caballosSelectRetirados.length,
                selectHead: vm.caballosSelectRetirados.slice(0, 20)
            });
            syncRetiradosSelectpicker();
        }

        vm.updateCaballoData = function () {
            vm.carrera.retirados = vm.carrera.retirados || [];
            logRetiradosSelect('updateCaballoData(inicio)', {
                carreraId: vm.carrera && vm.carrera.id,
                tieneResultado: !!(vm.carrera && vm.carrera.resultado)
            });
            if (vm.carrera.resultado) {
                vm._mesaCarreraId = vm.carrera.id;
                vm.llegada = vm.carrera.resultado.llegada;
                vm.posiciones = vm.carrera.resultado.posiciones;
                vm.availableCaballos = availableCaballosParaElegirPosicion();
                refreshCaballosSelectRetirados();
                logRetiradosSelect('updateCaballoData(rama)', { rama: 'desde_resultado_api' });
                logResultados('updateCaballoData', {
                    rama: 'desde_resultado_api',
                    carreraId: vm.carrera.id,
                    orden: vm.carrera.orden,
                    llegadaLen: vm.llegada && vm.llegada.length,
                    posicionesLen: vm.posiciones && vm.posiciones.length
                });
                return;
            }
            // ganadorasMaker deja resultado en null al editar; no pisar llegada/posiciones al refrescar retirados.
            var mesaTieneDatos = vm.llegada && vm.llegada.length > 0 && vm.posiciones && vm.posiciones.length > 0;
            if (mesaTieneDatos && vm._mesaCarreraId === vm.carrera.id) {
                vm.availableCaballos = availableCaballosParaElegirPosicion();
                refreshCaballosSelectRetirados();
                logRetiradosSelect('updateCaballoData(rama)', { rama: 'preservar_mesa_sin_resultado' });
                logResultados('updateCaballoData', {
                    rama: 'preservar_mesa_sin_resultado',
                    carreraId: vm.carrera.id,
                    _mesaCarreraId: vm._mesaCarreraId,
                    llegadaLen: vm.llegada.length,
                    posicionesLen: vm.posiciones.length,
                    editandoResultado: vm.editandoResultado
                });
                return;
            }
            logResultados('updateCaballoData', {
                rama: 'reset_plantilla',
                carreraId: vm.carrera.id,
                motivoNoPreservar: !mesaTieneDatos ? 'mesa_vacia_o_sin_posiciones' : 'cambio_carrera',
                mesaTieneDatos: mesaTieneDatos,
                _mesaCarreraId: vm._mesaCarreraId
            });
            vm._mesaCarreraId = vm.carrera.id;
            vm.llegada = GlobalHelpers.makeArray(vm.carrera.caballos - vm.carrera.retirados.length);
            vm.posiciones = [];
            vm.availableCaballos = availableCaballosParaElegirPosicion();
            refreshCaballosSelectRetirados();
            logRetiradosSelect('updateCaballoData(rama)', { rama: 'reset_plantilla' });
        };

        vm.elegirRetiradoDesdeSelect = function () {
            if (!vm.resultadosEsAdminTipo()) {
                return;
            }
            var n = vm.retiradoSelectModel;
            if (n === null || n === undefined || n === '') {
                return;
            }
            vm.toggleRetirado(n);
            vm.retiradoSelectModel = null;
        };

        function ensureCarreraListas(carrera) {
            if (!carrera) {
                return;
            }
            carrera.retirados = (carrera.retirados || []).map(Number).filter(function (n) {
                return !isNaN(n) && n > 0;
            });
            carrera.multiples = (carrera.multiples || []).map(Number).filter(function (n) {
                return !isNaN(n) && n > 0;
            });
        }

        function syncCarrerasTrasPatch(list) {
            if (!list || !vm.carreras || !vm.carrera) {
                return;
            }
            for (var k = 0; k < list.length; k++) {
                var idx = GlobalHelpers.findWithAttr(vm.carreras, 'id', list[k].id);
                if (idx >= 0) {
                    // El PATCH /carrera devuelve filas sin `resultado`; preservamos los datos cargados en Resultados.
                    vm.carreras[idx].retirados = list[k].retirados || [];
                    vm.carreras[idx].multiples = list[k].multiples || [];
                    vm.carreras[idx].ganador_es_favorito = !!list[k].ganador_es_favorito;
                }
            }
            var curIdx = GlobalHelpers.findWithAttr(vm.carreras, 'id', vm.carrera.id);
            if (curIdx >= 0) {
                vm.carrera = vm.carreras[curIdx];
            }
            ensureCarreraListas(vm.carrera);
            logResultados('syncCarrerasTrasPatch', {
                idsActualizados: (list || []).map(function (c) {
                    return c.id;
                }),
                carreraActualId: vm.carrera && vm.carrera.id,
                tieneResultadoEnVmCarrera: !!(vm.carrera && vm.carrera.resultado)
            });
        }

        function patchRetiradosCarrera(carrera) {
            vm.guardandoRetirados = true;
            $http.patch(ENV_VARS.apiUrl + 'carrera/' + carrera.id, carrera).then(function (response) {
                syncCarrerasTrasPatch(response.data.carreras);
                vm.updateCaballoData();
                vm.ganadorasMaker();
                toastr.success(response.data.msg);
            }, function () {
                toastr.error('No se pudo guardar los retirados');
            }).finally(function () {
                vm.guardandoRetirados = false;
            });
        }

        vm.toggleRetirado = function (i) {
            if (!vm.resultadosEsAdminTipo()) {
                return;
            }
            if (!vm.carrera || vm.guardandoRetirados) {
                return;
            }
            ensureCarreraListas(vm.carrera);
            var isReti = vm.carrera.retirados.indexOf(i) != -1;
            var isMulti = vm.carrera.multiples.indexOf(i) != -1;

            if (!isReti && isMulti) {
                $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    templateUrl: 'app/pages/turf/retirados/modals/multipleRetirado.html',
                    size: 'md',
                    resolve: {
                        parent: function () {
                            return vm;
                        },
                        horseNum: function () {
                            return i;
                        }
                    },
                    controllerAs: 'vm',
                    controller: function ($uibModalInstance, parent, horseNum) {
                        var modalVm = this;
                        modalVm.i = horseNum;
                        modalVm.carrera = parent.carrera;
                        modalVm.confirmPatch = function (carrera) {
                            carrera.retirados.push(horseNum);
                            patchRetiradosCarrera(carrera);
                            $uibModalInstance.close();
                        };
                    }
                });
            } else {
                GlobalHelpers.pushPop(vm.carrera.retirados, i);
                patchRetiradosCarrera(vm.carrera);
            }
        };

        function tieneResultadoLlegada(carrera) {
            return !!(carrera && carrera.resultado && carrera.resultado.llegada);
        }

        /**
         * Diagnóstico Resultados / ganadorasMaker / pools PCK-CNA.
         * En consola del navegador (pestaña de la app abierta):
         *   window.__DEBUG_RESULTADOS = true
         * O persistente:
         *   localStorage.setItem('DEBUG_RESULTADOS', '1')
         * Luego recargar o repetir la acción (cambiar carrera, guardar retirados, etc.).
         */
        function isDebugResultados() {
            if (typeof window === 'undefined') {
                return false;
            }
            if (window.__DEBUG_RESULTADOS) {
                return true;
            }
            try {
                return window.localStorage && window.localStorage.getItem('DEBUG_RESULTADOS') === '1';
            } catch (e) {
                return false;
            }
        }

        function logResultados() {
            if (!isDebugResultados()) {
                return;
            }
            var args = Array.prototype.slice.call(arguments);
            args.unshift('[Resultados][ganadorasMaker]');
            console.warn.apply(console, args);
        }

        function logResultadosError(message, err, extra) {
            var payload = {
                message: message,
                errMessage: err && err.message,
                stack: err && err.stack,
                extra: extra || {}
            };
            console.error('[Resultados][ganadorasMaker] ERROR', payload);
        }

        function getPrimeros(carrera) {
            var primeros = [];
            if (!carrera || !carrera.resultado) {
                return primeros;
            }

            carrera.resultado.llegada.forEach(function (llegada, index) {
                if (llegada == 1) {
                    primeros.push(carrera.resultado.posiciones[index]);
                }
            });

            return primeros;
        }

        /** Una pierna sin resultado (o sin ganador cargado) aporta un placeholder para armar filas como EXA/TRIF (inputs visibles). */
        function primerosPiernaPool(carrera) {
            var primeros = getPrimeros(carrera);
            if (primeros.length) {
                return primeros;
            }
            return [''];
        }

        function getPrimerosDesdeLlegadaPosiciones(llegada, posiciones) {
            var primeros = [];
            if (!Array.isArray(llegada) || !Array.isArray(posiciones)) {
                return primeros;
            }

            llegada.forEach(function (valor, index) {
                if (valor == 1) {
                    // Igual que cna/tlo/dob: permitir placeholder antes de elegir el ganador actual.
                    primeros.push((posiciones[index] || posiciones[index] === 0) ? posiciones[index] : '');
                }
            });

            return primeros;
        }

        function diagnosticarCarreraPool(carrera) {
            var resultado = carrera && carrera.resultado;
            var llegada = resultado && resultado.llegada;
            var posiciones = resultado && resultado.posiciones;
            var primerosRaw = [];
            var primerosValidos = [];

            if (Array.isArray(llegada)) {
                llegada.forEach(function (valor, index) {
                    if (valor == 1) {
                        primerosRaw.push({
                            index: index,
                            llegada: valor,
                            posicion: posiciones && posiciones[index]
                        });
                        if (posiciones && (posiciones[index] || posiciones[index] === 0)) {
                            primerosValidos.push(posiciones[index]);
                        }
                    }
                });
            }

            return {
                carreraId: carrera && carrera.id,
                orden: carrera && carrera.orden,
                abierta: carrera && carrera.abierta,
                tieneResultado: !!resultado,
                tipoLlegada: Array.isArray(llegada) ? 'array' : typeof llegada,
                tipoPosiciones: Array.isArray(posiciones) ? 'array' : typeof posiciones,
                llegadaLen: Array.isArray(llegada) ? llegada.length : null,
                posicionesLen: Array.isArray(posiciones) ? posiciones.length : null,
                llegada: llegada,
                posiciones: posiciones,
                primerosRaw: primerosRaw,
                primerosValidos: primerosValidos
            };
        }

        function cartesianProduct(arrays) {
            if (!arrays.length) {
                return [];
            }

            var result = [[]];
            arrays.forEach(function (items) {
                var step = [];
                result.forEach(function (base) {
                    items.forEach(function (item) {
                        step.push(base.concat([item]));
                    });
                });
                result = step;
            });

            return result;
        }

        function buildPoolGanadoras(startIndex, totalCarreras, usarUltimaPiernaActual) {
            var primerosPorCarrera = [];
            var diagnosticoPool = [];
            for (var i = 0; i < totalCarreras; i++) {
                var carrera = vm.carreras[startIndex + i];
                var esUltimaPiernaActual = !!usarUltimaPiernaActual && (i === totalCarreras - 1);
                var diagnosticoCarrera;
                var primeros;

                if (esUltimaPiernaActual) {
                    primeros = getPrimerosDesdeLlegadaPosiciones(vm.llegada, vm.posiciones);
                    diagnosticoCarrera = {
                        carreraId: carrera && carrera.id,
                        orden: carrera && carrera.orden,
                        fuente: 'estado_actual',
                        tieneResultadoPersistido: !!(carrera && carrera.resultado),
                        llegada: vm.llegada,
                        posiciones: vm.posiciones,
                        primerosValidos: primeros
                    };
                } else {
                    diagnosticoCarrera = diagnosticarCarreraPool(carrera);
                    primeros = primerosPiernaPool(carrera);
                }

                if (!primeros.length) {
                    primeros = [''];
                    diagnosticoCarrera.placeholderPierna = true;
                }
                diagnosticoPool.push(diagnosticoCarrera);
                logResultados('pool carrera diagnóstica', diagnosticoCarrera);
                primerosPorCarrera.push(primeros);
            }

            var combinacionesPool = cartesianProduct(primerosPorCarrera);
            logResultados('buildPoolGanadoras OK', {
                startIndex: startIndex,
                totalCarreras: totalCarreras,
                usarUltimaPiernaActual: !!usarUltimaPiernaActual,
                combinaciones: combinacionesPool.length
            });
            return combinacionesPool;
        }

        function ganadoraMultiplierKey(g, indexEnLista) {
            if (!g) {
                return 'n|' + indexEnLista;
            }
            if (g.tipo === false) {
                return 'f|' + indexEnLista;
            }
            var t = g.tipo || '';
            var p = g.place ? '1' : '0';
            var c = Array.isArray(g.caballos) ? g.caballos.join('-') : '';
            return t + '|' + p + '|' + c;
        }

        function mergeGanadorasMultipliersDesdePrev(prevRows) {
            if (!prevRows || !prevRows.length || !vm.ganadoras || !vm.ganadoras.length) {
                return;
            }
            var byKey = {};
            prevRows.forEach(function (row) {
                if (row.mult != null && row.mult !== '') {
                    byKey[row.key] = row.mult;
                }
            });
            vm.ganadoras.forEach(function (g, i) {
                var k = ganadoraMultiplierKey(g, i);
                if (Object.prototype.hasOwnProperty.call(byKey, k)) {
                    g.multiplier = byKey[k];
                }
            });
            if (vm.ganadoras.length === prevRows.length) {
                vm.ganadoras.forEach(function (g, i) {
                    if ((g.multiplier == null || g.multiplier === '') && prevRows[i].mult != null && prevRows[i].mult !== '') {
                        g.multiplier = prevRows[i].mult;
                    }
                });
            }
        }

        function tipoConReglaFavoritoEnMulti(code) {
            return ['dob', 'tlo', 'cna', 'pck5', 'pck6'].indexOf(code) !== -1;
        }

        function buildGanadoraFavoritoLegs(ganadora) {
            if (!ganadora || !ganadora.tipo || !Array.isArray(ganadora.caballos)) {
                return [];
            }
            if (!tipoConReglaFavoritoEnMulti(ganadora.tipo)) {
                return [];
            }
            if (!vm.carreras || vm.carreraIndex == null) {
                return [];
            }

            var nLegs = ganadora.caballos.length;
            if (!nLegs) {
                return [];
            }
            var startIdx = vm.carreraIndex - (nLegs - 1);
            if (startIdx < 0) {
                return [];
            }

            var out = [];
            var aplica = false;
            for (var i = 0; i < nLegs; i++) {
                var legCarrera = vm.carreras[startIdx + i];
                var ganadorLeg = ganadora.caballos[i];
                if (!legCarrera) {
                    continue;
                }
                var retirados = Array.isArray(legCarrera.retirados) ? legCarrera.retirados.slice(0) : [];
                var showRetiradosYGanador = !!legCarrera.ganador_es_favorito && retirados.length > 0;
                if (showRetiradosYGanador) {
                    aplica = true;
                    retirados.sort(function (a, b) {
                        return a - b;
                    });
                    var nums = retirados.concat([ganadorLeg]);
                    out.push({
                        label: nums.join('-'),
                        esFavoritoLeg: true
                    });
                } else {
                    var lbl = (ganadorLeg === '' || ganadorLeg === null || ganadorLeg === undefined) ? '—' : String(ganadorLeg);
                    out.push({
                        label: lbl,
                        esFavoritoLeg: false
                    });
                }
            }

            return aplica ? out : [];
        }

        vm.syncGanadorasFavoritoLegs = function () {
            if (!vm.ganadoras || !vm.ganadoras.length) {
                return;
            }
            vm.ganadoras.forEach(function (g) {
                g.favoritoLegs = buildGanadoraFavoritoLegs(g);
            });
        };

        vm.setGanadorEsFavorito = function (value) {
            if (!vm.resultadosEsAdminTipo()) {
                return;
            }
            if (!vm.carrera) {
                return;
            }
            vm.carrera.ganador_es_favorito = !!value;
            vm.syncGanadorasFavoritoLegs();
        };

        vm.ganadorasMaker = function () {
            var prevGanadorasParaMultipliers = (vm.ganadoras && vm.ganadoras.length) ? vm.ganadoras.map(function (g, i) {
                return { key: ganadoraMultiplierKey(g, i), mult: g && g.multiplier };
            }) : [];
            vm.ganadoras = [];
            var debugCtx = { fase: 'inicio' };

            try {
                debugCtx.fase = 'check_carrera';
                if (!vm.carrera) {
                    logResultados('abort: vm.carrera es null/undefined');
                    return;
                }

                debugCtx.carreraId = vm.carrera.id;
                debugCtx.orden = vm.carrera.orden;
                debugCtx.carreraIndex = vm.carreraIndex;
                debugCtx.abierta = vm.carrera.abierta;

                if (vm.carrera.abierta) {
                    return;
                }

                if (vm.carreras && vm.carreras.length) {
                    var idxSync = GlobalHelpers.findWithAttr(vm.carreras, 'id', vm.carrera.id);
                    if (idxSync >= 0) {
                        vm.carreraIndex = idxSync;
                    }
                }

                debugCtx.fase = 'ramas';
                if (vm.carrera.resultado && !vm._ganadorasSnapshotAplicado) {
                    debugCtx.modo = 'editar_resultado_existente';
                    logResultados('copiando ganadoras desde resultado previo', { resultadoId: vm.carrera.resultado.id });
                    vm.ganadoras = vm.carrera.resultado.ganadoras.slice(0);
                    vm._ganadorasSnapshotAplicado = true;
                    logResultados('ganadoras copiadas (modo edición; resultado se mantiene en vm.carreras para re-selección)', {
                        total: vm.ganadoras.length,
                        porTipo: vm.ganadoras.reduce(function (acc, g) {
                            var t = g && g.tipo;
                            if (t) {
                                acc[t] = (acc[t] || 0) + 1;
                            } else {
                                acc._placeholder = (acc._placeholder || 0) + 1;
                            }
                            return acc;
                        }, {})
                    });
                    return;
                } else {
                    debugCtx.modo = 'armar_desde_llegada';
                    logResultados('armar ganadoras desde posiciones actuales', {
                        carreraId: vm.carrera.id,
                        orden: vm.carrera.orden,
                        pck5Inicio: vm.carreras[vm.carreraIndex - 4] && vm.carreras[vm.carreraIndex - 4].pck5,
                        pck5InicioOrden: vm.carreras[vm.carreraIndex - 4] && vm.carreras[vm.carreraIndex - 4].orden
                    });
                    if (vm.carrera.gan > 0) {
                        vm.llegada.forEach(function (llegada, index) {
                            if (llegada == 1) {
                                vm.ganadoras.push({
                                    tipo: 'gan',
                                    caballos: [vm.posiciones[index]]
                                });
                                if (vm.carrera.seg > 0) {
                                    vm.ganadoras.push({
                                        tipo: 'seg',
                                        caballos: [vm.posiciones[index]]
                                    });
                                    if (vm.carrera.ter > 0) {
                                        vm.ganadoras.push({
                                            tipo: 'ter',
                                            caballos: [vm.posiciones[index]]
                                       });
                                    } else {
                                        vm.ganadoras.push({
                                            tipo: false
                                        });
                                    }
                                } else {
                                    vm.ganadoras.push({
                                        tipo: false
                                    });
                                    vm.ganadoras.push({
                                        tipo: false
                                    });
                                }
                            }
                        });
                    }

                    if (vm.carrera.seg > 0) {
                        vm.llegada.forEach(function (llegada, index) {
                            if (llegada == 2) {
                                vm.ganadoras.push({
                                    tipo: false
                                });
                                vm.ganadoras.push({
                                    tipo: 'seg',
                                    caballos: [vm.posiciones[index]]
                                });
                                if (vm.carrera.ter > 0) {
                                    vm.ganadoras.push({
                                        tipo: 'ter',
                                        caballos: [vm.posiciones[index]]
                                    });
                                } else {
                                    vm.ganadoras.push({
                                        tipo: false
                                    });
                                }
                            }
                        });
                    }

                    if (vm.carrera.ter > 0) {
                        vm.llegada.forEach(function (llegada, index) {
                            if (llegada == 3) {
                                vm.ganadoras.push({
                                    tipo: false
                                });
                                vm.ganadoras.push({
                                    tipo: false
                                });
                                vm.ganadoras.push({
                                    tipo: 'ter',
                                    caballos: [vm.posiciones[index]]
                                });
                            }
                        });
                    }

                    vm.tipos.forEach(function (tipo) {
                        debugCtx.tipoCode = tipo.code;
                        if (isDebugResultados() &&
                            ['dob', 'tlo', 'cna', 'tle', 'pck5', 'pck6', 'cuat'].indexOf(tipo.code) !== -1) {
                            logResultados('tipo iteración (multi-carrera)', {
                                code: tipo.code,
                                valeEnCarreraActual: vm.carrera[tipo.code]
                            });
                        }

                        if (tipo.code === 'cuat' && !(vm.carrera.cuat > 0)) {
                            logResultados('cuat omitido (vale en carrera <= 0)', { cuat: vm.carrera.cuat });
                        }

                        if (vm.carrera[tipo.code] > 0) {
                            switch (tipo.code) {
                                case 'exa':
                                    vm.llegada.forEach(function (llegada1, index1) {
                                        if (llegada1 == 1) {
                                            vm.llegada.forEach(function (llegada2, index2) {
                                                if (index2 != index1) {
                                                    if (llegada2 == 1 || llegada2 == 2) {
                                                        vm.ganadoras.push({
                                                            tipo: tipo.code,
                                                            caballos: [vm.posiciones[index1], vm.posiciones[index2]]
                                                        });
                                                    }
                                                }
                                            });
                                        }
                                    });
                                    break;
                                case 'imp':
                                    vm.llegada.forEach(function (llegada1, index1) {
                                        if (llegada1 == 1) {
                                            vm.llegada.forEach(function (llegada2, index2) {
                                                if (index2 != index1) {
                                                    if (llegada2 == 1 || llegada2 == 2) {
                                                        if (index1 < index2) {
                                                            vm.ganadoras.push({
                                                                tipo: tipo.code,
                                                                caballos: [Math.min(vm.posiciones[index1], vm.posiciones[index2]) || '', Math.max(vm.posiciones[index1], vm.posiciones[index2]) || '']
                                                            });
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    });
                                    break;
                                case 'trif':
                                    vm.llegada.forEach(function (llegada1, index1) {
                                        if (llegada1 == 1) {
                                            vm.llegada.forEach(function (llegada2, index2) {
                                                if (index2 != index1) {
                                                    if (llegada2 == 1 || llegada2 == 2) {
                                                        vm.llegada.forEach(function (llegada3, index3) {
                                                            if (index3 != index1 && index3 != index2) {
                                                                if (llegada3 == 1 || llegada3 == 2 || llegada3 == 3) {
                                                                    vm.ganadoras.push({
                                                                        tipo: tipo.code,
                                                                        caballos: [vm.posiciones[index1], vm.posiciones[index2], vm.posiciones[index3]]
                                                                    });
                                                                }
                                                            }
                                                        });
                                                    }
                                                }
                                            });
                                        }
                                    });
                                    break;
                                case 'cuat':
                                    vm.llegada.forEach(function (llegada1, index1) {
                                        if (llegada1 == 1) {
                                            vm.llegada.forEach(function (llegada2, index2) {
                                                if (index2 != index1) {
                                                    if (llegada2 == 1 || llegada2 == 2) {
                                                        vm.llegada.forEach(function (llegada3, index3) {
                                                            if (index3 != index1 && index3 != index2) {
                                                                if (llegada3 == 1 || llegada3 == 2 || llegada3 == 3) {
                                                                    vm.llegada.forEach(function (llegada4, index4) {
                                                                        if (index4 != index1 && index4 != index2 && index4 != index3) {
                                                                            if (llegada4 == 1 || llegada4 == 2 || llegada4 == 3 || llegada4 == 4) {
                                                                                vm.ganadoras.push({
                                                                                    tipo: tipo.code,
                                                                                    caballos: [vm.posiciones[index1], vm.posiciones[index2], vm.posiciones[index3], vm.posiciones[index4]]
                                                                                });
                                                                            }
                                                                        }
                                                                    });
                                                                }
                                                            }
                                                        });
                                                    }
                                                }
                                            });
                                        }
                                    });
                                    break;
                                // case 'eng':
                                //     vm.llegada.forEach(function (llegada1, index1) {
                                //         if (llegada1 == 1) {
                                //             vm.ganadoras.push({
                                //                 tipo: tipo.code,
                                //                 caballos: [vm.posiciones[index1]]
                                //             });
                                //         }
                                //     });
                                //     break;
                            }
                        }

                        if (tipo.code == 'dob' && vm.carrera.orden >= 2 && vm.carreras[vm.carreraIndex - 1] && vm.carreras[vm.carreraIndex - 1].dob > 0) {
                            var cDob = vm.carreras[vm.carreraIndex - 1];
                            var tipoDob = vm.tipos[GlobalHelpers.findWithAttr(vm.tipos, 'code', 'dob')];
                            if (!tieneResultadoLlegada(cDob)) {
                                vm.llegada.forEach(function (llegada2, index2) {
                                    if (llegada2 == 1) {
                                        vm.ganadoras.push({
                                            tipo: tipoDob.code,
                                            caballos: ['', vm.posiciones[index2]]
                                        });
                                    }
                                    if (vm.jornada.hipodromo.id == HIPODROMO.palermo) {
                                        if (llegada2 == 2) {
                                            vm.ganadoras.push({
                                                tipo: tipoDob.code,
                                                caballos: ['', vm.posiciones[index2]],
                                                place: true
                                            });
                                        }
                                    }
                                });
                            } else {
                            cDob.resultado.llegada.forEach(function (llegada1, index1) {
                                if (llegada1 == 1) {
                                    vm.llegada.forEach(function (llegada2, index2) {
                                        if (llegada2 == 1) {
                                            vm.ganadoras.push({
                                                tipo: tipoDob.code,
                                                caballos: [cDob.resultado.posiciones[index1], vm.posiciones[index2]]
                                            });
                                        }

                                        if (vm.jornada.hipodromo.id == HIPODROMO.palermo) {
                                            if (llegada2 == 2) {
                                                vm.ganadoras.push({
                                                    tipo: tipoDob.code,
                                                    caballos: [cDob.resultado.posiciones[index1], vm.posiciones[index2]],
                                                    place: true
                                                });
                                            }
                                        }
                                    });
                                }
                            });
                            }
                        }

                        if (tipo.code == 'tlo' && vm.carrera.orden >= 3 && vm.carreras[vm.carreraIndex - 2] && vm.carreras[vm.carreraIndex - 2].tlo > 0) {
                            var cTloA = vm.carreras[vm.carreraIndex - 2];
                            var cTloB = vm.carreras[vm.carreraIndex - 1];
                            var tipoTlo = vm.tipos[GlobalHelpers.findWithAttr(vm.tipos, 'code', 'tlo')];
                            var pTloA = primerosPiernaPool(cTloA);
                            var pTloB = primerosPiernaPool(cTloB);
                            pTloA.forEach(function (x1) {
                                pTloB.forEach(function (x2) {
                                    vm.llegada.forEach(function (llegada3, index3) {
                                        if (llegada3 == 1) {
                                            vm.ganadoras.push({
                                                tipo: tipoTlo.code,
                                                caballos: [x1, x2, vm.posiciones[index3]]
                                            });
                                        }
                                    });
                                });
                            });
                        }

                        if (tipo.code == 'cna') {
                            var cnaGate = vm.carrera.orden >= 4 && vm.carreras[vm.carreraIndex - 3] && vm.carreras[vm.carreraIndex - 3].cna > 0;
                            if (!cnaGate) {
                                logResultados('cna omitido (orden / carrera inicio / vale)', {
                                    orden: vm.carrera.orden,
                                    carreraIndex: vm.carreraIndex,
                                    cnaInicio: vm.carreras[vm.carreraIndex - 3],
                                    idxInicio: vm.carreraIndex - 3
                                });
                            } else {
                            var cCna1 = vm.carreras[vm.carreraIndex - 3];
                            var cCna2 = vm.carreras[vm.carreraIndex - 2];
                            var cCna3 = vm.carreras[vm.carreraIndex - 1];
                            var tipoCna = vm.tipos[GlobalHelpers.findWithAttr(vm.tipos, 'code', 'cna')];
                            var pCna1 = primerosPiernaPool(cCna1);
                            var pCna2 = primerosPiernaPool(cCna2);
                            var pCna3 = primerosPiernaPool(cCna3);
                            pCna1.forEach(function (x1) {
                                pCna2.forEach(function (x2) {
                                    pCna3.forEach(function (x3) {
                                        vm.llegada.forEach(function (llegada4, index4) {
                                            if (llegada4 == 1) {
                                                vm.ganadoras.push({
                                                    tipo: tipoCna.code,
                                                    caballos: [x1, x2, x3, vm.posiciones[index4]]
                                                });

                                                if (vm.jornada.hipodromo.id == HIPODROMO.sanIsidro) {
                                                    vm.ganadoras.push({
                                                        tipo: tipoCna.code,
                                                        caballos: [x1, x2, x3, vm.posiciones[index4]],
                                                        place: true
                                                    });
                                                }
                                            }
                                        });
                                    });
                                });
                            });
                            }
                        }

                        if (tipo.code == 'tle' && vm.carrera.orden >= 3 && vm.carreras[vm.carreraIndex - 2] && vm.carreras[vm.carreraIndex - 2].tle > 0) {
                            var cTleA = vm.carreras[vm.carreraIndex - 2];
                            var cTleB = vm.carreras[vm.carreraIndex - 1];
                            var tipoTle = vm.tipos[GlobalHelpers.findWithAttr(vm.tipos, 'code', 'tle')];
                            var pTleA = primerosPiernaPool(cTleA);
                            var pTleB = primerosPiernaPool(cTleB);
                            pTleA.forEach(function (x1) {
                                pTleB.forEach(function (x2) {
                                    vm.llegada.forEach(function (llegada3, index3) {
                                        if (llegada3 == 1) {
                                            vm.ganadoras.push({
                                                tipo: tipoTle.code,
                                                caballos: [x1, x2, vm.posiciones[index3]]
                                            });
                                        }

                                        if (llegada3 == 2) {
                                            vm.ganadoras.push({
                                                tipo: tipoTle.code,
                                                caballos: [x1, x2, vm.posiciones[index3]],
                                                place: true
                                            });
                                        }
                                    });
                                });
                            });
                        }

                        if (tipo.code == 'pck5') {
                            var pck5Gate = vm.carrera.orden >= 5 && vm.carreras[vm.carreraIndex - 4] && vm.carreras[vm.carreraIndex - 4].pck5 > 0;
                            if (!pck5Gate) {
                                logResultados('pck5 omitido (orden / inicio pool / vale pck5)', {
                                    orden: vm.carrera.orden,
                                    carreraIndex: vm.carreraIndex,
                                    startIdx: vm.carreraIndex - 4,
                                    carreraInicio: vm.carreras[vm.carreraIndex - 4],
                                    pck5ValeInicio: vm.carreras[vm.carreraIndex - 4] && vm.carreras[vm.carreraIndex - 4].pck5
                                });
                            } else {
                            debugCtx.fase = 'pck5';
                            logResultados('pck5 bloque', {
                                ordenActual: vm.carrera.orden,
                                carreraIndex: vm.carreraIndex,
                                startPoolIndex: vm.carreraIndex - 4,
                                pck5ValeInicioPool: vm.carreras[vm.carreraIndex - 4].pck5,
                                hipodromoId: vm.jornada.hipodromo && vm.jornada.hipodromo.id
                            });
                            var idxPck5 = GlobalHelpers.findWithAttr(vm.tipos, 'code', 'pck5');
                            if (idxPck5 < 0) {
                                logResultados('pck5 abort: no existe tipo pck5 en vm.tipos');
                                return;
                            }
                            var tipoPck5 = vm.tipos[idxPck5];
                            var combinacionesPck5 = buildPoolGanadoras(vm.carreraIndex - 4, 5, true);
                            logResultados('pck5 combinaciones', { count: combinacionesPck5.length });
                            combinacionesPck5.forEach(function (caballos) {
                                vm.ganadoras.push({
                                    tipo: tipoPck5.code,
                                    caballos: caballos
                                });

                                if (vm.jornada.hipodromo.id == HIPODROMO.laPlata) {
                                    vm.ganadoras.push({
                                        tipo: tipoPck5.code,
                                        caballos: caballos,
                                        place: true
                                    });
                                }
                            });
                            }
                        }

                        if (tipo.code == 'pck6') {
                            var pck6Gate = vm.carrera.orden >= 6 && vm.carreras[vm.carreraIndex - 5] && vm.carreras[vm.carreraIndex - 5].pck6 > 0;
                            if (!pck6Gate) {
                                logResultados('pck6 omitido (orden / inicio pool / vale pck6)', {
                                    orden: vm.carrera.orden,
                                    carreraIndex: vm.carreraIndex,
                                    startIdx: vm.carreraIndex - 5,
                                    carreraInicio: vm.carreras[vm.carreraIndex - 5],
                                    pck6ValeInicio: vm.carreras[vm.carreraIndex - 5] && vm.carreras[vm.carreraIndex - 5].pck6
                                });
                            } else {
                            debugCtx.fase = 'pck6';
                            logResultados('pck6 bloque', {
                                ordenActual: vm.carrera.orden,
                                carreraIndex: vm.carreraIndex,
                                startPoolIndex: vm.carreraIndex - 5
                            });
                            var idxPck6 = GlobalHelpers.findWithAttr(vm.tipos, 'code', 'pck6');
                            if (idxPck6 < 0) {
                                logResultados('pck6 abort: no existe tipo pck6 en vm.tipos');
                                return;
                            }
                            var tipoPck6 = vm.tipos[idxPck6];
                            var combinacionesPck6 = buildPoolGanadoras(vm.carreraIndex - 5, 6, true);
                            logResultados('pck6 combinaciones', { count: combinacionesPck6.length });
                            combinacionesPck6.forEach(function (caballos) {
                                vm.ganadoras.push({
                                    tipo: tipoPck6.code,
                                    caballos: caballos
                                });
                                vm.ganadoras.push({
                                    tipo: tipoPck6.code,
                                    caballos: caballos,
                                    place: true
                                });
                            });
                            }
                        }
                    });
                    logResultados('resumen post-tipos.forEach', {
                        modo: debugCtx.modo,
                        totalGanadoras: vm.ganadoras.length,
                        porTipo: vm.ganadoras.reduce(function (acc, g) {
                            var t = g && g.tipo;
                            if (t) {
                                acc[t] = (acc[t] || 0) + 1;
                            } else {
                                acc._placeholder = (acc._placeholder || 0) + 1;
                            }
                            return acc;
                        }, {}),
                        llegadaLen: vm.llegada && vm.llegada.length,
                        posicionesLen: vm.posiciones && vm.posiciones.length,
                        primerosPiernaActual: getPrimerosDesdeLlegadaPosiciones(vm.llegada, vm.posiciones)
                    });
                    mergeGanadorasMultipliersDesdePrev(prevGanadorasParaMultipliers);
                }
            } catch (err) {
                debugCtx.fase = debugCtx.fase || 'error';
                logResultadosError('ganadorasMaker', err, debugCtx);
                throw err;
            } finally {
                vm.syncGanadorasFavoritoLegs();
            }
        };

        function updateStatus  () {
            if (!vm.carrera) {
                return;
            }
            var prevCtxId = vm._ganadorasCtxCarreraId;
            vm._ganadorasCtxCarreraId = vm.carrera.id;
            if (prevCtxId !== vm._ganadorasCtxCarreraId) {
                vm._ganadorasSnapshotAplicado = false;
            }
            if (vm.carreras && vm.carreras.length) {
                var ci = GlobalHelpers.findWithAttr(vm.carreras, 'id', vm.carrera.id);
                if (ci >= 0) {
                    vm.carreraIndex = ci;
                }
            }
            vm.editandoResultado = vm.carrera.resultado ? vm.carrera.resultado.id : false;
            logResultados('updateStatus', {
                carreraId: vm.carrera.id,
                orden: vm.carrera.orden,
                carreraIndex: vm.carreraIndex,
                editandoResultado: vm.editandoResultado,
                tieneResultado: !!vm.carrera.resultado,
                pck5Vale: vm.carrera.pck5,
                pck6Vale: vm.carrera.pck6,
                cnaVale: vm.carrera.cna,
                cuatVale: vm.carrera.cuat
            });
            vm.carrera.ganador_es_favorito = !!vm.carrera.ganador_es_favorito;
            ensureCarreraListas(vm.carrera);
            vm.updateCaballoData();
            vm.ganadorasMaker();
            refreshCaballosSelectRetirados();
            logRetiradosSelect('updateStatus(post-ganadorasMaker)', {
                carreraId: vm.carrera.id,
                selectLength: vm.caballosSelectRetirados.length
            });
            var nextCarrera = vm.carreras[GlobalHelpers.findWithAttr(vm.carreras, 'orden', vm.carrera.orden + 1)];
            if (nextCarrera && nextCarrera.eng) { vm.eng = nextCarrera.eng }
        }

        vm.updateStatus = updateStatus;

        vm.getGanadoraLabel = function (ganadora) {
            if (!ganadora || !ganadora.tipo) {
                return '';
            }

            if (ganadora.tipo == 'pck5') {
                return (ganadora.caballos.join('.') + ' PCK5 ' + (ganadora.place ? '4/5' : '5/5')).toUpperCase();
            }

            if (ganadora.tipo == 'pck6') {
                return (ganadora.caballos.join('.') + ' PCK6 ' + (ganadora.place ? '5/6' : '6/6')).toUpperCase();
            }

            return (((!ganadora.place ? ganadora.caballos.join('.') : '') + ' ' + ganadora.tipo + (ganadora.place ? ' PLACE' : '')).trim()).toUpperCase();
        };

        function handleResultadoError(response) {
            var data = response.data || {};
            if ((response.status === 409 || response.status === 422) && data.mensaje) {
                toastr.error(data.mensaje);
                return getCarreras().then(function () {
                    vm.updateStatus();
                    GlobalHelpers.selectRefresh('select.selectpicker');
                });
            }
            toastr.error('Error al guardar resultado');
        }

        vm.sendResultado = function () {
            if (!vm.resultadosEsAdminTipo() || vm.ajax) {
                return;
            }
            if (!vm.editandoResultado && vm.carrera.resultado) {
                vm.editandoResultado = vm.carrera.resultado.id;
            }
            vm.ganadorasSanitizadas = vm.ganadoras.filter(function (ganadora) {
                return ganadora.tipo;
            }).map(function (ganadora) {
                var row = angular.copy(ganadora);
                delete row.favoritoLegs;
                return row;
            });

            var data = {
                carrera_id: vm.carrera.id,
                llegada: vm.llegada,
                posiciones: vm.posiciones,
                ganadoras: vm.ganadorasSanitizadas,
                eng: vm.eng,
                ganador_es_favorito: !!vm.carrera.ganador_es_favorito
            };

            if (vm.editandoResultado) {
                vm.ajax = true
                $http.patch(ENV_VARS.apiUrl + 'resultado/' + vm.editandoResultado, data).then(function (response) {
                    vm.carrera.resultado = response.data.resultado
                    toastr.success('Resultado editado correctamente');
                    $state.go('turf.jugar');
                }).catch(handleResultadoError).finally(function () {
                  vm.ajax = false
                });
            } else {
                vm.ajax = true
                $http.post(ENV_VARS.apiUrl + 'resultado', data).then(function (response) {
                    vm.carrera.resultado = response.data.resultado
                    toastr.success('Resultado cargado correctamente');
                    $state.go('turf.jugar');
                }).catch(handleResultadoError).finally(function () {
                  vm.ajax = false
                });
            }
        };

    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('RetiradosController', RetiradosController);

    function RetiradosController($http, $scope, $uibModal, ENV_VARS, GlobalHelpers, toastr) {

        var vm = this;
        vm.ready = false;

        vm.GlobalHelpers = GlobalHelpers;

        getJornada().then(function () {
          Promise.all([getCarreras()]).then(function () {
            vm.ready = true;
            $scope.$apply();
          });
        });

        function getJornada () {
          return $http.get(ENV_VARS.apiUrl + 'jornada').then(function (response) {
            vm.jornada = response.data.jornadas[0];
          });
        }

        function getCarreras () {
          return $http.get(ENV_VARS.apiUrl + 'carrera', {
            params: {
              jid: vm.jornada.id
            }
          }).then(function (response) {
            vm.jornada.carreras = response.data.carreras;
          });
        }

        function caballoClass (c, i) {
          return {
            'btn-danger'  : vm.jornada.carreras[c].retirados.indexOf(i) != -1,
            'btn-default' : vm.jornada.carreras[c].retirados.indexOf(i) == -1
          };
        }

        vm.caballoClass = caballoClass;

        function patchCarrera (carrera) {
          $http.patch(ENV_VARS.apiUrl + 'carrera/' + carrera.id, carrera).then(function (response) {
            vm.carreras = response.data.carreras;
            toastr.success(response.data.msg);
          });
        }

        vm.patchCarrera = patchCarrera;

        function clickCaballo (c, i) {
          var isReti  = vm.jornada.carreras[c].retirados.indexOf(i) != -1 ? true : false;
          var isMulti = vm.jornada.carreras[c].multiples.indexOf(i) != -1 ? true : false;

          if (!isReti && isMulti) {
            $uibModal.open({
              animation: true,
              backdrop: 'static',
              templateUrl: 'app/pages/turf/retirados/modals/multipleRetirado.html',
              size: 'md',
              resolve: {
                parent: function () { return vm }
              },
              controllerAs: 'vm',
              controller: function($http, $uibModalInstance, parent) {
                var vm = this;

                vm.i = i;
                vm.carrera = parent.jornada.carreras[c];

                vm.confirmPatch = function (carrera) {
                  carrera.retirados.push(i);
                  parent.patchCarrera(carrera);
                  $uibModalInstance.close();
                }
              }
            });
          } else {
            GlobalHelpers.pushPop(vm.jornada.carreras[c].retirados, i);
            vm.patchCarrera(vm.jornada.carreras[c]);
          }
      }

      vm.clickCaballo = clickCaballo;

    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('SaldosController', SaldosController);

    function SaldosController ($http, $scope, $uibModal, ENV_VARS, GlobalHelpers, SessionService, toastr) {

        var vm = this;

        vm.ajax = false;

        vm.GlobalHelpers = GlobalHelpers;
        vm.SessionService = SessionService;

        if (SessionService.currentUser.tipo === 'agente') {
          vm.selectedLugar = SessionService.lugar
        }

        GlobalHelpers.selectRefresh('#lugarSelect');
        GlobalHelpers.selectRefresh('#agenteSelect');

        function saldoTotal () {
          return vm.selectedLugar ? vm.selectedLugar.clientes.reduce(function (total, cliente) { return total + cliente.saldo }, 0) : null
        }

        vm.saldoTotal = saldoTotal

        function lugarChange () {
          GlobalHelpers.selectRefresh('#agenteSelect');
        }

        vm.lugarChange = lugarChange

        function doDescubierto (cliente) {
          vm.ajax = true
          $http.patch(ENV_VARS.apiUrl + 'cliente/' + cliente.id, {
            descubierto: cliente.descubierto
          }).then(function () {
            toastr.success('Correcto')
          }).catch(function () {
            toastr.error('Error')
          }).finally(function () {
            vm.ajax = false
          })
        }

        vm.doDescubierto = doDescubierto

        function doEstablecer (cliente) {
          vm.ajax = true
          $http.patch(ENV_VARS.apiUrl + 'cliente/' + cliente.id, {
            tipo: 'establecer',
            importe: cliente.establecer
          }).then(function () {
            toastr.success('Correcto')
            cliente.establecer = null
          }).catch(function () {
            toastr.error('Error')
          }).finally(function () {
            vm.ajax = false
          })
        }

        vm.doEstablecer = doEstablecer

        function doRecargar (cliente) {
          vm.ajax = true
          $http.patch(ENV_VARS.apiUrl + 'cliente/' + cliente.id, {
            tipo: 'recarga',
            importe: cliente.recargar
          }).then(function () {
            toastr.success('Se realizó la recarga')
            cliente.recargar = null
          }).catch(function (error) {
            toastr.error(error.data.mensaje || 'Hubo un error')
          }).finally(function () {
            vm.ajax = false
          })
        }

        vm.doRecargar = doRecargar

        function doRetirar (cliente) {
          if (cliente.retirar > 0) {
            if (cliente.saldo - cliente.retirar < cliente.descubierto) {
              toastr.error('No puede retirar más de $ ' + GlobalHelpers.formatMoney(cliente.saldo))
              return false
            }
            vm.ajax = true
            $http.patch(ENV_VARS.apiUrl + 'cliente/' + cliente.id, {
              tipo: 'retira',
              importe: cliente.retirar
            }).then(function () {
              toastr.success('Correcto')
              cliente.retirar = null
            }).catch(function (error) {
              toastr.error(error.data.mensaje || 'Error')
            }).finally(function () {
              vm.ajax = false
            })
          }
        }

        vm.doRetirar = doRetirar

        function doDescubiertoGrupo () {
          vm.ajax = true
          $http.patch(ENV_VARS.apiUrl + 'lugar/' + vm.selectedLugar.id, {
            descubierto: vm.selectedLugar.descubierto
          }).then(function () {
            toastr.success('Correcto')
          }).catch(function () {
            toastr.error('Error')
          }).finally(function () {
            vm.ajax = false
          })
        }

        vm.doDescubiertoGrupo = doDescubiertoGrupo

        function doEstablecerGrupo () {
          vm.ajax = true
          $http.patch(ENV_VARS.apiUrl + 'lugar/' + vm.selectedLugar.id, {
            saldo: true,
            tipo: 'establecer',
            importe: vm.selectedLugar.establecer
          }).then(function () {
            toastr.success('Correcto')
            vm.selectedLugar.establecer = null
          }).catch(function () {
            toastr.error('Error')
          }).finally(function () {
            vm.ajax = false
          })
        }

        vm.doEstablecerGrupo = doEstablecerGrupo

        function doRecargarGrupo () {
          vm.ajax = true
          $http.patch(ENV_VARS.apiUrl + 'lugar/' + vm.selectedLugar.id, {
            saldo: true,
            tipo: 'recargar',
            importe: vm.selectedLugar.recargar
          }).then(function () {
            toastr.success('Correcto')
            vm.selectedLugar.recargar = null
          }).catch(function () {
            toastr.error('Error')
          }).finally(function () {
            vm.ajax = false
          })
        }

        vm.doRecargarGrupo = doRecargarGrupo

        function doRetirarGrupo () {
          if (vm.selectedLugar.retirar > 0) {
            if (vm.selectedLugar.saldo - vm.selectedLugar.retirar < vm.selectedLugar.descubierto) {
              toastr.error('No puede retirar más de $ ' + GlobalHelpers.formatMoney(vm.selectedLugar.saldo))
              return false
            }
            vm.ajax = true
            $http.patch(ENV_VARS.apiUrl + 'lugar/' + vm.selectedLugar.id, {
              saldo: true,
              tipo: 'retirar',
              importe: vm.selectedLugar.retirar
            }).then(function () {
              toastr.success('Correcto')
              vm.selectedLugar.retirar = null
            }).catch(function (error) {
              toastr.error(error.data.mensaje || 'Error')
            }).finally(function () {
              vm.ajax = false
            })
          }
        }

        vm.doRetirarGrupo = doRetirarGrupo

        function doDescubiertoAgente () {
          vm.ajax = true
          $http.patch(ENV_VARS.apiUrl + 'user/' + vm.selectedAgente.id, {
            descubierto: vm.selectedAgente.descubierto
          }).then(function () {
            toastr.success('Correcto')
          }).catch(function () {
            toastr.error('Error')
          }).finally(function () {
            vm.ajax = false
          })
        }

        vm.doDescubiertoAgente = doDescubiertoAgente

        function doEstablecerAgente () {
          vm.ajax = true
          $http.patch(ENV_VARS.apiUrl + 'user/' + vm.selectedAgente.id, {
            saldo: true,
            tipo: 'establecer',
            importe: vm.selectedAgente.establecer
          }).then(function () {
            toastr.success('Correcto')
            vm.selectedAgente.establecer = null
          }).catch(function () {
            toastr.error('Error')
          }).finally(function () {
            vm.ajax = false
          })
        }

        vm.doEstablecerAgente = doEstablecerAgente

        function doRecargarAgente () {
          vm.ajax = true
          $http.patch(ENV_VARS.apiUrl + 'user/' + vm.selectedAgente.id, {
            saldo: true,
            tipo: 'recargar',
            importe: vm.selectedAgente.recargar
          }).then(function () {
            toastr.success('Correcto')
            vm.selectedAgente.recargar = null
          }).catch(function () {
            toastr.error('Error')
          }).finally(function () {
            vm.ajax = false
          })
        }

        vm.doRecargarAgente = doRecargarAgente

        function doRetirarAgente () {
          if (vm.selectedAgente.retirar > 0) {
            if (vm.selectedAgente.saldo - vm.selectedAgente.retirar < vm.selectedAgente.descubierto) {
              toastr.error('No puede retirar más de $ ' + GlobalHelpers.formatMoney(vm.selectedAgente.saldo))
              return false
            }
            vm.ajax = true
            $http.patch(ENV_VARS.apiUrl + 'user/' + vm.selectedAgente.id, {
              saldo: true,
              tipo: 'retirar',
              importe: vm.selectedAgente.retirar
            }).then(function () {
              toastr.success('Correcto')
              vm.selectedAgente.retirar = null
            }).catch(function (error) {
              toastr.error(error.data.mensaje || 'Error')
            }).finally(function () {
              vm.ajax = false
            })
          }
        }

        vm.doRetirarAgente = doRetirarAgente
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('TarifasController', TarifasController);

    function TarifasController ($http, $uibModal, ENV_VARS, GlobalHelpers, toastr) {

        var vm = this;

        vm.ajax = false;

        vm.GlobalHelpers = GlobalHelpers;

        function ensureIntervalosArray (entidad) {
            if (!entidad) {
                return;
            }
            if (!Array.isArray(entidad.intervalos)) {
                entidad.intervalos = [];
            }
        }

        function normalizeIntervalosEnGrupos (grupos) {
            if (!grupos) {
                return;
            }
            angular.forEach(grupos, function (filas) {
                if (angular.isArray(filas)) {
                    angular.forEach(filas, ensureIntervalosArray);
                } else {
                    ensureIntervalosArray(filas);
                }
            });
        }

        $http.get(ENV_VARS.apiUrl + 'tarifa').then(function (response) {
            vm.tarifas = response.data.tarifas;
            normalizeIntervalosEnGrupos(vm.tarifas);
            GlobalHelpers.selectRefresh('#tarifaSelect');
        });

        $http.get(ENV_VARS.apiUrl + 'tipo').then(function (response) {
            vm.tipos = response.data.tipos;
        });

        function updateTarifas (tarifa) {
            vm.ajax = true;
            vm.selectedTarifa.forEach(function (tarifa, index, array) {
                $http.patch(ENV_VARS.apiUrl + 'tarifa/' + tarifa.id, tarifa).then(function (response) {
                    if (index == array.length - 1) {
                        // vm.tarifas = response.data.tarifas;
                        toastr.success('Tarifas guardadas correctamente');
                        vm.ajax = false;
                    }
                });
            });
        }

        vm.updateTarifas = updateTarifas;

        function agregarIntervaloModal (tarifa) {
            ensureIntervalosArray(tarifa);
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/tarifas/modals/agregarIntervalo.html',
                size: 'md',
                controllerAs: 'vm',
                controller: function ($http, $uibModalInstance) {
                    var vm = this;

                    function agregarIntervalo () {
                        ensureIntervalosArray(tarifa);
                        tarifa.intervalos.push({
                            minimo: vm.minimo,
                            maximo: vm.maximo,
                            valor: vm.valor
                        });
                        $uibModalInstance.close();
                    }

                    vm.agregarIntervalo = agregarIntervalo;
                }
            });
        }

        vm.agregarIntervaloModal = agregarIntervaloModal;

        function editarIntervaloModal (intervalo) {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/tarifas/modals/editarIntervalo.html',
                size: 'md',
                controllerAs: 'vm',
                controller: function ($http, $uibModalInstance) {
                    var vm = this;

                    vm.intervalo = intervalo;

                    function editarIntervalo () {
                        intervalo.minimo = vm.minimo;
                        intervalo.maximo = vm.maximo;
                        intervalo.valor = vm.valor;
                        $uibModalInstance.close();
                    }

                    vm.editarIntervalo = editarIntervalo;
                }
            });
        }

        vm.editarIntervaloModal = editarIntervaloModal;

        function nuevaTarifaModal () {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/tarifas/modals/nuevaTarifa.html',
                resolve: {
                    parent: function () { return vm }
                },
                size: 'md',
                controllerAs: 'vm',
                controller: function (parent, $http, $uibModalInstance) {
                    var vm = this;

                    function nuevaTarifa () {
                        $http.post(ENV_VARS.apiUrl + 'tarifa', {
                            nombre: vm.nombre
                        }).then(function (response) {
                            parent.tarifas = response.data.tarifas;
                            normalizeIntervalosEnGrupos(parent.tarifas);
                            GlobalHelpers.selectRefresh('#tarifaSelect');
                            $uibModalInstance.close();
                        });
                    }

                    vm.nuevaTarifa = nuevaTarifa;
                }
            });
        }

        vm.nuevaTarifaModal = nuevaTarifaModal;

        function eliminarTarifa () {
            if (!vm.selectedTarifa || !vm.selectedTarifa.length) {
                toastr.warning('Seleccioná una tarifa');
                return;
            }
            var nombre = vm.selectedTarifa[0].nombre;
            if (!window.confirm('¿Eliminar la tarifa "' + nombre + '"?')) {
                return;
            }
            vm.ajax = true;
            $http.delete(ENV_VARS.apiUrl + 'tarifa-grupo', {
                params: { nombre: nombre, confirm: 0 }
            }).then(function (res) {
                if (res.data.needs_confirm) {
                    $uibModal.open({
                        animation: true,
                        backdrop: 'static',
                        templateUrl: 'app/pages/turf/modals/eliminarConfigGrupo.html',
                        size: 'md',
                        controllerAs: 'vm',
                        resolve: {
                            referencias: function () {
                                return res.data.referencias;
                            },
                            nombre: function () {
                                return nombre;
                            },
                            parent: function () {
                                return vm;
                            }
                        },
                        controller: ['$http', '$uibModalInstance', 'ENV_VARS', 'referencias', 'nombre', 'parent', 'GlobalHelpers', 'toastr',
                            function ($http, $uibModalInstance, ENV_VARS, referencias, nombre, parent, GlobalHelpers, toastr) {
                                var m = this;
                                m.nombre = nombre;
                                m.referencias = referencias;
                                m.ajax = false;
                                m.ejecutar = function () {
                                    m.ajax = true;
                                    $http.delete(ENV_VARS.apiUrl + 'tarifa-grupo', {
                                        params: { nombre: nombre, confirm: 1 }
                                    }).then(function (r2) {
                                        parent.tarifas = r2.data.tarifas;
                                        normalizeIntervalosEnGrupos(parent.tarifas);
                                        parent.selectedTarifa = null;
                                        toastr.success('Tarifa eliminada');
                                        GlobalHelpers.selectRefresh('#tarifaSelect');
                                        $uibModalInstance.close();
                                    }, function () {
                                        toastr.error('No se pudo eliminar la tarifa');
                                    }).finally(function () {
                                        m.ajax = false;
                                    });
                                };
                            }]
                    });
                    return;
                }
                if (res.data.success) {
                    vm.tarifas = res.data.tarifas;
                    normalizeIntervalosEnGrupos(vm.tarifas);
                    vm.selectedTarifa = null;
                    toastr.success('Tarifa eliminada');
                    GlobalHelpers.selectRefresh('#tarifaSelect');
                }
            }, function (res) {
                if (res.status === 404) {
                    toastr.error('Tarifa no encontrada');
                } else if (res.data && res.data.error === 'nombre_vacio') {
                    toastr.error('Nombre inválido');
                } else {
                    toastr.error('No se pudo eliminar la tarifa');
                }
            }).finally(function () {
                vm.ajax = false;
            });
        }

        vm.eliminarTarifa = eliminarTarifa;

        vm.keyListener = function (e) {
            if (e.keyCode == 38 || e.keyCode == 40) {
                e.preventDefault();
                var focusedId = document.activeElement.id;
                var split = focusedId.split('-');
                angular.element('#' + split[0] + '-' + (e.keyCode == 38 ? (parseInt(split[1]) - 1) : (parseInt(split[1]) + 1)))[0].focus();
            }
            if (e.keyCode == 37 || e.keyCode == 39) {
                e.preventDefault();
                var focusedId = document.activeElement.id;
                var split = focusedId.split('-');
                angular.element('#' + (e.keyCode == 37 ? (parseInt(split[0]) - 1) : (parseInt(split[0]) + 1)) + '-' + split[1])[0].focus();
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('TotalesController', TotalesController);

    function TotalesController ($http, $location, $scope, $timeout, ENV_VARS, GlobalHelpers, SessionService, TurfSocket) {

        var vm = this;
        vm.ready = false;
        vm.readyCount = 0;

        vm.update = false;

        TurfSocket.removeAllListeners("TurfSocket:App\\Events\\NuevaApuesta");
        TurfSocket.on("TurfSocket:App\\Events\\NuevaApuesta", function (data) {
            if ($location.path() == '/turf/totales') {
                if (vm.update) {
                    if (data.carrera.id == vm.carrera.id) {
                        vm.getApuestas();
                    }
                }
            }
        });

        vm.readyMaker = function () {
            vm.readyCount++;
            if (vm.readyCount == 3) {
                vm.ready = true;
            }
        };

        vm.getJornada = function (success) {
            $http.get(ENV_VARS.apiUrl + 'jornada', {
                params: {
                    to: 'pasado'
                }
            }).then(success);
        };

        vm.getApuestas = function () {
            $http.get(ENV_VARS.apiUrl + 'apuesta', {
                params: {
                    jidf: vm.jornadaDesde ? vm.jornadaDesde.id : null,
                    jidt: vm.jornadaHasta ? vm.jornadaHasta.id : null,
                    rid: vm.carrera ? vm.carrera.id : null,
                    uid: vm.user ? vm.user.id : null,
                    lid: vm.lugar ? vm.lugar.id : null,
                    cid: vm.cliente ? vm.cliente.id : null,
                    g: true
                }
            }).then(function (response) {
                vm.apuestas = response.data.apuestas;
                vm.total = response.data.total;
            });
        };

        $http.get(ENV_VARS.apiUrl + 'user', {
            params: {
                t: SessionService.currentUser.tipo == 'empleado' ? 'empleado' : 'superadmin-admin-empleado'
            }
        }).then(function (response) {
            vm.users = response.data.users;
            // vm.user = vm.users[GlobalHelpers.findWithAttr(vm.users, 'id', SessionService.currentUser.id)];
            GlobalHelpers.selectRefresh('#userSelect');
            vm.readyMaker();
        });

        $http.get(ENV_VARS.apiUrl + 'lugar').then(function (response) {
            vm.lugares = response.data.lugares;
            // vm.lugar = vm.lugares[GlobalHelpers.findWithAttr(vm.lugares, 'id', SessionService.lugar.id)];
            GlobalHelpers.selectRefresh('#lugarSelect');
            $http.get(ENV_VARS.apiUrl + 'cliente', {
                params: {
                    lid: vm.lugar ? vm.lugar.id : null
                }
            }).then(function (response) {
                vm.clientes = response.data.clientes;
                GlobalHelpers.selectRefresh('#clienteSelect');
                vm.readyMaker();
            });
        });

        vm.getJornada(function (response) {
            vm.jornadas = response.data.jornadas;
            vm.jornadaDesde = vm.jornadas[0];
            vm.jornadaHasta = vm.jornadas[0];
            vm.jornada = vm.jornadas[0];
            GlobalHelpers.selectRefresh('#jornadaDesdeSelect');
            GlobalHelpers.selectRefresh('#jornadaHastaSelect');
            if (vm.jornada) {
                for (var i = 0; i < vm.jornada.carreras.length; i++) {
                    if (vm.jornada.carreras[i].abierta) {
                        vm.carrera = vm.jornada.carreras[i];
                        break;
                    } else {
                        vm.carrera = vm.jornada.carreras[vm.jornada.carreras.length - 1];
                    }
                }
            }
            GlobalHelpers.selectRefresh('#carreraSelect');
            vm.readyMaker();
        });

        vm.filterChange = function (campo) {
            vm.combinations = undefined;
            vm.apuestas = undefined;
            vm.total = 0;
            GlobalHelpers.selectRefresh('select');
            switch (campo) {
                case 'jornada':
                    if (vm.jornadaDesde == vm.jornadaHasta) {
                        vm.jornada = vm.jornadaDesde;
                    } else {
                        vm.jornada = undefined;
                    }
                    GlobalHelpers.selectRefresh('#carreraSelect');
                    break;
                case 'carrera':
                    $http.get(ENV_VARS.apiUrl + 'user', {
                        params: {
                            rid: vm.carrera ? vm.carrera.id : null
                        }
                    }).then(function (response) {
                        vm.users = response.data.users;
                        GlobalHelpers.selectRefresh('#userSelect');
                    });
                    $http.get(ENV_VARS.apiUrl + 'lugar', {
                        params: {
                            rid: vm.carrera ? vm.carrera.id : null
                        }
                    }).then(function (response) {
                        vm.lugares = response.data.lugares;
                        GlobalHelpers.selectRefresh('#lugarSelect');
                    });
                    $http.get(ENV_VARS.apiUrl + 'cliente', {
                        params: {
                            rid: vm.carrera ? vm.carrera.id : null
                        }
                    }).then(function (response) {
                        vm.clientes = response.data.clientes;
                        GlobalHelpers.selectRefresh('#clienteSelect');
                    });
                    break;
                case 'user':
                    $http.get(ENV_VARS.apiUrl + 'lugar', {
                        params: {
                            rid: vm.carrera ? vm.carrera.id : null,
                            uid: vm.user ? vm.user.id : null
                        }
                    }).then(function (response) {
                        vm.lugares = response.data.lugares;
                        GlobalHelpers.selectRefresh('#lugarSelect');
                    });
                    $http.get(ENV_VARS.apiUrl + 'cliente', {
                        params: {
                            rid: vm.carrera ? vm.carrera.id : null,
                            uid: vm.user ? vm.user.id : null
                        }
                    }).then(function (response) {
                        vm.clientes = response.data.clientes;
                        GlobalHelpers.selectRefresh('#clienteSelect');
                    });
                    break;
                case 'lugar':
                    $http.get(ENV_VARS.apiUrl + 'cliente', {
                        params: {
                            rid: vm.carrera ? vm.carrera.id : null,
                            uid: vm.user ? vm.user.id : null,
                            lid: vm.lugar ? vm.lugar.id : null
                        }
                    }).then(function (response) {
                        vm.clientes = response.data.clientes;
                    });
                    break;
                case 'cliente':
                    break;
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.turf')
        .controller('UsuariosController', UsuariosController);

    function UsuariosController($http, $uibModal, ENV_VARS, GlobalHelpers, SessionService, toastr) {

        var vm = this;
        vm.ready = false;
        vm.readyCount = 0;
        vm.ajax = false

        vm.readyMaker = function () {
            vm.readyCount++;
            if (vm.readyCount == 3) {
                vm.ready = true;
            }
        };

        GlobalHelpers.selectRefresh('#tipoSelect');
        vm.SessionService = SessionService;

        $http.get(ENV_VARS.apiUrl + 'user', {
            params: {
                t: 'superadmin-admin-empleado-agente'
            }
        }).then(function (response) {
            vm.users = response.data.users;
            vm.readyMaker();
        });

        $http.get(ENV_VARS.apiUrl + 'lugar').then(function (response) {
            vm.lugares = response.data.lugares;
            vm.lugaresParticulares = []
            for (var i = 0; i < vm.lugares.length; i++) {
              if (vm.lugares[i].particular) vm.lugaresParticulares.push(vm.lugares[i])
            }
            GlobalHelpers.selectRefresh('#lugarSelect');
            GlobalHelpers.selectRefresh('#lugarParaAgenteSelect');
            GlobalHelpers.selectRefresh('#lugarParaMostrarSelect');
            vm.readyMaker();
        });

        $http.get(ENV_VARS.apiUrl + 'user', {
            params: {
                t: 'particular'
            }
        }).then(function (response) {
            vm.particulares = response.data.users;
            if (SessionService.currentUser.tipo === 'agente') {
              vm.tipo = 'particular'
              vm.lugarParaAgente = SessionService.lugar
              vm.lugarParaMostrar = SessionService.lugar
              vm.lugarParaMostrarChange()
              GlobalHelpers.selectRefresh('select')
            }
            vm.readyMaker();
        });

        vm.getLugarClientes = function () {
            $http.get(ENV_VARS.apiUrl + 'cliente', {
                params: {
                    lid: vm.lugar.id
                }
            }).then(function (response) {
                vm.lugar.clientes = response.data.clientes;
            });
        };

        vm.addUser = function () {
            $http.post(ENV_VARS.apiUrl + 'user', {
                username: vm.username,
                password: vm.password,
                tipo: vm.tipo,
                lugar_id: vm.lugarParaAgente ? vm.lugarParaAgente.id : null
            }).then(function(response) {
                vm.username = '';
                vm.password = '';
                if (SessionService.currentUser.tipo !== 'agente') {
                  vm.tipo = '';
                  vm.lugarParaAgente = '';
                  vm.users = response.data.users;
                  $http.get(ENV_VARS.apiUrl + 'lugar').then(function (response) {
                      SessionService.lugares = response.data.lugares;
                      GlobalHelpers.selectRefresh('select');
                      SessionService.initSaldos();
                  });
                } else {
                  var cliente = response.data.user.cliente
                  SessionService.initSaldoCliente(cliente)
                  SessionService.lugar.clientes.push(cliente)
                  vm.particulares = response.data.users
                  vm.lugarParaMostrarChange()
                }

            });
        };

        vm.deleteUser = function (user) {
          if (confirm('Confirme que desea eliminar el usuario ' + user.username)) {
            $http.delete(ENV_VARS.apiUrl + 'user/' + user.id).then(function (response) {
                if (user.tipo == 'particular') {
                    vm.particulares = response.data.users;
                    vm.lugarParaMostrarChange()
                } else {
                    vm.users = response.data.users;
                }
            });
          }
        };

        function showChangePassword (user) {
            $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/pages/turf/usuarios/modals/changePassword.html',
                size: 'md',
                controllerAs: 'vm',
                controller: function ($http, $uibModalInstance) {
                    var vm = this;

                    vm.user = user

                    function changePassword () {
                        $http.patch(ENV_VARS.apiUrl + 'user/' + user.id, {
                          password: vm.password
                        }).then(function (response) {
                          toastr.success('Contraseña modificada');
                        }).catch(function (error) {
                          console.log(error)
                          toastr.error('Hubo un error, vuelva a intentar');
                        }).finally(function () {
                          $uibModalInstance.close();
                        })
                    }

                    vm.changePassword = changePassword;
                }
            });
        }

        vm.showChangePassword = showChangePassword;

        function lugarParaMostrarChange () {
          vm.particularesFiltrados = []
          for (var i = 0; i < vm.particulares.length; i++) {
            if (vm.particulares[i].cliente && vm.particulares[i].cliente.lugar_id == vm.lugarParaMostrar.id) vm.particularesFiltrados.push(vm.particulares[i])
          }
        }

        vm.lugarParaMostrarChange = lugarParaMostrarChange;
    }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService, SessionService) {
    $scope.SessionService = SessionService;

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 0;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed, optClickEvent) {
          // Same click must not trigger baSidebar's window listener (closes menu ~10ms later).
          if (optClickEvent && optClickEvent.originalEvent) {
            optClickEvent.originalEvent.$sidebarEventProcessed = true;
          }
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                  itemFor: s.itemFor
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/*
 * $Id: combinatorics.js,v 0.25 2013/03/11 15:42:14 dankogai Exp dankogai $
 *
 *  Licensed under the MIT license.
 *  http://www.opensource.org/licenses/mit-license.php
 *
 *  References:
 *    http://www.ruby-doc.org/core-2.0/Array.html#method-i-combination
 *    http://www.ruby-doc.org/core-2.0/Array.html#method-i-permutation
 *    http://en.wikipedia.org/wiki/Factorial_number_system
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define([], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.Combinatorics = factory();
    }
}(this, function () {
    'use strict';
    var version = "0.5.5";
    /* combinatory arithmetics */
    var P = function(m, n) {
        if (n % 1 !== 0) throw new RangeError;
        var p = 1;
        while (n--) p *= m--;
        return p;
    };
    var C = function(m, n) {
        if (n > m) {
            return 0;
        }
        return P(m, n) / P(n, n);
    };
    var factorial = function(n) {
        return P(n, n);
    };
    var factoradic = function(n, d) {
        var f = 1;
        if (!d) {
            for (d = 1; f < n; f *= ++d);
            if (f > n) f /= d--;
        } else {
            f = factorial(d);
        }
        var result = [0];
        for (; d; f /= d--) {
            result[d] = Math.floor(n / f);
            n %= f;
        }
        return result;
    };
    /* common methods */
    var addProperties = function(dst, src) {
        Object.keys(src).forEach(function(p) {
            Object.defineProperty(dst, p, {
                value: src[p],
                configurable: p == 'next'
            });
        });
    };
    var hideProperty = function(o, p) {
        Object.defineProperty(o, p, {
            writable: true
        });
    };
    var toArray = function(f) {
        var e, result = [];
        this.init();
        while (e = this.next()) result.push(f ? f(e) : e);
        this.init();
        return result;
    };
    var common = {
        toArray: toArray,
        map: toArray,
        forEach: function(f) {
            var e;
            this.init();
            while (e = this.next()) f(e);
            this.init();
        },
        filter: function(f) {
            var e, result = [];
            this.init();
            while (e = this.next()) if (f(e)) result.push(e);
            this.init();
            return result;
        },
        find: function(f) {
            var e, result;
            this.init();
            while (e = this.next()) {
                if (f(e)) {
                    result = e;
                    break;
                }
            }
            this.init();
            return result;
        },
        reduce: function(reducer, result) {
            // return this.toArray().reduce(reducer, init);
            this.init();
            var index = 0;
            if (arguments.length < 2) {
                result = this.next();
                index += 1;
            }
            var length = this.length;
            while(index < length) {
                result = reducer(result, this.next(), index, this);
                index += 1;
            }
            return result;
        },
        lazyMap: function(f) {
            this._lazyMap = f;
            return this;
        },
        lazyFilter: function(f) {
            Object.defineProperty(this, 'next', {
                writable: true
            });
            if (typeof f !== 'function') {
                this.next = this._next;
            } else {
                if (typeof (this._next) !== 'function') {
                    this._next = this.next;
                }
                var _next = this._next.bind(this);
                this.next = (function() {
                    var e;
                    while (e = _next()) {
                        if (f(e))
                            return e;
                    }
                    return e;
                }).bind(this);
            }
            Object.defineProperty(this, 'next', {
                writable: false
            });
            return this;
        }

    };
    /* power set */
    var power = function(ary, fun) {
        var size = 1 << ary.length,
            sizeOf = function() {
                return size;
            },
            that = Object.create(ary.slice(), {
                length: {
                    get: sizeOf
                }
            });
        hideProperty(that, 'index');
        addProperties(that, {
            valueOf: sizeOf,
            init: function() {
                that.index = 0;
            },
            nth: function(n) {
                if (n >= size) return;
                var i = 0,
                    result = [];
                for (; n; n >>>= 1, i++) if (n & 1) result.push(this[i]);
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            },
            next: function() {
                return this.nth(this.index++);
            }
        });
        addProperties(that, common);
        that.init();
        return (typeof (fun) === 'function') ? that.map(fun) : that;
    };
    /* combination */
    var nextIndex = function(n) {
        var smallest = n & -n,
            ripple = n + smallest,
            new_smallest = ripple & -ripple,
            ones = ((new_smallest / smallest) >> 1) - 1;
        return ripple | ones;
    };
    var combination = function(ary, nelem, fun) {
        if (!nelem) nelem = ary.length;
        if (nelem < 1) throw new RangeError;
        if (nelem > ary.length) throw new RangeError;
        var first = (1 << nelem) - 1,
            size = C(ary.length, nelem),
            maxIndex = 1 << ary.length,
            sizeOf = function() {
                return size;
            },
            that = Object.create(ary.slice(), {
                length: {
                    get: sizeOf
                }
            });
        hideProperty(that, 'index');
        addProperties(that, {
            valueOf: sizeOf,
            init: function() {
                this.index = first;
            },
            next: function() {
                if (this.index >= maxIndex) return;
                var i = 0,
                    n = this.index,
                    result = [];
                for (; n; n >>>= 1, i++) {
                    if (n & 1) result[result.length] = this[i];
                }

                this.index = nextIndex(this.index);
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            }
        });
        addProperties(that, common);
        that.init();
        return (typeof (fun) === 'function') ? that.map(fun) : that;
    };
    /* bigcombination */
    var bigNextIndex = function(n, nelem) {

        var result = n;
        var j = nelem;
        var i = 0;
        for (i = result.length - 1; i >= 0; i--) {
            if (result[i] == 1) {
                j--;
            } else {
                break;
            }
        } 
        if (j == 0) {
            // Overflow
            result[result.length] = 1;
            for (var k = result.length - 2; k >= 0; k--) {
                result[k] = (k < nelem-1)?1:0;
            }
        } else {
            // Normal

            // first zero after 1
            var i1 = -1;
            var i0 = -1;
            for (var i = 0; i < result.length; i++) {
                if (result[i] == 0 && i1 != -1) {
                    i0 = i;
                }
                if (result[i] == 1) {
                    i1 = i;
                }
                if (i0 != -1 && i1 != -1) {
                    result[i0] = 1;
                    result[i1] = 0;
                    break;
                }
            }

            j = nelem;
            for (var i = result.length - 1; i >= i1; i--) {
                if (result[i] == 1)
                    j--;
            }
            for (var i = 0; i < i1; i++) {
                result[i] = (i < j)?1:0;
            }
        }

        return result;

    };
    var buildFirst = function(nelem) {
        var result = [];
        for (var i = 0; i < nelem; i++) {
            result[i] = 1;
        }
        result[0] = 1;
        return result;
    };
    var bigCombination = function(ary, nelem, fun) {
        if (!nelem) nelem = ary.length;
        if (nelem < 1) throw new RangeError;
        if (nelem > ary.length) throw new RangeError;
        var first = buildFirst(nelem),
            size = C(ary.length, nelem),
            maxIndex = ary.length,
            sizeOf = function() {
                return size;
            },
            that = Object.create(ary.slice(), {
                length: {
                    get: sizeOf
                }
            });
        hideProperty(that, 'index');
        addProperties(that, {
            valueOf: sizeOf,
            init: function() {
                this.index = first.concat();
            },
            next: function() {
                if (this.index.length > maxIndex) return;
                var i = 0,
                    n = this.index,
                    result = [];
                for (var j = 0; j < n.length; j++, i++) {
                    if (n[j])
                        result[result.length] = this[i];
                }
                bigNextIndex(this.index, nelem);
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            }
        });
        addProperties(that, common);
        that.init();
        return (typeof (fun) === 'function') ? that.map(fun) : that;
    };
    /* permutation */
    var _permutation = function(ary) {
        var that = ary.slice(),
            size = factorial(that.length);
        that.index = 0;
        that.next = function() {
            if (this.index >= size) return;
            var copy = this.slice(),
                digits = factoradic(this.index, this.length),
                result = [],
                i = this.length - 1;
            for (; i >= 0; --i) result.push(copy.splice(digits[i], 1)[0]);
            this.index++;
            return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
        };
        return that;
    };
    // which is really a permutation of combination
    var permutation = function(ary, nelem, fun) {
        if (!nelem) nelem = ary.length;
        if (nelem < 1) throw new RangeError;
        if (nelem > ary.length) throw new RangeError;
        var size = P(ary.length, nelem),
            sizeOf = function() {
                return size;
            },
            that = Object.create(ary.slice(), {
                length: {
                    get: sizeOf
                }
            });
        hideProperty(that, 'cmb');
        hideProperty(that, 'per');
        addProperties(that, {
            valueOf: function() {
                return size;
            },
            init: function() {
                /* combination can only be used for less than 31 elements */
                if (ary.length < 31) {
                    this.cmb = combination(ary, nelem);
                } else {
                    this.cmb = bigCombination(ary, nelem);
                }
                
                this.per = _permutation(this.cmb.next());
            },
            next: function() {
                var result = this.per.next();
                if (!result) {
                    var cmb = this.cmb.next();
                    if (!cmb) return;
                    this.per = _permutation(cmb);
                    return this.next();
                }
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            }
        });
        addProperties(that, common);
        that.init();
        return (typeof (fun) === 'function') ? that.map(fun) : that;
    };

    var PC = function(m) {
        var total = 0;
        for (var n = 1; n <= m; n++) {
            var p = P(m,n);
            total += p;
        };
        return total;
    };
    // which is really a permutation of combination
    var permutationCombination = function(ary, fun) {
        // if (!nelem) nelem = ary.length;
        // if (nelem < 1) throw new RangeError;
        // if (nelem > ary.length) throw new RangeError;
        var size = PC(ary.length),
            sizeOf = function() {
                return size;
            },
            that = Object.create(ary.slice(), {
                length: {
                    get: sizeOf
                }
            });
        hideProperty(that, 'cmb');
        hideProperty(that, 'per');
        hideProperty(that, 'nelem');
        addProperties(that, {
            valueOf: function() {
                return size;
            },
            init: function() {
                this.nelem = 1;
                // console.log("Starting nelem: " + this.nelem);
                this.cmb = combination(ary, this.nelem);
                this.per = _permutation(this.cmb.next());
            },
            next: function() {
                var result = this.per.next();
                if (!result) {
                    var cmb = this.cmb.next();
                    if (!cmb) {
                        this.nelem++;
                        // console.log("increment nelem: " + this.nelem + " vs " + ary.length);
                        if (this.nelem > ary.length) return;
                        this.cmb = combination(ary, this.nelem);
                        cmb = this.cmb.next();
                        if (!cmb) return;
                    }
                    this.per = _permutation(cmb);
                    return this.next();
                }
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            }
        });
        addProperties(that, common);
        that.init();
        return (typeof (fun) === 'function') ? that.map(fun) : that;
    };
    /* Cartesian Product */
    var arraySlice = Array.prototype.slice;
    var cartesianProduct = function() {
        if (!arguments.length) throw new RangeError;
        var args = arraySlice.call(arguments),
            size = args.reduce(function(p, a) {
                return p * a.length;
            }, 1),
            sizeOf = function() {
                return size;
            },
            dim = args.length,
            that = Object.create(args, {
                length: {
                    get: sizeOf
                }
            });
        if (!size) throw new RangeError;
        hideProperty(that, 'index');
        addProperties(that, {
            valueOf: sizeOf,
            dim: dim,
            init: function() {
                this.index = 0;
            },
            get: function() {
                if (arguments.length !== this.length) return;
                var result = [],
                    d = 0;
                for (; d < dim; d++) {
                    var i = arguments[d];
                    if (i >= this[d].length) return;
                    result.push(this[d][i]);
                }
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            },
            nth: function(n) {
                var result = [],
                    d = 0;
                for (; d < dim; d++) {
                    var l = this[d].length;
                    var i = n % l;
                    result.push(this[d][i]);
                    n -= i;
                    n /= l;
                }
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            },
            next: function() {
                if (this.index >= size) return;
                var result = this.nth(this.index);
                this.index++;
                return result;
            }
        });
        addProperties(that, common);
        that.init();
        return that;
    };
    /* baseN */
    var baseN = function(ary, nelem, fun) {
                if (!nelem) nelem = ary.length;
        if (nelem < 1) throw new RangeError;
        var base = ary.length,
                size = Math.pow(base, nelem);
        var sizeOf = function() {
                return size;
            },
            that = Object.create(ary.slice(), {
                length: {
                    get: sizeOf
                }
            });
        hideProperty(that, 'index');
        addProperties(that, {
            valueOf: sizeOf,
            init: function() {
                that.index = 0;
            },
            nth: function(n) {
                if (n >= size) return;
                var result = [];
                for (var i = 0; i < nelem; i++) {
                    var d = n % base;
                    result.push(ary[d])
                    n -= d; n /= base
                }
                return (typeof (that._lazyMap) === 'function')?that._lazyMap(result):result;
            },
            next: function() {
                return this.nth(this.index++);
            }
        });
        addProperties(that, common);
        that.init();
        return (typeof (fun) === 'function') ? that.map(fun) : that;
    };

    /* export */
    var Combinatorics = Object.create(null);
    addProperties(Combinatorics, {
        C: C,
        P: P,
        factorial: factorial,
        factoradic: factoradic,
        cartesianProduct: cartesianProduct,
        combination: combination,
        bigCombination: bigCombination,
        permutation: permutation,
        permutationCombination: permutationCombination,
        power: power,
        baseN: baseN,
        VERSION: version
    });
    return Combinatorics;
}));

'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "a. m.",
      "p. m."
    ],
    "DAY": [
      "domingo",
      "lunes",
      "martes",
      "mi\u00e9rcoles",
      "jueves",
      "viernes",
      "s\u00e1bado"
    ],
    "ERANAMES": [
      "antes de Cristo",
      "despu\u00e9s de Cristo"
    ],
    "ERAS": [
      "a. C.",
      "d. C."
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ],
    "SHORTDAY": [
      "dom.",
      "lun.",
      "mar.",
      "mi\u00e9.",
      "jue.",
      "vie.",
      "s\u00e1b."
    ],
    "SHORTMONTH": [
      "ene.",
      "feb.",
      "mar.",
      "abr.",
      "may.",
      "jun.",
      "jul.",
      "ago.",
      "sept.",
      "oct.",
      "nov.",
      "dic."
    ],
    "STANDALONEMONTH": [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, d 'de' MMMM 'de' y",
    "longDate": "d 'de' MMMM 'de' y",
    "medium": "d MMM y h:mm:ss a",
    "mediumDate": "d MMM y",
    "mediumTime": "h:mm:ss a",
    "short": "d/M/yy h:mm a",
    "shortDate": "d/M/yy",
    "shortTime": "h:mm a"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "$",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "es-ar",
  "localeID": "es_AR",
  "pluralCat": function(n, opt_precision) {  if (n == 1) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

angular.module("BlurAdmin").run(["$templateCache", function($templateCache) {$templateCache.put("app/pages/grupo.html","<div class=\"auth-main\" form-init=\"\"><div class=\"auth-block\"><form class=\"form-horizontal\" ng-submit=\"vm.doSetLugar()\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Grupo</label><div class=\"col-sm-10\"><select class=\"form-control selectpicker\" id=\"lugarSelect\" ng-model=\"vm.lugar\" ng-options=\"lugar as (lugar.nombre.toUpperCase() + (lugar.particular ? \' (P)\' : \'\')) for lugar in vm.SessionService.lugares | orderBy:\'nombre\'\" selectpicker=\"\" title=\"---\"><option data-hidden=\"true\"></option></select></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-default btn-auth\">Ingresar</button></div></div></form></div></div>");
$templateCache.put("app/pages/login.html","<div class=\"auth-main\" form-init=\"\"><div class=\"auth-block\"><form class=\"form-horizontal\" ng-submit=\"vm.doLogin()\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Usuario</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" placeholder=\"Usuario\" ng-model=\"vm.credencial.username\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Contraseña</label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" placeholder=\"Contraseña\" ng-model=\"vm.credencial.password\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-default btn-auth\" ng-disabled=\"vm.loggingIn\">Ingresar</button></div></div></form></div></div>");
$templateCache.put("app/pages/turf/apuestas/apuestas.html","<div id=\"apuestas\" ng-show=\"vm.ready\"><div style=\"margin-bottom: 4px; display: flex; justify-content: center;\"><a ng-click=\"vm.updateList()\" class=\"btn btn-lg btn-primary\" ng-disabled=\"vm.buscando || vm.ajax\" style=\"z-index: 1;\">BUSCAR</a></div><div class=\"apuestas-filters-backdrop visible-xs\" ng-show=\"vm.filtersOpen\" ng-click=\"vm.closeFiltersPanel()\"></div><div class=\"panel apuestas-panel\"><div class=\"panel-body\"><div class=\"apuestas-caption text-center\"><span class=\"pull-left\"><button class=\"btn btn-default btn-sm noprintable\" ng-click=\"(vm.update = !vm.update)\" ng-class=\"{ \'btn-success\': vm.update }\" ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\">ACTUALIZAR</button></span><select id=\"jornadaSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"---\" data-container=\"body\" ng-change=\"vm.updateFilters(true)\" ng-model=\"vm.jornada\" ng-options=\"jornada as (jornada.fecha + \' - \' + jornada.hipodromo.nombre.toUpperCase()) for jornada in vm.jornadas\"><option data-hidden=\"true\"></option></select><span class=\"pull-right\"><button class=\"btn btn-default btn-sm noprintable\" ng-click=\"vm.agruparCombinaciones = !vm.agruparCombinaciones\" ng-class=\"{ \'btn-success\': vm.agruparCombinaciones }\">COMPACTO</button></span></div><button type=\"button\" class=\"btn btn-default btn-block visible-xs noprintable apuestas-filters-toggle\" ng-click=\"vm.openFiltersPanel()\">Filtros</button><div class=\"apuestas-filters\" ng-class=\"{ \'apuestas-filters--open\': vm.filtersOpen }\"><div class=\"apuestas-filters-head visible-xs\"><strong>Filtros</strong> <button type=\"button\" class=\"close apuestas-filters-close\" ng-click=\"vm.closeFiltersPanel()\" aria-label=\"Cerrar\">&times;</button></div><div class=\"apuestas-filters-row apuestas-filters-row--controls\" ng-style=\"vm.getFiltersGridStyle()\"><div class=\"apuestas-filter-cell apuestas-filter-cell--carrera\"><label>CARRERA</label><div class=\"apuestas-filter-origen\"><button class=\"btn btn-default btn-sm noprintable\" ng-click=\"vm.origen = true\" ng-class=\"{ \'btn-success\': vm.origen }\" ng-disabled=\"vm.ajax\">ORIGEN</button> <button class=\"btn btn-default btn-sm noprintable\" ng-click=\"vm.origen = false\" ng-class=\"{ \'btn-success\': !vm.origen }\" ng-disabled=\"vm.ajax\">CIERRE</button></div><select id=\"carreraSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"CARRERA\" data-container=\"body\" ng-disabled=\"vm.ajax\" ng-change=\"vm.updateFilters()\" ng-model=\"vm.carrera\" ng-options=\"carrera as (carrera.orden + \'ª\') for carrera in vm.carreras\"><option value=\"\">TODAS</option></select><button type=\"button\" class=\"btn btn-default btn-sm noprintable apuestas-filter-agrupar visible-xs\" ng-click=\"vm.agruparCarreras = !vm.agruparCarreras\" ng-class=\"{ \'btn-success\': vm.agruparCarreras }\" ng-disabled=\"vm.ajax\">AGRUPAR</button></div><div class=\"apuestas-filter-cell\" ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\', \'agente\'])\"><label>USUARIO</label><select id=\"userSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"USUARIO\" data-container=\"body\" ng-disabled=\"vm.ajax\" ng-change=\"vm.updateFilters()\" ng-model=\"vm.user\" ng-options=\"user as user.username.toUpperCase() for user in vm.users | orderBy: \'username\'\"><option value=\"\">TODOS</option></select><button type=\"button\" class=\"btn btn-default btn-sm noprintable apuestas-filter-agrupar visible-xs\" ng-click=\"vm.agruparUsuarios = !vm.agruparUsuarios\" ng-class=\"{ \'btn-success\': vm.agruparUsuarios }\" ng-disabled=\"vm.ajax\">AGRUPAR</button></div><div class=\"apuestas-filter-cell\" ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\', \'agente\'])\"><label>GRUPO</label><select id=\"lugarSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"GRUPO\" data-container=\"body\" ng-disabled=\"vm.ajax\" ng-change=\"vm.updateFilters()\" ng-model=\"vm.lugar\" ng-options=\"lugar as lugar.nombre.toUpperCase() for lugar in vm.lugares | orderBy: \'nombre\'\"><option value=\"\">TODOS</option></select><button type=\"button\" class=\"btn btn-default btn-sm noprintable apuestas-filter-agrupar visible-xs\" ng-click=\"vm.agruparLugares = !vm.agruparLugares\" ng-class=\"{ \'btn-success\': vm.agruparLugares }\" ng-disabled=\"vm.ajax\">AGRUPAR</button></div><div class=\"apuestas-filter-cell\" ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\"><label>CLIENTE</label><select id=\"clienteSelect\" class=\"form-control selectpicker with-search select-filtro\" selectpicker=\"\" title=\"CLIENTE\" data-live-search=\"true\" data-container=\"body\" ng-disabled=\"vm.ajax\" ng-change=\"vm.updateFilters()\" ng-model=\"vm.cliente\" ng-options=\"cliente as cliente.nickname.toUpperCase() for cliente in vm.clientes | orderBy: \'nickname\'\"><option value=\"\">TODOS</option></select><button type=\"button\" class=\"btn btn-default btn-sm noprintable apuestas-filter-agrupar visible-xs\" ng-click=\"vm.agruparClientes = !vm.agruparClientes\" ng-class=\"{ \'btn-success\': vm.agruparClientes }\" ng-disabled=\"vm.ajax\">AGRUPAR</button></div><div class=\"apuestas-filter-cell\"><label>JUGADA</label><select id=\"tipoSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"JUGADA\" data-container=\"body\" ng-disabled=\"vm.ajax\" ng-change=\"vm.updateFilters()\" ng-model=\"vm.tipo\" ng-options=\"tipo as tipo.code.toUpperCase() for tipo in vm.tipos\"><option value=\"\">TODAS</option></select><button type=\"button\" class=\"btn btn-default btn-sm noprintable apuestas-filter-agrupar visible-xs\" ng-click=\"vm.agruparTipos = !vm.agruparTipos\" ng-class=\"{ \'btn-success\': vm.agruparTipos }\" ng-disabled=\"vm.ajax\">AGRUPAR</button></div><div class=\"apuestas-filter-cell apuestas-filter-cell--static hidden-xs\"><label>CREADA</label></div><div class=\"apuestas-filter-cell apuestas-filter-cell--static hidden-xs\"><label>ELIMINADA</label></div><div class=\"apuestas-filter-cell apuestas-filter-cell--static hidden-xs\"><label>TOTAL</label></div><div class=\"apuestas-filter-cell apuestas-filter-cell--static hidden-xs\"><label>PAGAR</label></div></div><div class=\"apuestas-filters-row apuestas-filters-row--agrupar hidden-xs\" ng-style=\"vm.getFiltersGridStyle()\"><div class=\"apuestas-filter-cell\"><button class=\"btn btn-default btn-sm noprintable\" ng-click=\"vm.agruparCarreras = !vm.agruparCarreras\" ng-class=\"{ \'btn-success\': vm.agruparCarreras }\" ng-disabled=\"vm.ajax\">AGRUPAR</button></div><div class=\"apuestas-filter-cell\" ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\', \'agente\'])\"><button class=\"btn btn-default btn-sm noprintable\" ng-click=\"vm.agruparUsuarios = !vm.agruparUsuarios\" ng-class=\"{ \'btn-success\': vm.agruparUsuarios }\" ng-disabled=\"vm.ajax\">AGRUPAR</button></div><div class=\"apuestas-filter-cell\" ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\', \'agente\'])\"><button class=\"btn btn-default btn-sm noprintable\" ng-click=\"vm.agruparLugares = !vm.agruparLugares\" ng-class=\"{ \'btn-success\': vm.agruparLugares }\" ng-disabled=\"vm.ajax\">AGRUPAR</button></div><div class=\"apuestas-filter-cell\" ng-if=\"vm.GlobalHelpers.hideFrom([\'particular\'])\"><button class=\"btn btn-default btn-sm noprintable\" ng-click=\"vm.agruparClientes = !vm.agruparClientes\" ng-class=\"{ \'btn-success\': vm.agruparClientes }\" ng-disabled=\"vm.ajax\">AGRUPAR</button></div><div class=\"apuestas-filter-cell\"><button class=\"btn btn-default btn-sm noprintable\" ng-click=\"vm.agruparTipos = !vm.agruparTipos\" ng-class=\"{ \'btn-success\': vm.agruparTipos }\" ng-disabled=\"vm.ajax\">AGRUPAR</button></div><div class=\"apuestas-filter-cell apuestas-filter-cell--empty hidden-xs\"></div><div class=\"apuestas-filter-cell apuestas-filter-cell--empty hidden-xs\"></div><div class=\"apuestas-filter-cell apuestas-filter-cell--empty hidden-xs\"></div><div class=\"apuestas-filter-cell apuestas-filter-cell--empty hidden-xs\"></div></div><div class=\"apuestas-filters-footer visible-xs\"><button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"vm.closeFiltersPanel()\">Listo</button></div></div><div class=\"apuestas-table-scroll\"><table class=\"table-hover apuestas-main-table\"><thead><tr class=\"apuestas-data-header-row visible-xs\"><th>CARRERA</th><th ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\', \'agente\'])\">USUARIO</th><th ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\', \'agente\'])\">GRUPO</th><th ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\">CLIENTE</th><th>JUGADA</th><th>CREADA</th><th>ELIMINADA</th><th>TOTAL</th><th>PAGAR</th></tr></thead><tbody><tr ng-if=\"!(vm.agruparCarreras || vm.agruparUsuarios || vm.agruparLugares || vm.agruparClientes || vm.agruparTipos)\" ng-repeat=\"combination in vm.data.combinations\" ng-class=\"vm.combinationClass(combination)\"><td><span>{{ combination.carrera.orden }}ª</span></td><td ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\', \'agente\'])\"><span>{{ combination.user.username.toUpperCase() }}</span></td><td ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\', \'agente\'])\"><span>{{ combination.cliente.lugar.nombre.toUpperCase() }}</span></td><td ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\"><span>{{ combination.cliente.nickname.toUpperCase() }}</span></td><td><span ng-show=\"vm.agruparCombinaciones\">{{ combination.string }}</span><table class=\"table-hover apuestas-detalle-table\" ng-hide=\"vm.agruparCombinaciones\"><tbody><tr ng-repeat=\"apuesta in combination.apuestas\"><td ng-if=\"!apuesta.vales\">{{ apuesta.caballos.join(\'.\') }} {{ apuesta.tipo_code.toUpperCase() }} $ <span ng-class=\"{ \'monto-negativo\': apuesta.importe < 0 }\">{{ apuesta.importe | money }}</span></td><td ng-if=\"apuesta.vales\">{{ apuesta.caballos.join(\'.\') }} TLE {{ apuesta.vales }} {{ apuesta.vales == 1 ? \'VALE\' : \'VALES\' }}</td></tr></tbody></table></td><td><span ng-if=\"combination.created_at\">{{ combination.created_at | date:\'dd/MM/yyyy HH:mm\' }}</span></td><td><span ng-if=\"combination.deleted_at\">{{ combination.deleted_at | date:\'dd/MM/yyyy HH:mm\' }}</span></td><td><span ng-if=\"!combination.deleted_at\" ng-class=\"{ \'monto-negativo\': combination.importe < 0 }\">{{ combination.importe | money }}</span></td><td><span ng-if=\"!combination.deleted_at\" ng-show=\"vm.agruparCombinaciones\" ng-class=\"{ \'monto-negativo\': combination.pagar < 0 }\">{{ combination.pagar | money }}</span><table class=\"table-hover apuestas-detalle-table\" ng-hide=\"vm.agruparCombinaciones\"><tbody><tr ng-repeat=\"apuesta in combination.apuestas\"><td><span ng-if=\"apuesta.pagar > 0\">$ {{ apuesta.pagar | money }}</span></td></tr></tbody></table></td></tr><tr ng-if=\"vm.agruparCarreras || vm.agruparUsuarios || vm.agruparLugares || vm.agruparClientes || vm.agruparTipos\" ng-repeat=\"group in vm.data.groups\"><td><span ng-if=\"group.orden\">{{ group.orden }}ª</span></td><td ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\'])\"><span>{{ group.username.toUpperCase() }}</span></td><td ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\'])\"><span>{{ group.nombre.toUpperCase() }}</span></td><td ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\"><span>{{ group.nickname.toUpperCase() }}</span></td><td><span>{{ group.code.toUpperCase() }}</span></td><td></td><td></td><td><span ng-class=\"{ \'monto-negativo\': group.importe < 0 }\">{{ group.importe | money }}</span></td><td><span ng-class=\"{ \'monto-negativo\': group.pagar < 0 }\">{{ group.pagar | money }}</span></td></tr><tr><td ng-repeat=\"i in vm.GlobalHelpers.makeArray(vm.cols[vm.SessionService.currentUser.tipo])\"></td><td><span ng-class=\"{ \'monto-negativo\': vm.data.total.combinations < 0 }\">{{ vm.data.total.combinations | money }}</span></td><td><span ng-class=\"{ \'monto-negativo\': vm.data.total.pagar < 0 }\">{{ vm.data.total.pagar | money }}</span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/pages/turf/carreras/carreras.html","<div class=\"turf-carreras\" ng-show=\"vm.ready\"><div class=\"row\"><div ba-panel=\"\" class=\"col-xs-12 col-md-6 col-md-offset-3 select-panel\"><select class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" ng-model=\"vm.jornada\" ng-change=\"vm.jornadaChange()\" ng-options=\"jornada as (jornada.fecha + \' - \' + jornada.hipodromo.nombre) for jornada in vm.jornadas\"></select></div></div><div ba-panel=\"\" class=\"carreras-panel\"><div class=\"carreras-table-scroll\"><table class=\"table table-bordered tabla-carreras\"><thead><tr><th class=\"carreras-col-orden\">Orden</th><th>Caballos</th><th>Múltiples</th><th>Ganador</th><th>Segundo</th><th>Tercero</th><th>Exacta</th><th>Imperfecta</th><th>Trifecta</th><th>Cuatrifecta</th><th>Doble</th><th>Triplo</th><th>Cuaterna</th><th>Pick 5</th><th>Pick 6</th><th>Triple</th></tr></thead><tbody><tr ng-repeat=\"carrera in vm.jornada.carreras\"><td class=\"carreras-col-orden\"><input type=\"text\" class=\"form-control\" value=\"{{ carrera.orden }}\" disabled=\"\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'0-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.caballos\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></td><td><select class=\"form-control multiples-select\" title=\"---\" selectpicker=\"\" multiple=\"\" ng-model=\"carrera.multiples\" ng-options=\"value for value in vm.GlobalHelpers.makeArray(carrera.caballos)\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></select></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'1-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.gan\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'2-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.seg\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'3-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.ter\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'4-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.exa\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'5-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.imp\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'6-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.trif\" ng-change=\"vm.trifInput(carrera)\" ng-model-options=\"{ debounce: 250 }\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'7-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.cuat\" ng-change=\"vm.cuatInput(carrera)\" ng-model-options=\"{ debounce: 250 }\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'8-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.dob\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'9-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.tlo\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'10-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.cna\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'11-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.pck5\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'12-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.pck6\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></td><td><input ng-keydown=\"vm.keyListener($event)\" id=\"{{ \'13-\' + $index }}\" type=\"number\" step=\"1\" min=\"0\" class=\"form-control\" ng-model=\"carrera.tle\" ng-change=\"\" ng-model-options=\"{ debounce: 250 }\"></td></tr></tbody></table></div><div class=\"carreras-actions button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.agregarCarrera()\" ng-disabled=\"vm.ajax\">+1</button> <button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.guardarCarreras()\" ng-disabled=\"vm.ajax\">GUARDAR</button></div></div></div>");
$templateCache.put("app/pages/turf/cierres/cierres.html","<div class=\"turf-cierres\" ng-show=\"vm.ready\"><div ba-panel=\"\" class=\"col-xs-12 col-md-offset-4 col-md-4\"><h4>{{ vm.jornada.fecha + \' - \' + vm.jornada.hipodromo.nombre }}</h4></div><div ba-panel=\"\" ba-panel-title=\"Carrera\" class=\"col-xs-12 col-md-offset-4 col-md-4 panel-carrera\"><div class=\"form-group carrera-select\"><select id=\"carreraSelect\" class=\"form-control selectpicker\" data-style=\"btn-default btn-lg\" selectpicker=\"\" title=\"---\" ng-model=\"vm.selectedCarrera\" ng-options=\"carrera as (carrera.orden + \'ª\') for carrera in vm.jornada.carreras\"><option data-hidden=\"true\"></option></select></div></div><div ba-panel=\"\" ba-panel-title=\"Cierre instantáneo\" class=\"col-xs-12 col-md-offset-4 col-md-4\" ng-show=\"!(vm.selectedCarrera.cerrando || !vm.selectedCarrera.abierta)\"><div class=\"button-wrapper btns-same-width-lg\"><button type=\"button\" class=\"btn btn-lg\" ng-click=\"vm.cerrarCarrera(vm.selectedCarrera)\" ng-class=\"vm.carreraStatus(vm.selectedCarrera)\">{{ vm.selectedCarrera.orden }}ª</button></div></div><div ba-panel=\"\" ba-panel-title=\"Cierre diferido\" class=\"col-xs-12 col-md-offset-4 col-md-4 panel-2\" ng-show=\"!(vm.selectedCarrera.cerrando || !vm.selectedCarrera.abierta)\"><div class=\"form-group time-select\"><select id=\"timeSelect\" class=\"form-control selectpicker\" data-style=\"btn-default btn-lg\" selectpicker=\"\" title=\"---\" ng-model=\"vm.closingTime\" ng-options=\"(time * 1000) as (time + \'s\') for time in [5, 10, 15, 20, 25, 30]\"><option data-hidden=\"true\"></option></select></div><div class=\"button-wrapper btns-same-width-lg\"><button type=\"button\" class=\"btn btn-lg\" ng-click=\"vm.cerrarCarreraDiferido(vm.selectedCarrera)\" ng-class=\"vm.carreraStatus(vm.selectedCarrera)\" ng-disabled=\"!vm.closingTime\">{{ vm.selectedCarrera.orden }}ª</button></div></div><div ba-panel=\"\" ba-panel-title=\"Abrir\" class=\"col-xs-12 col-md-offset-4 col-md-4 panel-3\" ng-show=\"vm.selectedCarrera.cerrando || !vm.selectedCarrera.abierta\"><div class=\"button-wrapper btns-same-width-lg\"><button type=\"button\" class=\"btn btn-lg btn-warning\" ng-click=\"vm.abrirCarrera(vm.selectedCarrera)\">{{ vm.selectedCarrera.orden }}ª</button></div></div></div>");
$templateCache.put("app/pages/turf/grupos/grupos.html","<div class=\"turf-grupos\" ng-show=\"vm.ready\"><div class=\"row\"><div ba-panel=\"\" class=\"col-xs-12 col-md-6 lugares-panel\"><select id=\"lugarSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" data-container=\"body\" ng-model=\"vm.lugar\" ng-change=\"vm.lugarChange()\" ng-options=\"lugar as (lugar.nombre.toUpperCase() + (lugar.particular ? \' (PARTICULAR)\' : \'\')) for lugar in vm.lugares\"><option data-hidden=\"true\"></option></select>&nbsp;<div class=\"grupos-nuevo-row\"><input type=\"text\" class=\"form-control\" placeholder=\"NUEVO GRUPO\" ng-model=\"vm.nombre\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" ng-model=\"vm.particular\"> <span>Particulares</span></label></div></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.agregarLugar()\" ng-disabled=\"vm.ajax\">AGREGAR</button></div></div><div ba-panel=\"\" class=\"col-xs-12 col-md-6 modifiers-panel\" ng-show=\"vm.lugar\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4\"><label>TARIFA</label><select id=\"tarifaSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" data-container=\"body\" ng-model=\"vm.lugar.tarifa\" ng-options=\"tarifa as nombre.toUpperCase() for (nombre, tarifa) in vm.tarifas\"><option value=\"\">---</option></select></div><div class=\"col-xs-12 col-sm-4\"><label>INCREMENTO</label><select id=\"incrementoSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" data-container=\"body\" ng-model=\"vm.lugar.incremento\" ng-options=\"incremento as nombre.toUpperCase() for (nombre, incremento) in vm.incrementos\"><option value=\"\">---</option></select></div><div class=\"col-xs-12 col-sm-4\"><label>LIMITE</label><select id=\"limiteSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" data-container=\"body\" ng-model=\"vm.lugar.limite\" ng-options=\"limite as nombre.toUpperCase() for (nombre, limite) in vm.limites\"><option value=\"\">---</option></select></div>&nbsp;<div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.guardarLugar()\" ng-disabled=\"vm.ajax\">GUARDAR</button> <button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"vm.eliminarLugar()\" ng-disabled=\"vm.ajax\">ELIMINAR GRUPO</button></div></div></div></div><div class=\"row\" ng-show=\"vm.lugar\"><div ba-panel=\"\" class=\"col-xs-12\"><form ng-show=\"!vm.lugar.particular\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"NUEVO CLIENTE\" ng-model=\"vm.newCliente\"></div><div class=\"button-wrapper\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.addCliente()\" ng-disabled=\"vm.ajax\">AGREGAR</button></div></form><div class=\"grupos-table-scroll\"><table class=\"table table-hover table-clientes\"><thead><tr class=\"black-muted-bg\"><th class=\"grupos-col-cliente\">CLIENTE</th><th>TARIFA</th><th>INCREMENTO</th><th>LÍMITE</th><th>ACCIONES</th></tr></thead><tbody><tr ng-repeat=\"cliente in vm.lugar.clientes | orderBy: \'nickname\'\"><td class=\"grupos-col-cliente\">{{ cliente.nickname.toUpperCase() }}</td><td><select id=\"tarifaSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" data-container=\"body\" ng-model=\"cliente.tarifaObj\" ng-options=\"tarifa as nombre.toUpperCase() for (nombre, tarifa) in vm.tarifas\"><option value=\"\">---</option></select></td><td><select id=\"incrementoSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" data-container=\"body\" ng-model=\"cliente.incrementoObj\" ng-options=\"incremento as nombre.toUpperCase() for (nombre, incremento) in vm.incrementos\"><option value=\"\">---</option></select></td><td><select id=\"limiteSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" data-container=\"body\" ng-model=\"cliente.limiteObj\" ng-options=\"limite as nombre.toUpperCase() for (nombre, limite) in vm.limites\"><option value=\"\">---</option></select></td><td><button class=\"btn btn-success\" ng-click=\"vm.guardarCliente(cliente)\" ng-disabled=\"vm.ajax\"><i class=\"ion-checkmark-round\"></i></button> <button class=\"btn btn-danger\" ng-click=\"vm.deleteCliente(cliente)\" ng-disabled=\"vm.ajax\"><i class=\"ion-close-round\"></i></button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/pages/turf/hipodromos/hipodromos.html","<div ba-panel=\"\" class=\"turf-hipodromos\"><div class=\"hipodromos-table-scroll\"><table class=\"table table-bordered tabla-hipodromos\"><thead><tr><th class=\"hipodromos-col-nombre\">Nombre</th><th>Ganador</th><th>Segundo</th><th>Tercero</th><th>Exacta</th><th>Imperfecta</th><th>Trifecta</th><th>Cuatrifecta</th><th>Doble</th><th>Triplo</th><th>Cuaterna</th><th>Triple</th></tr></thead><tbody><tr ng-repeat=\"hipodromo in vm.hipodromos\"><td class=\"hipodromos-col-nombre\"><input type=\"text\" class=\"form-control\" value=\"{{ hipodromo.nombre }}\" disabled=\"\"></td><td><input type=\"number\" class=\"form-control\" ng-model=\"hipodromo.gan\" ng-model-options=\"{ debounce: 250 }\"></td><td><input type=\"number\" class=\"form-control\" ng-model=\"hipodromo.seg\" ng-model-options=\"{ debounce: 250 }\"></td><td><input type=\"number\" class=\"form-control\" ng-model=\"hipodromo.ter\" ng-model-options=\"{ debounce: 250 }\"></td><td><input type=\"number\" class=\"form-control\" ng-model=\"hipodromo.exa\" ng-model-options=\"{ debounce: 250 }\"></td><td><input type=\"number\" class=\"form-control\" ng-model=\"hipodromo.imp\" ng-model-options=\"{ debounce: 250 }\"></td><td><input type=\"number\" class=\"form-control\" ng-model=\"hipodromo.trif\" ng-model-options=\"{ debounce: 250 }\"></td><td><input type=\"number\" class=\"form-control\" ng-model=\"hipodromo.cuat\" ng-model-options=\"{ debounce: 250 }\"></td><td><input type=\"number\" class=\"form-control\" ng-model=\"hipodromo.dob\" ng-model-options=\"{ debounce: 250 }\"></td><td><input type=\"number\" class=\"form-control\" ng-model=\"hipodromo.tlo\" ng-model-options=\"{ debounce: 250 }\"></td><td><input type=\"number\" class=\"form-control\" ng-model=\"hipodromo.cna\" ng-model-options=\"{ debounce: 250 }\"></td><td><input type=\"number\" class=\"form-control\" ng-model=\"hipodromo.tle\" ng-model-options=\"{ debounce: 250 }\"></td></tr></tbody></table></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.guardarHipodromos()\" ng-disabled=\"vm.ajax\">GUARDAR</button></div></div>");
$templateCache.put("app/pages/turf/incrementos/incrementos.html","<div id=\"tarifas\"><div class=\"row\"><div ba-panel=\"\" class=\"col-md-offset-3 col-md-6 select-panel\"><select id=\"incrementoSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" ng-model=\"vm.selectedIncremento\" ng-options=\"incremento as nombre.toUpperCase() for (nombre, incremento) in vm.incrementos\"><option data-hidden=\"true\"></option></select></div></div><div ba-panel=\"\" class=\"horizontal-scroll col-md-offset-2 col-md-8\"><table class=\"table table-bordered\"><tbody><tr ng-repeat=\"incremento in vm.selectedIncremento\"><td><input type=\"text\" class=\"form-control\" value=\"{{ vm.tipos[vm.GlobalHelpers.findWithAttr(vm.tipos, \'code\', incremento.code)].title | uppercase }}\" disabled=\"\"></td><td><input type=\"text\" class=\"form-control\" value=\"{{ incremento.place ? \'PLACE\' : \'\' }}\" disabled=\"\"></td><td><p ng-repeat=\"intervalo in incremento.intervalos\">{{ intervalo.minimo }} - {{ intervalo.maximo }}: {{ intervalo.factor }} <button class=\"btn btn-primary\" ng-click=\"vm.editarIntervaloModal(intervalo)\">EDITAR</button></p></td><td><button class=\"btn btn-primary\" ng-click=\"vm.agregarIntervaloModal(incremento)\">AGREGAR</button></td></tr></tbody></table></div><div class=\"button-wrapper col-md-12\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.nuevoIncrementoModal()\">NUEVO</button> <button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.updateIncrementos()\" ng-disabled=\"vm.ajax\">GUARDAR</button> <button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"vm.eliminarIncremento()\" ng-disabled=\"vm.ajax\">ELIMINAR</button></div></div>");
$templateCache.put("app/pages/turf/jornadas/jornadas.html","<div id=\"jornadas\" ng-show=\"vm.ready\"><div ba-panel=\"\"><form class=\"row form-inline\"><div class=\"form-group col-sm-4\"><input type=\"date\" class=\"form-control\" placeholder=\"Fecha\" ng-model=\"vm.jornada.fecha\"></div><div class=\"form-group col-sm-4\"><select id=\"jornadaSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"HIPÓDROMO\" ng-model=\"vm.jornada.hipodromo\" ng-options=\"hipodromo as hipodromo.nombre.toUpperCase() for hipodromo in vm.hipodromos\"><option data-hidden=\"true\"></option></select></div><div class=\"form-group col-sm-4\"><input type=\"number\" class=\"form-control\" placeholder=\"CARRERAS\" ng-model=\"vm.jornada.carreras\"></div></form><div class=\"button-wrapper\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.sendJornada()\" ng-disabled=\"vm.ajax\">ENVIAR</button></div></div></div>");
$templateCache.put("app/pages/turf/jugar/jugar.html","<div class=\"turf-jugar\" ng-show=\"vm.ready\"><div class=\"mobile visible-xs\"><div class=\"top\"><div class=\"topbar\"><div ba-panel=\"\" class=\"bet-carrera\"><div include-with-scope=\"app/pages/turf/jugar/widgets/carrera.html\"></div></div></div><div ba-panel=\"\" class=\"bet-triples\" ng-if=\"vm.selectedCarrera.vales.length > 0\"><div include-with-scope=\"app/pages/turf/jugar/widgets/triples.html\"></div></div><div ba-panel=\"\" class=\"bet-cliente\" ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\"><div include-with-scope=\"app/pages/turf/jugar/widgets/cliente.html\"></div></div></div><div class=\"center\"><div ba-panel=\"\" class=\"bet-tipo\" ng-show=\"vm.paso == 1\"><div include-with-scope=\"app/pages/turf/jugar/widgets/tipo.html\"></div></div><div ba-panel-title=\"Caballos\" ba-panel=\"\" class=\"bet-caballos\" ng-show=\"vm.paso == 2\"><div include-with-scope=\"app/pages/turf/jugar/widgets/caballos.html\"></div></div><div ba-panel-title=\"Importes\" ba-panel=\"\" class=\"bet-importe\" ng-show=\"vm.paso == 3\"><div include-with-scope=\"app/pages/turf/jugar/widgets/importe.html\"></div></div></div><div class=\"bottom\"><div ba-panel=\"\" class=\"bet-preview\"><div include-with-scope=\"app/pages/turf/jugar/widgets/preview.html\"></div></div><div ba-panel=\"\" class=\"bet-apuestas\"><div include-with-scope=\"app/pages/turf/jugar/widgets/apuestas.html\"></div></div></div></div><div class=\"hidden-xs\"><div class=\"col-sm-2 col-1\"><div ba-panel=\"\" class=\"bet-triples\" ng-if=\"vm.selectedCarrera.vales.length > 0\"><div include-with-scope=\"app/pages/turf/jugar/widgets/triples.html\"></div></div><div ba-panel=\"\" class=\"bet-recientes\" ng-if=\"vm.selectedCarrera.clientes.length > 0 && vm.GlobalHelpers.hideFrom(\'particular\')\"><div include-with-scope=\"app/pages/turf/jugar/widgets/recientes.html\"></div></div></div><div class=\"col-sm-4 col-2\"><div ba-panel=\"\" class=\"bet-tipo\"><div include-with-scope=\"app/pages/turf/jugar/widgets/tipo.html\"></div></div><div ba-panel=\"\" class=\"bet-importe\"><div include-with-scope=\"app/pages/turf/jugar/widgets/importe.html\"></div></div></div><div class=\"col-sm-4 col-3\"><div ba-panel=\"\" class=\"bet-caballos\"><div include-with-scope=\"app/pages/turf/jugar/widgets/caballos.html\"></div></div></div><div class=\"col-sm-2 col-4\"><div ba-panel=\"\" class=\"bet-carrera\"><div include-with-scope=\"app/pages/turf/jugar/widgets/carrera.html\"></div></div><div ba-panel=\"\" class=\"bet-cliente\" ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\"><div include-with-scope=\"app/pages/turf/jugar/widgets/cliente.html\"></div></div><div ba-panel=\"\" class=\"bet-preview\"><div include-with-scope=\"app/pages/turf/jugar/widgets/preview.html\"></div></div><div ba-panel=\"\" class=\"bet-apuestas\"><div include-with-scope=\"app/pages/turf/jugar/widgets/apuestas.html\"></div></div></div></div></div>");
$templateCache.put("app/pages/turf/limites/limites.html","<div id=\"limites\"><div ba-panel=\"\" class=\"col-md-offset-3 col-md-6 select-panel\"><select id=\"limiteSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" ng-model=\"vm.selectedLimite\" ng-options=\"limite as nombre.toUpperCase() for (nombre, limite) in vm.limites\"><option data-hidden=\"true\"></option></select></div><div ba-panel=\"\" class=\"horizontal-scroll col-md-offset-2 col-md-8\"><table class=\"table table-bordered\"><tbody><tr ng-repeat=\"limite in vm.selectedLimite\"><td><input type=\"text\" class=\"form-control\" value=\"{{ vm.tipos[vm.GlobalHelpers.findWithAttr(vm.tipos, \'code\', limite.code)].title | uppercase }}\" disabled=\"\"></td><td><p ng-repeat=\"intervalo in limite.intervalos\">{{ intervalo.minimo }} - {{ intervalo.maximo }}: {{ intervalo.valor }} <button class=\"btn btn-primary\" ng-click=\"vm.editarIntervaloModal(intervalo)\">EDITAR</button></p></td><td><button class=\"btn btn-primary\" ng-click=\"vm.agregarIntervaloModal(limite)\" ng-if=\"!limite.intervalos || limite.intervalos.length === 0\">AGREGAR</button></td></tr></tbody></table></div><div class=\"button-wrapper col-md-12\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.nuevoLimiteModal()\">NUEVO</button> <button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.updateLimites()\" ng-disabled=\"vm.ajax\">GUARDAR</button> <button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"vm.eliminarLimite()\" ng-disabled=\"vm.ajax\">ELIMINAR</button></div></div>");
$templateCache.put("app/pages/turf/liquidacion/liquidacion.html","<div id=\"liquidacion\" ng-show=\"vm.ready\"><div ba-panel=\"\" class=\"col-sm-2 col-izq\"><div class=\"form-group\"><label>JORNADA (DESDE)</label><select id=\"jornadaDesdeSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"JORNADA\" ng-change=\"vm.filterChange(\'jornada\')\" ng-model=\"vm.jornadaDesde\" ng-options=\"jornada as (jornada.fecha + \' - \' + jornada.hipodromo.nombre.toUpperCase()) for jornada in vm.jornadas\"><option data-hidden=\"true\"></option></select></div><div class=\"form-group\"><label>JORNADA (HASTA)</label><select id=\"jornadaHastaSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"JORNADA\" ng-change=\"vm.filterChange(\'jornada\')\" ng-model=\"vm.jornadaHasta\" ng-options=\"jornada as (jornada.fecha + \' - \' + jornada.hipodromo.nombre.toUpperCase()) for jornada in vm.jornadas\"><option data-hidden=\"true\"></option></select></div><div class=\"form-group\"><label>CARRERA</label><select id=\"carreraSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"CARRERA\" ng-change=\"vm.filterChange()\" ng-model=\"vm.carrera\" ng-options=\"carrera as (carrera.orden + \'ª\') for carrera in vm.jornada.carreras\"><option value=\"\">TODAS</option></select></div><div class=\"form-group\" ng-if=\"vm.GlobalHelpers.hideFrom([\'particular\'])\"><label>USUARIO</label><select id=\"userSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"USUARIO\" ng-change=\"vm.filterChange()\" ng-model=\"vm.user\" ng-options=\"user as user.username.toUpperCase() for user in vm.users\"><option value=\"\">TODOS</option></select></div><div class=\"form-group\" ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\'])\"><label>LUGAR</label><select id=\"lugarSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"LUGAR\" ng-change=\"vm.filterChange()\" ng-model=\"vm.lugar\" ng-options=\"lugar as lugar.nombre.toUpperCase() for lugar in vm.lugares\"><option value=\"\">TODOS</option></select></div><div class=\"form-group\" ng-if=\"vm.GlobalHelpers.hideFrom([\'particular\'])\"><label>CLIENTE</label><select id=\"clienteSelect\" class=\"form-control selectpicker select-filtro with-search\" selectpicker=\"\" title=\"CLIENTE\" data-live-search=\"true\" ng-change=\"vm.filterChange()\" ng-model=\"vm.cliente\" ng-options=\"cliente as cliente.nickname.toUpperCase() for cliente in vm.clientes\"><option value=\"\">TODOS</option></select></div><div class=\"button-wrapper\"><button class=\"btn btn-primary btn-fw\" ng-click=\"vm.getAciertos()\" ng-disabled=\"vm.ajax\">BUSCAR</button></div></div><div ba-panel=\"\" class=\"col-sm-10 printable col-der\"><div class=\"horizontal-scroll\"><table class=\"table table-hover apuestas-table\" st-table=\"vm.displayedGrupos\" st-safe-src=\"vm.gruposArray\"><thead><caption><span class=\"pull-left noprintable\"></span><h3 ng-if=\"vm.grupos && vm.jornada\">{{ vm.jornada.fecha }} - {{ vm.jornada.hipodromo.nombre.toUpperCase() }} {{ vm.carrera ? \' - \' + vm.carrera.orden + \'ª CARRERA\' : \'\' }}</h3><h3 ng-if=\"vm.grupos && !vm.jornada\">{{ vm.jornadaDesde.fecha }} - {{ vm.jornadaDesde.hipodromo.nombre.toUpperCase() }} A {{ vm.jornadaHasta.fecha }} - {{ vm.jornadaHasta.hipodromo.nombre.toUpperCase() }}</h3><span class=\"pull-right\"><button ng-click=\"vm.conDetalle = false\" ng-class=\"{\'btn-success\': !vm.conDetalle}\" class=\"btn btn-default btn-sm\">RESUMEN</button> <button ng-click=\"vm.conDetalle = true\" ng-class=\"{\'btn-success\': vm.conDetalle}\" class=\"btn btn-default btn-sm\">DETALLE</button></span></caption><tr><th class=\"col-jornada\" ng-if=\"!vm.jornada\" st-sort=\"jornada\"><strong>JORNADA</strong></th><th class=\"col-usuario\" st-sort=\"usuario\" ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\"><strong>USUARIO</strong></th><th class=\"col-lugar\" st-sort=\"lugar\" ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\'])\"><strong>LUGAR</strong></th><th class=\"col-cliente\" st-sort=\"cliente\" ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\"><strong>CLIENTE</strong></th><th class=\"col-detalle\"><strong><span ng-if=\"!vm.carrera && vm.conDetalle\">CARRERA -&nbsp;</span><span ng-show=\"vm.conDetalle\">JUGADA -&nbsp;</span>A PAGAR</strong></th></tr></thead><tbody><tr ng-repeat=\"grupo in vm.displayedGrupos\"><td ng-if=\"!vm.jornada\">{{ grupo[0].fecha }}</td><td ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\">{{ grupo[0].usuario | uppercase }}</td><td ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\'])\">{{ (grupo[0].tipo == \'superadmin\' || grupo[0].tipo == \'admin\' || grupo[0].tipo == \'empleado\') ? grupo[0].lugar.toUpperCase() : \'---\' }}</td><td ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\">{{ (grupo[0].tipo == \'superadmin\' || grupo[0].tipo == \'admin\' || grupo[0].tipo == \'empleado\') ? grupo[0].cliente.toUpperCase() : \'---\' }}</td><td><span ng-hide=\"vm.conDetalle\" ng-class=\"{ \'monto-negativo\': vm.getTotal(grupo) < 0 }\">$ {{ vm.getTotal(grupo) | money }}</span><table class=\"detalle-jugada table-hover\" ng-show=\"vm.conDetalle\"><tr ng-repeat=\"apuesta in grupo\"><td class=\"col-carrera\" ng-if=\"!vm.carrera && vm.conDetalle\">{{ apuesta.carrera }}ª</td><td class=\"col-jugada\" ng-class=\"{ \'monto-negativo\': !apuesta.vales && apuesta.importe < 0 }\">{{ vm.formatJugadaDetalle(apuesta) }}</td><td class=\"col-apagar\" ng-class=\"{ \'monto-negativo\': apuesta.aPagar < 0 }\">$ {{ apuesta.aPagar | money }}</td></tr></table></td></tr></tbody><tfoot><tr><td ng-if=\"!vm.jornada\"></td><td ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\"></td><td ng-if=\"vm.GlobalHelpers.hideFrom([\'empleado\', \'particular\'])\"></td><td ng-if=\"vm.GlobalHelpers.hideFrom(\'particular\')\"></td><td><strong>TOTAL $ <span ng-class=\"{ \'monto-negativo\': vm.total < 0 }\">{{ vm.total | money }}</span></strong></td></tr></tfoot></table></div></div></div>");
$templateCache.put("app/pages/turf/modals/eliminarConfigGrupo.html","<div class=\"modal-header\"><h4 class=\"modal-title\">Confirmar eliminación</h4></div><div class=\"modal-body\"><p>Se eliminará la configuración <strong>{{ vm.nombre }}</strong>.</p><div ng-show=\"vm.referencias.lugares.length\"><p><strong>Grupos que la usan</strong></p><ul><li ng-repeat=\"l in vm.referencias.lugares\">{{ l.nombre }} <small>(id {{ l.id }})</small></li></ul></div><div ng-show=\"vm.referencias.clientes.length\"><p><strong>Clientes que la usan</strong></p><ul><li ng-repeat=\"c in vm.referencias.clientes\">{{ c.nickname }} <span ng-if=\"c.lugar\">— grupo {{ c.lugar.nombre }}</span></li></ul></div><p class=\"text-warning\" ng-show=\"vm.referencias.lugares.length || vm.referencias.clientes.length\">Al confirmar se quitará esta asociación en los registros listados y se dará de baja la configuración.</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\">Cancelar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.ejecutar()\" ng-disabled=\"vm.ajax\">Eliminar</button></div>");
$templateCache.put("app/pages/turf/movimientos/movimientos.html","<div id=\"apuestas\" ng-show=\"vm.ready\"><div class=\"bg-panel flex flex-col rounded-lg\"><div class=\"flex justify-center items-center p-4\"><div class=\"form-group m-0 mx-2 w-1/4\"><label class=\"uppercase\">Jornada</label><select id=\"jornadaSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"---\" ng-model=\"vm.jornada\" ng-options=\"jornada as jornada.fecha for jornada in vm.jornadas\"><option data-hidden=\"true\"></option></select></div><div class=\"form-group m-0 mx-2 w-1/4\"><label class=\"uppercase\">Admin</label><select id=\"adminSelect\" class=\"form-control selectpicker select-filtro mx-2\" selectpicker=\"\" title=\"ADMIN\" ng-disabled=\"vm.ajax\" ng-model=\"vm.admin\" ng-options=\"admin as admin.username.toUpperCase() for admin in vm.admins | orderBy: \'username\'\"><option value=\"\">---</option></select></div><div class=\"form-group m-0 mx-2 w-1/4\"><label class=\"uppercase\">Agente</label><select id=\"agenteSelect\" class=\"form-control selectpicker select-filtro mx-2\" selectpicker=\"\" title=\"AGENTE\" ng-disabled=\"vm.ajax\" ng-model=\"vm.agente\" ng-options=\"agente as agente.username.toUpperCase() for agente in vm.agentes | orderBy: \'username\'\"><option value=\"\">---</option></select></div><div class=\"form-group m-0 mx-2 w-1/4\"><label class=\"uppercase\">Cliente</label><select id=\"adminSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"CLIENTE\" ng-disabled=\"vm.ajax\" ng-model=\"vm.particular\" ng-options=\"particular as particular.username.toUpperCase() for particular in vm.particulares | orderBy: \'username\'\"><option value=\"\">---</option></select></div><div class=\"form-group m-0 mx-2 w-1/4\"><label class=\"uppercase\">Movimiento</label><select multiple=\"\" id=\"tiposMovimientosSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"---\" ng-disabled=\"vm.ajax\" ng-model=\"vm.selectedTiposMovimientos\" ng-options=\"movimiento as movimiento.toUpperCase() for movimiento in vm.tiposMovimientos\"></select></div></div><div class=\"flex mb-2\"><div class=\"mx-2 w-1/4\"></div><div class=\"mx-2 w-1/4 flex justify-center\"><button class=\"btn btn-default uppercase\" ng-class=\"{ \'btn-success\': vm.agruparAdmin }\" ng-click=\"vm.reset(); vm.agruparAdmin = !vm.agruparAdmin\">Agrupar</button></div><div class=\"mx-2 w-1/4 flex justify-center\"><button class=\"btn btn-default uppercase\" ng-class=\"{ \'btn-success\': vm.agruparAgente }\" ng-click=\"vm.reset(); vm.agruparAgente = !vm.agruparAgente\">Agrupar</button></div><div class=\"mx-2 w-1/4 flex justify-center\"><button class=\"btn btn-default uppercase\" ng-class=\"{ \'btn-success\': vm.agruparParticular }\" ng-click=\"vm.reset(); vm.agruparParticular = !vm.agruparParticular\">Agrupar</button></div><div class=\"mx-2 w-1/4\"></div></div></div><div class=\"flex justify-center my-2\"><a ng-click=\"vm.updateList()\" class=\"btn btn-primary\" ng-disabled=\"vm.ajax\" style=\"z-index: 1;\">BUSCAR</a></div><div class=\"bg-panel rounded-lg p-4\" ng-show=\"vm.movimientos\"><table class=\"table-hover\" ng-if=\"!(vm.agruparAdmin || vm.agruparAgente || vm.agruparParticular)\"><thead><th>ADMIN</th><th>AGENTE</th><th>CLIENTE</th><th>MOVIMIENTO</th><th>IMPORTE</th><th>SALDO</th></thead><tbody><tr ng-repeat=\"movimiento in vm.movimientos\"><td class=\"uppercase\">{{ movimiento.user.username }}</td><td class=\"uppercase\">{{ movimiento.agent.username }}</td><td class=\"uppercase\">{{ movimiento.cliente.nickname }}</td><td class=\"uppercase\">{{ movimiento.tipo }}</td><td class=\"uppercase\" ng-class=\"{ \'monto-negativo\': movimiento.importe < 0 }\">$ {{ movimiento.importe | money }}</td><td class=\"uppercase\" ng-class=\"{ \'monto-negativo\': movimiento.saldo < 0 }\">$ {{ movimiento.saldo | money }}</td></tr></tbody></table><table class=\"table-hover\" ng-if=\"vm.agruparAdmin || vm.agruparAgente || vm.agruparParticular\"><thead><th ng-if=\"vm.agruparAdmin\">ADMIN</th><th ng-if=\"vm.agruparAgente\">ADMIN</th><th ng-if=\"vm.agruparParticular\">CLIENTE</th><th>MOVIMIENTO</th><th>TOTAL</th></thead><tbody><tr ng-repeat=\"grupo in vm.movimientos\"><td class=\"uppercase\" ng-if=\"vm.agruparAdmin\">{{ grupo.admin }}</td><td class=\"uppercase\" ng-if=\"vm.agruparAgente\">{{ grupo.agent }}</td><td class=\"uppercase\" ng-if=\"vm.agruparParticular\">{{ grupo.cliente }}</td><td class=\"uppercase\">{{ grupo.tipo }}</td><td class=\"uppercase\" ng-class=\"{ \'monto-negativo\': grupo.importe < 0 }\">{{ grupo.importe | money }}</td></tr></tbody></table></div></div>");
$templateCache.put("app/pages/turf/netwin/netwin.html","<div id=\"netwin\" ng-show=\"vm.ready\"><div class=\"bg-panel rounded-lg p-4\"><div class=\"netwin-filters\"><div class=\"netwin-filter\"><label>DESDE</label> <input type=\"date\" class=\"form-control\" ng-model=\"vm.desde\" ng-disabled=\"vm.ajax\"></div><div class=\"netwin-filter\"><label>HASTA</label> <input type=\"date\" class=\"form-control\" ng-model=\"vm.hasta\" ng-disabled=\"vm.ajax\"></div><div class=\"netwin-filter\"><label>TIPO DE JUGADA</label><select multiple=\"\" id=\"tipoSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"TODOS\" data-container=\"body\" data-actions-box=\"true\" data-selected-text-format=\"count > 1\" ng-model=\"vm.tipos\" ng-disabled=\"vm.ajax\" ng-options=\"tipo.code as tipo.title.toUpperCase() for tipo in vm.catalogoTipos\"></select><button type=\"button\" class=\"btn btn-default btn-sm btn-block\" ng-disabled=\"vm.ajax\" ng-class=\"{ \'btn-success\': vm.agrupar.tipo }\" ng-click=\"vm.agrupar.tipo = !vm.agrupar.tipo\">AGRUPAR</button></div><div class=\"netwin-filter\"><label>GRUPO</label><select multiple=\"\" id=\"grupoSelect\" class=\"form-control selectpicker with-search\" selectpicker=\"\" title=\"TODOS\" data-container=\"body\" data-live-search=\"true\" data-actions-box=\"true\" data-selected-text-format=\"count > 1\" ng-model=\"vm.grupos\" ng-disabled=\"vm.ajax\" ng-options=\"grupo.id as grupo.nombre.toUpperCase() for grupo in vm.catalogoGrupos\"></select><button type=\"button\" class=\"btn btn-default btn-sm btn-block\" ng-disabled=\"vm.ajax\" ng-class=\"{ \'btn-success\': vm.agrupar.grupo }\" ng-click=\"vm.agrupar.grupo = !vm.agrupar.grupo\">AGRUPAR</button></div><div class=\"netwin-filter\"><label>USUARIO</label><select multiple=\"\" id=\"usuarioSelect\" class=\"form-control selectpicker with-search\" selectpicker=\"\" title=\"TODOS\" data-container=\"body\" data-live-search=\"true\" data-actions-box=\"true\" data-selected-text-format=\"count > 1\" ng-model=\"vm.usuarios\" ng-disabled=\"vm.ajax\" ng-options=\"usuario.id as usuario.username.toUpperCase() for usuario in vm.catalogoUsuarios | orderBy: \'username\'\"></select><button type=\"button\" class=\"btn btn-default btn-sm btn-block\" ng-disabled=\"vm.ajax\" ng-class=\"{ \'btn-success\': vm.agrupar.usuario }\" ng-click=\"vm.agrupar.usuario = !vm.agrupar.usuario\">AGRUPAR</button></div><div class=\"netwin-filter\"><label>CLIENTE</label><select multiple=\"\" id=\"clienteSelect\" class=\"form-control selectpicker with-search\" selectpicker=\"\" title=\"TODOS\" data-container=\"body\" data-live-search=\"true\" data-actions-box=\"true\" data-selected-text-format=\"count > 1\" ng-model=\"vm.clientes\" ng-disabled=\"vm.ajax\" ng-options=\"cliente.id as cliente.nickname.toUpperCase() for cliente in vm.catalogoClientes | orderBy: \'nickname\'\"></select><button type=\"button\" class=\"btn btn-default btn-sm btn-block\" ng-disabled=\"vm.ajax\" ng-class=\"{ \'btn-success\': vm.agrupar.cliente }\" ng-click=\"vm.agrupar.cliente = !vm.agrupar.cliente\">AGRUPAR</button></div><div class=\"netwin-filter\"><label>HIPÓDROMO</label><select multiple=\"\" id=\"hipodromoSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"TODOS\" data-container=\"body\" data-actions-box=\"true\" data-selected-text-format=\"count > 1\" ng-model=\"vm.hipodromos\" ng-disabled=\"vm.ajax\" ng-options=\"hipodromo.id as hipodromo.nombre.toUpperCase() for hipodromo in vm.catalogoHipodromos\"></select><button type=\"button\" class=\"btn btn-default btn-sm btn-block\" ng-disabled=\"vm.ajax\" ng-class=\"{ \'btn-success\': vm.agrupar.hipodromo }\" ng-click=\"vm.agrupar.hipodromo = !vm.agrupar.hipodromo\">AGRUPAR</button></div></div><div class=\"netwin-actions\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.buscar()\" ng-disabled=\"vm.ajax\">BUSCAR</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.descargar(\'xlsx\')\" ng-disabled=\"vm.ajax || !vm.reporte\">EXCEL</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.descargar(\'pdf\')\" ng-disabled=\"vm.ajax || !vm.reporte\">PDF</button></div></div><div class=\"bg-panel rounded-lg p-4 netwin-result\" ng-show=\"vm.reporte\"><p class=\"netwin-note\">{{ vm.reporte.nota }}</p><p class=\"netwin-range\" ng-show=\"vm.consulta\">{{ vm.consulta.desde }} a {{ vm.consulta.hasta }}</p><p class=\"netwin-empty\" ng-show=\"vm.reporte.filas.length === 0\">No hay jugadas en ese rango.</p><div class=\"horizontal-scroll\" ng-show=\"vm.reporte.filas.length > 0\"><table class=\"table table-hover netwin-table\"><thead><tr><th ng-repeat=\"col in vm.reporte.grupos_activos\">{{ vm.etiquetas[col] }}</th><th ng-if=\"vm.reporte.saldos_visibles\" class=\"num\">SALDO INI</th><th class=\"num\">PASE</th><th class=\"num\">ACIERTO</th><th ng-if=\"vm.reporte.saldos_visibles\" class=\"num\">CARGAS</th><th ng-if=\"vm.reporte.saldos_visibles\" class=\"num\">DESCARGAS</th><th ng-if=\"vm.reporte.saldos_visibles\" class=\"num\">SALDO FINAL</th><th class=\"num\">NETWIN</th></tr></thead><tbody><tr ng-repeat=\"fila in vm.reporte.filas\"><td ng-repeat=\"col in vm.reporte.grupos_activos\" class=\"uppercase\">{{ fila[col] }}</td><td ng-if=\"vm.reporte.saldos_visibles\" class=\"num\" ng-class=\"{ \'monto-negativo\': fila.saldo_ini < 0 }\">{{ vm.monto(fila.saldo_ini) }}</td><td class=\"num\" ng-class=\"{ \'monto-negativo\': fila.pase < 0 }\">{{ vm.monto(fila.pase) }}</td><td class=\"num\" ng-class=\"{ \'monto-negativo\': fila.acierto < 0 }\">{{ vm.monto(fila.acierto) }}</td><td ng-if=\"vm.reporte.saldos_visibles\" class=\"num\" ng-class=\"{ \'monto-negativo\': fila.cargas < 0 }\">{{ vm.monto(fila.cargas) }}</td><td ng-if=\"vm.reporte.saldos_visibles\" class=\"num\" ng-class=\"{ \'monto-negativo\': fila.descargas < 0 }\">{{ vm.monto(fila.descargas) }}</td><td ng-if=\"vm.reporte.saldos_visibles\" class=\"num\" ng-class=\"{ \'monto-negativo\': fila.saldo_final < 0 }\">{{ vm.monto(fila.saldo_final) }}</td><td class=\"num\" ng-class=\"{ \'monto-negativo\': fila.netwin < 0 }\">{{ vm.monto(fila.netwin) }}</td></tr></tbody><tfoot ng-if=\"vm.reporte.filas.length > 1\"><tr><td ng-repeat=\"col in vm.reporte.grupos_activos\">{{ $first ? \'TOTAL\' : \'\' }}</td><td ng-if=\"vm.reporte.saldos_visibles\" class=\"num\" ng-class=\"{ \'monto-negativo\': vm.reporte.total.saldo_ini < 0 }\">{{ vm.monto(vm.reporte.total.saldo_ini) }}</td><td class=\"num\" ng-class=\"{ \'monto-negativo\': vm.reporte.total.pase < 0 }\">{{ vm.monto(vm.reporte.total.pase) }}</td><td class=\"num\" ng-class=\"{ \'monto-negativo\': vm.reporte.total.acierto < 0 }\">{{ vm.monto(vm.reporte.total.acierto) }}</td><td ng-if=\"vm.reporte.saldos_visibles\" class=\"num\" ng-class=\"{ \'monto-negativo\': vm.reporte.total.cargas < 0 }\">{{ vm.monto(vm.reporte.total.cargas) }}</td><td ng-if=\"vm.reporte.saldos_visibles\" class=\"num\" ng-class=\"{ \'monto-negativo\': vm.reporte.total.descargas < 0 }\">{{ vm.monto(vm.reporte.total.descargas) }}</td><td ng-if=\"vm.reporte.saldos_visibles\" class=\"num\" ng-class=\"{ \'monto-negativo\': vm.reporte.total.saldo_final < 0 }\">{{ vm.monto(vm.reporte.total.saldo_final) }}</td><td class=\"num\" ng-class=\"{ \'monto-negativo\': vm.reporte.total.netwin < 0 }\">{{ vm.monto(vm.reporte.total.netwin) }}</td></tr></tfoot></table></div></div></div>");
$templateCache.put("app/pages/turf/resultados/resultados.html","<div class=\"turf-resultados\" ng-show=\"vm.ready\"><div class=\"row resultados-selectores\"><div ba-panel=\"\" class=\"col-xs-12 col-md-4 col-md-offset-4 panel-jornada no-padding\"><div class=\"form-group\"><select class=\"form-control selectpicker\" data-style=\"btn-default btn-lg\" selectpicker=\"\" title=\"---\" data-container=\"body\" ng-disabled=\"vm.ajax\" ng-change=\"vm.jornadaChange()\" ng-model=\"vm.jornada\" ng-options=\"jornada as (jornada.fecha + \' - \' + jornada.hipodromo.nombre.toUpperCase()) for jornada in vm.jornadas\"><option data-hidden=\"true\"></option></select></div></div></div><div class=\"row resultados-selectores\" ng-hide=\"vm.ajax\"><div ba-panel=\"\" ba-panel-title=\"Carrera\" class=\"col-xs-12 col-md-4 col-md-offset-4 panel-carrera no-padding\"><div class=\"form-group\"><select class=\"form-control selectpicker\" data-style=\"btn-default btn-lg\" selectpicker=\"\" title=\"---\" data-container=\"body\" ng-model=\"vm.carrera\" ng-change=\"vm.updateStatus()\" ng-options=\"carrera as (carrera.orden + \'ª\' + (carrera.abierta ? \' (ABIERTA)\' : \'\')) for carrera in vm.carreras\"><option data-hidden=\"true\"></option></select></div></div></div><div class=\"row\" ng-show=\"vm.carrera && vm.carrera.abierta\"><div class=\"col-xs-12\"><div ba-panel=\"\" class=\"resultados-carrera-abierta\"><p class=\"resultados-carrera-abierta__text\">La carrera aún está abierta.</p></div></div></div><div class=\"row resultados-main\" ng-show=\"vm.carrera && !vm.carrera.abierta\"><div class=\"col-xs-12 col-md-6 resultados-col resultados-col--llegada\"><div ba-panel=\"\"><div class=\"btn-row btns-same-width-sm\" ng-if=\"vm.resultadosEsAdminTipo()\"><button type=\"button\" class=\"btn btn-lg btn-primary\" ng-repeat=\"i in vm.availableCaballos\" ng-click=\"vm.toggleCaballo(i)\">{{ i }}</button></div><div class=\"resultados-caballos-disponibles-sololectura\" ng-if=\"!vm.resultadosEsAdminTipo() && vm.availableCaballos.length\"><span class=\"label label-default resultados-caballo-disponible-chip\" ng-repeat=\"i in vm.availableCaballos track by i\">{{ i }}</span></div></div><div ba-panel=\"\" ba-panel-title=\"Retirados\" ba-panel-class=\"resultados-panel-retirados\"><div class=\"resultados-retirados-ui\"><div class=\"resultados-retirados-columns\"><div class=\"resultados-retirados-col-select\" ng-if=\"vm.resultadosEsAdminTipo()\"><div class=\"form-group resultados-retirados-select-wrap\"><select id=\"resultadosRetiradosSelect\" class=\"form-control selectpicker\" data-style=\"btn-default btn-lg\" data-container=\"body\" selectpicker=\"\" title=\"---\" ng-model=\"vm.retiradoSelectModel\" ng-change=\"vm.elegirRetiradoDesdeSelect()\" ng-disabled=\"vm.guardandoRetirados\" ng-options=\"n as n for n in vm.caballosSelectRetirados track by n\"><option data-hidden=\"true\" value=\"\"></option></select></div><p class=\"text-muted resultados-retirados-sin-opciones\" ng-if=\"vm.caballosCarreraTotal && !vm.caballosSelectRetirados.length\">No quedan caballos por retirar.</p></div><div class=\"resultados-retirados-col-retirados\"><div class=\"resultados-retirados-actuales\" ng-if=\"vm.retiradosListaOrdenada.length && vm.resultadosEsAdminTipo()\"><button type=\"button\" class=\"btn btn-sm btn-danger resultados-retirado-quitar\" ng-repeat=\"n in vm.retiradosListaOrdenada track by n\" ng-click=\"vm.toggleRetirado(n)\" ng-disabled=\"vm.guardandoRetirados\" title=\"Quitar retirado\">{{ n }} <i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></div><div class=\"resultados-retirados-actuales resultados-retirados-actuales--sololectura\" ng-if=\"vm.retiradosListaOrdenada.length && !vm.resultadosEsAdminTipo()\"><span class=\"label label-danger resultados-retirado-sololectura\" ng-repeat=\"n in vm.retiradosListaOrdenada track by n\">{{ n }}</span></div><p class=\"text-muted resultados-retirados-vacio\" ng-if=\"!vm.retiradosListaOrdenada.length\">Ningún caballo retirado.</p></div></div></div></div><div ba-panel=\"\" ba-panel-title=\"El ganador es favorito\" ba-panel-class=\"resultados-panel-favorito\" ng-if=\"!vm.resultadosEsAdminTipo()\"><p class=\"resultados-favorito-sololectura\">{{ vm.carrera.ganador_es_favorito ? \'SÍ\' : \'NO\' }}</p></div><div ba-panel=\"\" ba-panel-title=\"El ganador es favorito\" ba-panel-class=\"resultados-panel-favorito\" ng-if=\"vm.resultadosEsAdminTipo()\"><div class=\"resultados-favorito-toggle\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-lg\" ng-class=\"vm.carrera.ganador_es_favorito ? \'btn-success\' : \'btn-default\'\" ng-click=\"vm.setGanadorEsFavorito(true)\">SÍ</button> <button type=\"button\" class=\"btn btn-lg\" ng-class=\"!vm.carrera.ganador_es_favorito ? \'btn-info\' : \'btn-default\'\" ng-click=\"vm.setGanadorEsFavorito(false)\">NO</button></div></div></div><div ba-panel=\"\"><div class=\"flex-vertical posicionados btns-same-width-sm\" ng-if=\"vm.resultadosEsAdminTipo()\"><div class=\"posicion flex-horizontal\" ng-repeat=\"i in vm.llegada track by $index\"><button type=\"button\" class=\"btn btn-lg btn-info\" ng-click=\"vm.corregirOrden($index)\">{{ i }}º</button> <button type=\"button\" class=\"btn btn-lg btn-success\" ng-if=\"vm.posiciones[$index]\" ng-click=\"vm.toggleCaballo(vm.posiciones[$index])\">{{ vm.posiciones[$index] }}</button></div></div><div class=\"flex-vertical posicionados resultados-posiciones-sololectura\" ng-if=\"!vm.resultadosEsAdminTipo()\"><div class=\"posicion flex-horizontal\" ng-repeat=\"i in vm.llegada track by $index\"><span class=\"resultados-posicion-orden-readonly\">{{ i }}º</span> <span class=\"label label-success resultados-posicion-caballo-readonly\" ng-if=\"vm.posiciones[$index]\">{{ vm.posiciones[$index] }}</span></div></div></div></div><div class=\"col-xs-12 col-md-6 resultados-col resultados-col--pagos\"><div ba-panel=\"\"><div class=\"resultados-ganadoras-simples\"><div ng-repeat=\"ganadora in vm.ganadoras\"><div class=\"col-xs-4 col-md-4\" ng-class=\"{ clearfix: $index % 3 == 0, \'resultados-ganadora-col--first\': $index % 3 == 0, \'resultados-ganadora-col--mid\': $index % 3 == 1, \'resultados-ganadora-col--last\': $index % 3 == 2 }\" ng-if=\"ganadora.tipo == \'gan\' || ganadora.tipo == \'seg\' || ganadora.tipo == \'ter\' || ganadora.tipo == false\"><div class=\"resultados-ganadora-celda\" ng-if=\"ganadora.tipo\"><label>{{ ganadora.caballos.join(\'.\') + \' \' + ganadora.tipo | uppercase }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ganadora.multiplier\" ng-readonly=\"!vm.resultadosEsAdminTipo()\"></div></div></div></div><div class=\"ganadora-pool-row\" ng-class=\"{ \'ganadora-pool-row--no-chips\': !ganadora.favoritoLegs || !ganadora.favoritoLegs.length }\" ng-repeat=\"ganadora in vm.ganadoras\" ng-if=\"ganadora.tipo && !(ganadora.tipo == \'gan\' || ganadora.tipo == \'seg\' || ganadora.tipo == \'ter\')\"><div class=\"ganadora-pool-chips\"><div class=\"ganadora-favorito-chips\" ng-if=\"ganadora.favoritoLegs && ganadora.favoritoLegs.length\"><span class=\"ganadora-favorito-chip\" ng-class=\"{ \'ganadora-favorito-chip--favorito\': leg.esFavoritoLeg }\" ng-repeat=\"leg in ganadora.favoritoLegs track by $index\">{{ leg.label }}</span></div></div><div class=\"ganadora-pool-field\"><label>{{ vm.getGanadoraLabel(ganadora) }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"ganadora.multiplier\" ng-readonly=\"!vm.resultadosEsAdminTipo()\"></div></div></div><div ba-panel=\"\" ba-panel-title=\"Valor enganche\" ng-if=\"vm.carrera.needsEnganche && vm.resultadosEsAdminTipo()\"><div class=\"form-group\"><input type=\"text\" class=\"form-control input-enganche\" ng-model=\"vm.eng\" placeholder=\"\"></div></div><div ba-panel=\"\" ba-panel-title=\"Valor enganche\" ng-if=\"vm.carrera.needsEnganche && !vm.resultadosEsAdminTipo()\"><p class=\"form-control-static text-center input-enganche resultados-enganche-sololectura\">{{ vm.eng }}</p></div><div ba-panel=\"\" ng-if=\"vm.resultadosEsAdminTipo()\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.sendResultado()\" ng-disabled=\"vm.ajax\">ENVIAR</button></div></div></div></div></div>");
$templateCache.put("app/pages/turf/retirados/retirados.html","<div class=\"turf-retirados\" ng-show=\"vm.ready\"><div ba-panel=\"\" class=\"col-md-6 col-md-offset-3\"><h4>{{ vm.jornada.fecha + \' - \' + vm.jornada.hipodromo.nombre.toUpperCase() }}</h4></div><div ba-panel=\"\" ba-panel-title=\"{{ carrera.orden }}ª\" class=\"col-md-4 bet-caballos\" ng-repeat=\"carrera in vm.jornada.carreras track by $index\"><div class=\"btn-row btns-same-width-sm\"><button type=\"button\" class=\"btn\" ng-repeat=\"i in vm.GlobalHelpers.makeArray(carrera.caballos) track by $index\" ng-click=\"vm.clickCaballo($parent.$index, i)\" ng-class=\"vm.caballoClass($parent.$index, i)\">{{ i }}</button></div></div></div>");
$templateCache.put("app/pages/turf/saldos/saldos.html","<div id=\"saldos\" class=\"turf-saldos\"><div class=\"row\" ng-show=\"vm.SessionService.currentUser.tipo !== \'agente\'\"><div ba-panel=\"\" class=\"col-xs-12 col-md-6 col-md-offset-3 saldos-lugar-panel\"><select id=\"lugarSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" data-container=\"body\" ng-model=\"vm.selectedLugar\" ng-change=\"vm.lugarChange()\" ng-options=\"lugar as lugar.nombre.toUpperCase() for lugar in vm.SessionService.lugaresParticulares\"><option data-hidden=\"true\"></option></select></div></div><div class=\"row\" ng-show=\"vm.selectedLugar\" ng-if=\"vm.SessionService.currentUser.tipo !== \'agente\'\"><div ba-panel=\"\" class=\"col-xs-12 col-md-6\" ng-if=\"vm.SessionService.currentUser.tipo === \'superadmin\' || vm.SessionService.currentUser.tipo === \'admin\'\"><div class=\"saldos-panel-actions\"><h3>Saldo del grupo: <span ng-class=\"{ \'monto-negativo\': vm.selectedLugar.saldo < 0 }\">$ {{ vm.selectedLugar.saldo | money }}</span></h3><form class=\"saldos-form\" ng-submit=\"vm.doDescubiertoGrupo()\"><label class=\"saldos-form__label\">Descubierto</label><div class=\"saldos-form__controls\"><input ng-disabled=\"vm.ajax\" type=\"number\" step=\"1\" class=\"form-control\" ng-class=\"{ \'monto-negativo\': vm.selectedLugar.descubierto < 0 }\" ng-model=\"vm.selectedLugar.descubierto\"> <button ng-disabled=\"vm.ajax\" type=\"submit\" class=\"btn btn-success\"><i class=\"ion-checkmark-round\"></i></button></div></form><form class=\"saldos-form\" ng-submit=\"vm.doEstablecerGrupo()\"><label class=\"saldos-form__label\">Establecer</label><div class=\"saldos-form__controls\"><input ng-disabled=\"vm.ajax\" type=\"number\" step=\"1\" class=\"form-control\" ng-model=\"vm.selectedLugar.establecer\"> <button ng-disabled=\"vm.ajax\" type=\"submit\" class=\"btn btn-success\"><i class=\"ion-checkmark-round\"></i></button></div></form><form class=\"saldos-form\" ng-submit=\"vm.doRecargarGrupo()\"><label class=\"saldos-form__label\">Recargar</label><div class=\"saldos-form__controls\"><input ng-disabled=\"vm.ajax\" type=\"number\" step=\"1\" class=\"form-control\" ng-model=\"vm.selectedLugar.recargar\"> <button ng-disabled=\"vm.ajax\" type=\"submit\" class=\"btn btn-success\"><i class=\"ion-checkmark-round\"></i></button></div></form><form class=\"saldos-form\" ng-submit=\"vm.doRetirarGrupo()\"><label class=\"saldos-form__label\">Retirar</label><div class=\"saldos-form__controls\"><input ng-disabled=\"vm.ajax\" type=\"number\" step=\"1\" class=\"form-control\" ng-model=\"vm.selectedLugar.retirar\"> <button ng-disabled=\"vm.ajax\" type=\"submit\" class=\"btn btn-success\"><i class=\"ion-checkmark-round\"></i></button></div></form></div></div><div ba-panel=\"\" ba-panel-title=\"Agentes\" class=\"saldos-agentes-panel\" ng-class=\"(vm.SessionService.currentUser.tipo === \'superadmin\' || vm.SessionService.currentUser.tipo === \'admin\') ? \'col-xs-12 col-md-6\' : \'col-xs-12 col-md-6 col-md-offset-3\'\"><select id=\"agenteSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" data-container=\"body\" ng-model=\"vm.selectedAgente\" ng-options=\"agente as agente.username.toUpperCase() for agente in vm.selectedLugar.users\"><option data-hidden=\"true\"></option></select><div class=\"saldos-agente-detail\" ng-show=\"vm.selectedAgente\"><h3>Saldo: <span ng-class=\"{ \'monto-negativo\': vm.selectedAgente.saldo < 0 }\">$ {{ vm.selectedAgente.saldo | money }}</span></h3><form class=\"saldos-form\" ng-submit=\"vm.doDescubiertoAgente()\"><label class=\"saldos-form__label\">Descubierto</label><div class=\"saldos-form__controls\"><input ng-disabled=\"vm.ajax\" type=\"number\" step=\"1\" class=\"form-control\" ng-class=\"{ \'monto-negativo\': vm.selectedAgente.descubierto < 0 }\" ng-model=\"vm.selectedAgente.descubierto\"> <button ng-disabled=\"vm.ajax\" type=\"submit\" class=\"btn btn-success\"><i class=\"ion-checkmark-round\"></i></button></div></form><form class=\"saldos-form\" ng-submit=\"vm.doEstablecerAgente()\"><label class=\"saldos-form__label\">Establecer</label><div class=\"saldos-form__controls\"><input ng-disabled=\"vm.ajax\" type=\"number\" step=\"1\" class=\"form-control\" ng-model=\"vm.selectedAgente.establecer\"> <button ng-disabled=\"vm.ajax\" type=\"submit\" class=\"btn btn-success\"><i class=\"ion-checkmark-round\"></i></button></div></form><form class=\"saldos-form\" ng-submit=\"vm.doRecargarAgente()\"><label class=\"saldos-form__label\">Recargar</label><div class=\"saldos-form__controls\"><input ng-disabled=\"vm.ajax\" type=\"number\" step=\"1\" class=\"form-control\" ng-model=\"vm.selectedAgente.recargar\"> <button ng-disabled=\"vm.ajax\" type=\"submit\" class=\"btn btn-success\"><i class=\"ion-checkmark-round\"></i></button></div></form><form class=\"saldos-form\" ng-submit=\"vm.doRetirarAgente()\"><label class=\"saldos-form__label\">Retirar</label><div class=\"saldos-form__controls\"><input ng-disabled=\"vm.ajax\" type=\"number\" step=\"1\" class=\"form-control\" ng-model=\"vm.selectedAgente.retirar\"> <button ng-disabled=\"vm.ajax\" type=\"submit\" class=\"btn btn-success\"><i class=\"ion-checkmark-round\"></i></button></div></form></div></div></div><div class=\"row\" ng-show=\"vm.SessionService.currentUser.tipo === \'agente\'\"><h1 class=\"text-center\">Saldo: <span ng-class=\"{ \'monto-negativo\': vm.SessionService.currentUser.saldo < 0 }\">$ {{ vm.SessionService.currentUser.saldo | money }}</span></h1><h3 class=\"text-center\">(Descubierto: <span ng-class=\"{ \'monto-negativo\': vm.SessionService.currentUser.descubierto < 0 }\">$ {{ vm.SessionService.currentUser.descubierto | money }}</span>)</h3><h3 class=\"text-center\" ng-if=\"vm.selectedLugar\">Saldo del grupo: <span ng-class=\"{ \'monto-negativo\': vm.selectedLugar.saldo < 0 }\">$ {{ vm.selectedLugar.saldo | money }}</span></h3></div><div class=\"row\" ng-show=\"vm.selectedLugar\"><div ba-panel=\"\" class=\"col-xs-12 col-md-12\"><div class=\"saldos-table-scroll\"><table class=\"table table-hover saldos-table\"><thead><tr class=\"black-muted-bg\"><th class=\"saldos-col-cliente\">CLIENTE</th><th ng-if=\"vm.SessionService.currentUser.tipo !== \'agente\'\">DESCUBIERTO</th><th>SALDO</th><th>DESCUBIERTO</th><th ng-if=\"vm.SessionService.currentUser.tipo !== \'agente\'\">ESTABLECER</th><th>PAGA</th><th>RETIRA</th></tr></thead><tbody><tr ng-repeat=\"cliente in vm.selectedLugar.clientes | orderBy: \'nickname\'\"><td class=\"saldos-col-cliente\">{{ cliente.nickname.toUpperCase() }}</td><td ng-if=\"vm.SessionService.currentUser.tipo !== \'agente\'\"><form class=\"saldos-table-form\" ng-submit=\"vm.doDescubierto(cliente)\"><input ng-disabled=\"vm.ajax\" type=\"number\" step=\"1\" class=\"form-control\" ng-class=\"{ \'monto-negativo\': cliente.descubierto < 0 }\" ng-model=\"cliente.descubierto\"> <button ng-disabled=\"vm.ajax\" type=\"submit\" class=\"btn btn-success\"><i class=\"ion-checkmark-round\"></i></button></form></td><td ng-class=\"{ \'monto-negativo\': cliente.saldo < 0 }\">$ {{ cliente.saldo | money }}</td><td ng-class=\"{ \'monto-negativo\': cliente.descubierto < 0 }\">$ {{ cliente.descubierto | money }}</td><td ng-if=\"vm.SessionService.currentUser.tipo !== \'agente\'\"><form class=\"saldos-table-form\" ng-submit=\"vm.doEstablecer(cliente)\"><input ng-disabled=\"vm.ajax\" type=\"number\" step=\"1\" class=\"form-control\" ng-model=\"cliente.establecer\"> <button ng-disabled=\"vm.ajax\" type=\"submit\" class=\"btn btn-success\"><i class=\"ion-checkmark-round\"></i></button></form></td><td><form class=\"saldos-table-form\" ng-submit=\"vm.doRecargar(cliente)\"><input ng-disabled=\"vm.ajax\" type=\"number\" min=\"0\" step=\"1\" class=\"form-control\" ng-model=\"cliente.recargar\"> <button ng-disabled=\"vm.ajax\" type=\"submit\" class=\"btn btn-success\"><i class=\"ion-checkmark-round\"></i></button></form></td><td><form class=\"saldos-table-form\" ng-submit=\"vm.doRetirar(cliente)\"><input ng-disabled=\"vm.ajax\" type=\"number\" min=\"0\" step=\"1\" class=\"form-control\" ng-model=\"cliente.retirar\"> <button ng-disabled=\"vm.ajax\" type=\"submit\" class=\"btn btn-success\"><i class=\"ion-checkmark-round\"></i></button></form></td></tr><tr><td class=\"saldos-col-cliente\"></td><td ng-if=\"vm.SessionService.currentUser.tipo !== \'agente\'\"></td><td ng-class=\"{ \'monto-negativo\': vm.saldoTotal() < 0 }\">$ {{ vm.saldoTotal() | money }}</td><td></td><td ng-if=\"vm.SessionService.currentUser.tipo !== \'agente\'\"></td><td></td><td></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/pages/turf/tarifas/tarifas.html","<div id=\"tarifas\"><div ba-panel=\"\" class=\"col-md-offset-3 col-md-6 select-panel\"><select id=\"tarifaSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" ng-model=\"vm.selectedTarifa\" ng-options=\"tarifa as nombre.toUpperCase() for (nombre, tarifa) in vm.tarifas\"><option data-hidden=\"true\"></option></select></div><div ba-panel=\"\" class=\"horizontal-scroll col-md-offset-2 col-md-8\"><table class=\"table table-bordered\"><tbody><tr ng-repeat=\"tarifa in vm.selectedTarifa\"><td><input type=\"text\" class=\"form-control\" value=\"{{ vm.tipos[vm.GlobalHelpers.findWithAttr(vm.tipos, \'code\', tarifa.code)].title | uppercase }}\" disabled=\"\"></td><td><input type=\"text\" class=\"form-control\" value=\"{{ tarifa.place ? \'PLACE\' : \'\' }}\" disabled=\"\"></td><td><p ng-repeat=\"intervalo in tarifa.intervalos\">{{ intervalo.minimo }} - {{ intervalo.maximo }}: {{ intervalo.valor }} <button class=\"btn btn-primary\" ng-click=\"vm.editarIntervaloModal(intervalo)\">EDITAR</button></p></td><td><button class=\"btn btn-primary\" ng-click=\"vm.agregarIntervaloModal(tarifa)\">AGREGAR</button></td></tr></tbody></table></div><div class=\"button-wrapper col-md-12\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.nuevaTarifaModal()\">NUEVO</button> <button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.updateTarifas()\" ng-disabled=\"vm.ajax\">GUARDAR</button> <button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"vm.eliminarTarifa()\" ng-disabled=\"vm.ajax\">ELIMINAR</button></div></div>");
$templateCache.put("app/pages/turf/totales/totales.html","<div id=\"totales\" ng-show=\"vm.ready\"><div ba-panel=\"\" class=\"col-sm-2 col-izq\"><div class=\"form-group\"><label>JORNADA (DESDE)</label><select id=\"jornadaDesdeSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"JORNADA\" ng-change=\"vm.filterChange(\'jornada\')\" ng-model=\"vm.jornadaDesde\" ng-options=\"jornada as (jornada.fecha + \' - \' + jornada.hipodromo.nombre.toUpperCase()) for jornada in vm.jornadas\"><option data-hidden=\"true\"></option></select></div><div class=\"form-group\"><label>JORNADA (HASTA)</label><select id=\"jornadaHastaSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"JORNADA\" ng-change=\"vm.filterChange(\'jornada\')\" ng-model=\"vm.jornadaHasta\" ng-options=\"jornada as (jornada.fecha + \' - \' + jornada.hipodromo.nombre.toUpperCase()) for jornada in vm.jornadas\"><option data-hidden=\"true\"></option></select></div><div class=\"form-group\"><label>CARRERA</label><select id=\"carreraSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"CARRERA\" ng-change=\"vm.filterChange(\'carrera\')\" ng-model=\"vm.carrera\" ng-options=\"carrera as (carrera.orden + \'ª\') for carrera in vm.jornada.carreras\"><option value=\"\">TODAS</option></select></div><div class=\"form-group\" ng-if=\"vm.GlobalHelpers.hideform(\'particular\')\"><label>USUARIO</label><select id=\"userSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"USUARIO\" ng-change=\"vm.filterChange(\'user\')\" ng-model=\"vm.user\" ng-options=\"user as user.username.toUpperCase() for user in vm.users | orderBy: \'username\'\"><option value=\"\">TODOS</option></select></div><div class=\"form-group\" ng-if=\"!vm.GlobalHelpers.showTo([\'empleado\', \'particular\'])\"><label>LUGAR</label><select id=\"lugarSelect\" class=\"form-control selectpicker select-filtro\" selectpicker=\"\" title=\"LUGAR\" ng-change=\"vm.lugarChange(\'lugar\')\" ng-model=\"vm.lugar\" ng-options=\"lugar as lugar.nombre.toUpperCase() for lugar in vm.lugares | orderBy: \'nombre\'\"><option value=\"\">TODOS</option></select></div><div class=\"form-group\" ng-if=\"!vm.GlobalHelpers.showTo([\'particular\'])\"><label>CLIENTE</label><select id=\"clienteSelect\" class=\"form-control selectpicker select-filtro with-search\" selectpicker=\"\" title=\"CLIENTE\" data-live-search=\"true\" ng-change=\"vm.filterChange(\'cliente\')\" ng-model=\"vm.cliente\" ng-options=\"cliente as cliente.nickname.toUpperCase() for cliente in vm.clientes | orderBy: \'nickname\'\"><option value=\"\">TODOS</option></select></div><div class=\"button-wrapper\"><button class=\"btn btn-primary btn-fw\" ng-click=\"vm.getApuestas()\">BUSCAR</button></div></div><div ba-panel=\"\" class=\"col-sm-10 printable col-der\"><div class=\"horizontal-scroll\"><table class=\"table table-hover apuestas-table\" st-table=\"vm.displayedApuestas\" st-safe-src=\"vm.apuestas\"><thead><caption><span class=\"pull-left noprintable\"><button class=\"btn btn-default btn-sm\" ng-click=\"(vm.update = !vm.update)\" ng-class=\"{ \'btn-success\': vm.update }\">ACTUALIZAR</button></span><h3 ng-if=\"vm.apuestas && vm.jornada\">{{ vm.jornada.fecha }} - {{ vm.jornada.hipodromo.nombre.toUpperCase() }}</h3><h3 ng-if=\"vm.apuestas && !vm.jornada\">{{ vm.jornadaDesde.fecha }} - {{ vm.jornadaDesde.hipodromo.nombre.toUpperCase() }} A {{ vm.jornadaHasta.fecha }} - {{ vm.jornadaHasta.hipodromo.nombre.toUpperCase() }}</h3></caption><tr><th><strong>TIPO</strong></th><th><strong>CABALLOS</strong></th><th><strong>TOTAL</strong></th></tr></thead><tbody><tr ng-repeat=\"apuesta in vm.displayedApuestas\"><td>{{ apuesta.tipo.toUpperCase() }}</td><td>{{ apuesta.caballos.join(\'.\') }}</td><td>$ <span ng-class=\"{ \'monto-negativo\': apuesta.importe < 0 }\">{{ apuesta.importe | money }}</span></td></tr></tbody><tfoot><tr><td></td><td></td><td><strong>TOTAL $ <span ng-class=\"{ \'monto-negativo\': vm.total < 0 }\">{{ vm.total | money }}</span></strong></td></tr></tfoot></table></div></div></div>");
$templateCache.put("app/pages/turf/usuarios/usuarios.html","<div class=\"bet-usuarios\" ng-show=\"vm.ready\"><div class=\"col-sm-6\"><div ba-panel=\"\" ba-panel-title=\"Nuevo usuario\" class=\"pan-1\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"USUARIO\" ng-model=\"vm.username\"></div><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"CONTRASEÑA\" ng-model=\"vm.password\"></div><div class=\"form-group\" ng-show=\"vm.SessionService.currentUser.tipo !== \'agente\'\"><select id=\"tipoSelect\" class=\"form-control\" ng-model=\"vm.tipo\" title=\"TIPO\" selectpicker=\"\"><option data-hidden=\"true\"></option><option value=\"admin\">ADMIN</option><option value=\"empleado\">EMPLEADO</option><option value=\"agente\">AGENTE</option><option value=\"particular\">PARTICULAR</option></select></div><div class=\"form-group\" ng-show=\"vm.SessionService.currentUser.tipo !== \'agente\' && (vm.tipo === \'agente\' || vm.tipo === \'particular\')\"><select id=\"lugarParaAgenteSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" ng-model=\"vm.lugarParaAgente\" ng-options=\"lugar as lugar.nombre.toUpperCase() for lugar in vm.SessionService.lugaresParticulares\"><option data-hidden=\"true\"></option></select></div><div class=\"button-wrapper\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.addUser()\">AGREGAR</button></div></div><div ba-panel=\"\" ba-panel-title=\"Usuarios\" class=\"pan-2\" ng-if=\"vm.SessionService.currentUser.tipo !== \'agente\'\"><div class=\"horizontal-scroll\"><table class=\"table table-condensed\"><thead><tr class=\"black-muted-bg\"><th>USUARIO</th><th>TIPO</th><th>ELIMINAR</th></tr></thead><tbody><tr ng-repeat=\"user in vm.users | orderBy: \'username\'\"><td>{{ user.username.toUpperCase() }}</td><td>{{ user.tipo.toUpperCase() }} {{ user.tipo === \'agente\' ? \'(\' + user.lugar.nombre.toUpperCase() + \')\' : \'\' }}</td><td><button class=\"btn btn-primary\" ng-if=\"user.tipo != \'superadmin\'\" ng-click=\"vm.deleteUser(user)\"><i class=\"ion-close-round\"></i></button></td></tr></tbody></table></div></div></div><div class=\"col-sm-6\"><div ba-panel=\"\" ba-panel-title=\"Clientes\"><select ng-if=\"vm.SessionService.currentUser.tipo !== \'agente\'\" id=\"lugarParaMostrarSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" ng-model=\"vm.lugarParaMostrar\" ng-change=\"vm.lugarParaMostrarChange()\" ng-options=\"lugar as lugar.nombre.toUpperCase() for lugar in vm.SessionService.lugaresParticulares\"><option data-hidden=\"true\"></option></select><table class=\"table table-hover mt-4\" ng-show=\"vm.lugarParaMostrar\"><thead><tr class=\"black-muted-bg\"><th>CLIENTE</th><th>ACCIONES</th></tr></thead><tbody><tr ng-repeat=\"user in vm.particularesFiltrados | orderBy: \'username\'\"><td>{{ user.username.toUpperCase() }}</td><td class=\"btns-same-width-sm\"><button class=\"btn btn-primary\" ng-click=\"vm.showChangePassword(user)\"><i class=\"ion-key\"></i></button> <button class=\"btn btn-primary\" ng-click=\"vm.deleteUser(user)\"><i class=\"ion-close-round\"></i></button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","<aside class=\"al-sidebar\" ng-swipe-right=\"$baSidebarService.setMenuCollapsed(false)\" ng-swipe-left=\"$baSidebarService.setMenuCollapsed(true)\" ng-mouseleave=\"hoverElemTop=selectElemTop\"><ul class=\"al-sidebar-list\" slimscroll=\"{height: \'{{menuHeight}}px\'}\" slimscroll-watch=\"menuHeight\"><li ng-repeat=\"item in ::menuItems\" class=\"al-sidebar-list-item\" ng-class=\"::{\'with-sub-menu\': item.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"item\"><a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"item.stateRef || \'\'\" ng-href=\"{{::(item.fixedHref ? item.fixedHref: \'\')}}\" ng-if=\"::!item.subMenu\" class=\"al-sidebar-list-link\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::item.subMenu\" class=\"al-sidebar-list-link\" ba-ui-sref-toggler=\"\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span> <b class=\"fa fa-angle-down\" ui-sref-active=\"fa-angle-up\" ng-if=\"::item.subMenu\"></b></a><ul ng-if=\"::item.subMenu\" class=\"al-sidebar-sublist\" ng-class=\"{\'slide-right\': item.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-repeat=\"subitem in ::item.subMenu\" ng-class=\"::{\'with-sub-menu\': subitem.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"subitem\" class=\"ba-sidebar-sublist-item\"><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::subitem.subMenu\" ba-ui-sref-toggler=\"\" class=\"al-sidebar-list-link subitem-submenu-link\"><span>{{ ::subitem.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}\" ng-if=\"::subitem.subMenu\"></b></a><ul ng-if=\"::subitem.subMenu\" class=\"al-sidebar-sublist subitem-submenu-list\" ng-class=\"{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-mouseenter=\"hoverItem($event, item)\" ng-repeat=\"subSubitem in ::subitem.subMenu\" ui-sref-active=\"selected\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::subSubitem.disabled\" class=\"al-sidebar-list-link\">{{ ::item.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"subSubitem.stateRef || \'\'\" ng-if=\"::!subSubitem.disabled\" ng-href=\"{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}\">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::(!subitem.subMenu && subitem.disabled)\" class=\"al-sidebar-list-link\">{{ ::subitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" target=\"{{::(subitem.blank ? \'_blank\' : \'_self\')}}\" ng-if=\"::(!subitem.subMenu && !subitem.disabled)\" ui-state=\"subitem.stateRef || \'\'\" ng-href=\"{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}\" ng-show=\"subitem.itemFor.indexOf(SessionService.currentUser.tipo) != -1\">{{ ::subitem.title}}</a></li></ul></li><li style=\"padding-left: 51px; padding-top: 20px;\"><a ng-click=\"vm.logout()\">Salir</a></li><li style=\"padding-left: 51px; padding-top: 120px;\" class=\"visible-xs\"><a ng-click=\"$baSidebarService.setMenuCollapsed(true)\"><i class=\"fa fa-5x fa-long-arrow-left\" aria-hidden=\"true\"></i></a></li></ul><div class=\"sidebar-hover-elem\" ng-style=\"{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}\" ng-class=\"{\'show-hover-elem\': showHoverElem }\"></div></aside>");
$templateCache.put("app/theme/components/baWizard/baWizard.html","<div class=\"ba-wizard\"><div class=\"ba-wizard-navigation-container\"><div ng-repeat=\"t in $baWizardController.tabs\" class=\"ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}\" ng-click=\"$baWizardController.selectTab($index)\">{{t.title}}</div></div><div class=\"progress ba-wizard-progress\"><div class=\"progress-bar progress-bar-danger active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: $baWizardController.progress + \'%\'}\"></div></div><div class=\"steps\" ng-transclude=\"\"></div><nav><ul class=\"pager ba-wizard-pager\"><li class=\"previous\"><button ng-disabled=\"$baWizardController.isFirstTab()\" ng-click=\"$baWizardController.previousTab()\" type=\"button\" class=\"btn btn-primary\"><span aria-hidden=\"true\">&larr;</span> previous</button></li><li class=\"next\"><button ng-disabled=\"$baWizardController.isLastTab()\" ng-click=\"$baWizardController.nextTab()\" type=\"button\" class=\"btn btn-primary\">next <span aria-hidden=\"true\">&rarr;</span></button></li></ul></nav></div>");
$templateCache.put("app/theme/components/baWizard/baWizardStep.html","<section ng-show=\"selected\" class=\"step\" ng-transclude=\"\"></section>");
$templateCache.put("app/theme/components/backTop/backTop.html","<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"Back to Top\"></i>");
$templateCache.put("app/theme/components/contentTop/contentTop.html","<div class=\"content-top clearfix\"><h1 class=\"al-title\">{{ activePageTitle }}</h1><ul class=\"breadcrumb al-breadcrumb\"><li><a href=\"#/dashboard\">Home</a></li><li>{{ activePageTitle }}</li></ul></div>");
$templateCache.put("app/theme/components/msgCenter/msgCenter.html","<ul class=\"al-msg-center clearfix\"><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Notifications</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in notifications\"><div class=\"img-area\"><img ng-class=\"{\'photo-msg-item\' : !msg.image}\" ng-src=\"{{::( msg.image || (users[msg.userId].name | profilePicture) )}}\"></div><div class=\"msg-area\"><div ng-bind-html=\"getMessage(msg)\"></div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all notifications</a></div></li><li uib-dropdown=\"\"><a href=\"\" class=\"msg\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Messages</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in messages\"><div class=\"img-area\"><img class=\"photo-msg-item\" ng-src=\"{{::( users[msg.userId].name | profilePicture )}}\"></div><div class=\"msg-area\"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all messages</a></div></li></ul>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<div class=\"page-top clearfix\" scroll-position=\"scrolled\" max-height=\"50\" ng-class=\"{\'scrolled\': scrolled}\"><a href=\"#/dashboard\" class=\"al-logo clearfix\"><span>Hagan</span>Juego</a> <a href=\"\" class=\"collapse-menu-link ion-navicon\" ba-sidebar-toggle-menu=\"\"></a></div>");
$templateCache.put("app/theme/components/widgets/widgets.html","<div class=\"widgets\"><div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{\'row\': widgetBlock.widgets.length > 1}\"><div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{\'col-md-6\': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\"><div ba-panel=\"\" ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\"><div ng-include=\"widget.url\"></div></div></div></div></div>");
$templateCache.put("app/pages/turf/incrementos/modals/agregarIntervalo.html","<div class=\"modal-content modal-incrementos\"><div class=\"modal-header bg-info\"><i class=\"ion-document modal-icon\"></i><span>AGREGAR INTERVALO</span></div><div class=\"modal-body text-center\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"minimo\" class=\"col-sm-2 control-label\">MÍNIMO</label><div class=\"col-sm-10\"><input ng-model=\"vm.minimo\" type=\"text\" class=\"form-control\" id=\"minimo\" placeholder=\"MÍNIMO\"></div></div><div class=\"form-group\"><label for=\"maximo\" class=\"col-sm-2 control-label\">MÁXIMO</label><div class=\"col-sm-10\"><input ng-model=\"vm.maximo\" type=\"text\" class=\"form-control\" id=\"maximo\" placeholder=\"MÁXIMO\"></div></div><div class=\"form-group\"><label for=\"factor\" class=\"col-sm-2 control-label\">FACTOR</label><div class=\"col-sm-10\"><input ng-model=\"vm.factor\" type=\"text\" class=\"form-control\" id=\"factor\" placeholder=\"FACTOR\"></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"$dismiss()\">CANCELAR</button> <button type=\"button\" class=\"btn btn-success btn-lg\" ng-click=\"vm.agregarIntervalo()\">ACEPTAR</button></div></div>");
$templateCache.put("app/pages/turf/incrementos/modals/editarIntervalo.html","<div class=\"modal-content modal-incrementos\"><div class=\"modal-header bg-info\"><i class=\"ion-document modal-icon\"></i><span>EDITAR INTERVALO</span></div><div class=\"modal-body text-center\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"minimo\" class=\"col-sm-2 control-label\">MÍNIMO</label><div class=\"col-sm-10\"><input id=\"minimo\" class=\"form-control\" type=\"text\" placeholder=\"MÍNIMO\" ng-model=\"vm.minimo\" ng-value=\"vm.intervalo.minimo\" ng-init=\"vm.minimo = vm.intervalo.minimo\"></div></div><div class=\"form-group\"><label for=\"maximo\" class=\"col-sm-2 control-label\">MÁXIMO</label><div class=\"col-sm-10\"><input id=\"maximo\" class=\"form-control\" type=\"text\" placeholder=\"MÁXIMO\" ng-model=\"vm.maximo\" ng-value=\"vm.intervalo.maximo\" ng-init=\"vm.maximo = vm.intervalo.maximo\"></div></div><div class=\"form-group\"><label for=\"factor\" class=\"col-sm-2 control-label\">FACTOR</label><div class=\"col-sm-10\"><input id=\"factor\" class=\"form-control\" type=\"text\" placeholder=\"FACTOR\" ng-model=\"vm.factor\" ng-value=\"vm.intervalo.factor\" ng-init=\"vm.factor = vm.intervalo.factor\"></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"$dismiss()\">CANCELAR</button> <button type=\"button\" class=\"btn btn-success btn-lg\" ng-click=\"vm.editarIntervalo()\">ACEPTAR</button></div></div>");
$templateCache.put("app/pages/turf/incrementos/modals/nuevoIncremento.html","<div class=\"modal-content modal-tarifas\"><div class=\"modal-header bg-info\"><i class=\"ion-document modal-icon\"></i><span>NUEVO INCREMENTO</span></div><div class=\"modal-body text-center\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"nombre\" class=\"col-sm-2 control-label\">NOMBRE</label><div class=\"col-sm-10\"><input ng-model=\"vm.nombre\" type=\"text\" class=\"form-control\" id=\"nombre\" placeholder=\"NOMBRE\"></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"$dismiss()\">CANCELAR</button> <button type=\"button\" class=\"btn btn-success btn-lg\" ng-click=\"vm.nuevoIncremento()\">ACEPTAR</button></div></div>");
$templateCache.put("app/pages/turf/jugar/modals/carreraAbierta.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-document modal-icon\"></i><span>CARRERA ABIERTA</span></div><div class=\"modal-body text-center\">LA CARRERA <strong>{{ vm.carrera.orden }}ª</strong> ABRIÓ PARA HACER JUGADAS</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"$dismiss()\">CONTINUAR</button></div></div>");
$templateCache.put("app/pages/turf/jugar/modals/carreraCerrada.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-document modal-icon\"></i><span>CARRERA CERRADA</span></div><div class=\"modal-body text-center\">LA CARRERA <strong>{{ vm.carrera.orden }}ª</strong> CERRÓ PARA HACER JUGADAS</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"$dismiss()\">CONTINUAR</button></div></div>");
$templateCache.put("app/pages/turf/jugar/modals/carreraCerrando.html","<div class=\"modal-content\"><div class=\"modal-header bg-warning\"><i class=\"ion-document modal-icon\"></i><span>CARRERA CERRANDO</span></div><div class=\"modal-body text-center\">LA CARRERA <strong>{{ vm.carrera.orden }}ª</strong> CIERRA EN {{ vm.closingTime / 1000 }} SEGUNDOS</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"$dismiss()\">CONTINUAR</button></div></div>");
$templateCache.put("app/pages/turf/jugar/modals/clienteNuevo.html","<div class=\"modal-content\"><div class=\"modal-header bg-success\"><i class=\"ion-document modal-icon\"></i><span>CLIENTE NUEVO</span></div><div class=\"modal-body text-center\">INGRESE EL NOMBRE</div><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"NOMBRE\" ng-model=\"vm.nickname\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.sendClienteNuevo()\">ACEPTAR</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">CANCELAR</button></div></div>");
$templateCache.put("app/pages/turf/jugar/modals/clientes.html","<div class=\"modal-content clientes-modal\"><div class=\"modal-header bg-success\"><i class=\"ion-ios-list-outline modal-icon\"></i><span>CLIENTES</span></div><div class=\"modal-body btns-same-width-lg\"><div class=\"button-wrapper\" ng-repeat=\"cliente in vm.SessionService.lugar.clientes | orderBy:\'nickname\'\"><button type=\"button\" class=\"btn btn-default btn-lg\" ng-class=\"vm.clienteClass(cliente)\" ng-click=\"vm.toggleFav(cliente)\">{{ cliente.nickname.toUpperCase() }}</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.parent.clienteNuevo()\">NUEVO</button></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"$dismiss()\">CERRAR</button></div></div>");
$templateCache.put("app/pages/turf/jugar/modals/confirmCombinada.html","<div class=\"modal-content confirm-combinada-modal\"><div class=\"modal-body\"><h3 class=\"confirm-combinada-title\">CONFIRMAR JUGADA</h3><p class=\"confirm-combinada-subtitle\">SE GENERARÁN LAS SIGUIENTES COMBINACIONES. ¿DESEA ENVIARLAS?</p><div class=\"confirm-combinada-list-box\"><ul class=\"list-unstyled\"><li ng-repeat=\"apuesta in vm.preview.apuestas\"><span class=\"confirm-combinada-caballos\">{{ apuesta.caballos }}</span> <span class=\"confirm-combinada-detalle\">{{ apuesta.tipo }} ${{ apuesta.importe | money }}</span></li></ul></div><p class=\"confirm-combinada-total\">TOTAL: ${{ vm.preview.total | money }}</p><div class=\"confirm-combinada-actions\"><button type=\"button\" class=\"btn confirm-combinada-volver\" ng-click=\"vm.cancel()\">VOLVER</button> <button type=\"button\" class=\"btn confirm-combinada-aceptar\" ng-click=\"vm.confirm()\">ACEPTAR</button></div></div></div>");
$templateCache.put("app/pages/turf/jugar/modals/deleteApuesta.html","<div class=\"modal-content\"><div class=\"modal-header bg-warning\"><i class=\"ion-android-warning modal-icon\"></i><span>ELIMINAR APUESTA</span></div><div class=\"modal-body text-center\">DESEA ELIMINAR <strong>{{ vm.comb.string }}</strong> ?</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.confirmDelete(vm.comb)\" ng-disabled=\"vm.deleting\">ELIMINAR</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"$dismiss()\">CANCELAR</button></div></div>");
$templateCache.put("app/pages/turf/jugar/widgets/apuestas.html","<div class=\"row\"><table class=\"table table-hover\"><tbody><tr class=\"no-top-border\"><td><strong>TOTAL $ {{ vm.total.combinations | money }}</strong></td></tr><tr ng-repeat=\"combination in vm.combinations\" class=\"no-top-border\" ng-class=\"vm.combinationClass(combination)\"><td ng-click=\"vm.deleteApuesta(combination)\">{{ combination.string }}</td></tr></tbody></table></div>");
$templateCache.put("app/pages/turf/jugar/widgets/caballos.html","<div class=\"row btn-row btns-same-width-md\" ng-if=\"vm.selectedTipos[0].caballos > 1 || vm.selectedTipos[0].carreras > 1\"><button type=\"button\" class=\"btn btn-lg btn-warning\" ng-click=\"vm.caballosClear()\"><i class=\"ion-close-round\"></i></button></div><div class=\"row btn-row btns-same-width-md row-carrera carrera{{$index}}\" ng-repeat=\"leg in vm.GlobalHelpers.makeArray(vm.selectionLegCount()) track by $index\"><h4 class=\"info-carrera\" ng-if=\"vm.selectedTipos[0].carreras > 1\">{{ vm.carrerasParaJugar[vm.carreraIndexForLeg($index)].orden }}ª</h4><h4 class=\"info-carrera\" ng-if=\"vm.selectedTipos[0].carreras == 1 && vm.selectedTipos[0].caballos > 1\">{{ vm.puestoLabel($index) }}</h4><button type=\"button\" class=\"btn btn-default btn-lg\" ng-repeat=\"horse in vm.GlobalHelpers.makeArray(vm.carrerasParaJugar[vm.carreraIndexForLeg($index)].caballos) track by $index\" ng-click=\"vm.clickCaballo($parent.$index, horse)\" ng-class=\"vm.caballoClass($parent.$index, horse)\" ng-disabled=\"vm.caballoDisabled($parent.$index, horse)\">{{ horse }}</button></div>");
$templateCache.put("app/pages/turf/jugar/widgets/carrera.html","<div class=\"form-group\"><select id=\"carreraSelect\" class=\"form-control selectpicker carreraSelect\" title=\"---\" selectpicker=\"\" data-style=\"btn-info btn-lg\" ng-model=\"vm.selectedCarrera\" ng-change=\"vm.carreraChange()\" ng-options=\"carrera as (carrera.orden + \'ª\' + (!carrera.abierta ? \' (CERRADA)\' : \'\')) for carrera in vm.jornada.carreras | filter: vm.carreraFilter\"></select></div>");
$templateCache.put("app/pages/turf/jugar/widgets/cliente.html","<div class=\"button-wrapper\"><button ng-click=\"vm.openClientesModal()\" type=\"button\" class=\"btn btn-primary btn-lg btn-clientes\">CLIENTES</button></div><div class=\"form-group\"><select id=\"clienteSelect\" class=\"form-control selectpicker\" selectpicker=\"\" title=\"---\" data-style=\"btn-success btn-lg\" ng-model=\"vm.selectedCliente\" ng-change=\"vm.clienteChange()\" ng-options=\"cliente as cliente.nickname.toUpperCase() for cliente in vm.SessionService.lugar.clientes | filter: vm.clienteIsFav() | orderBy: \'nickname\'\"><option data-hidden=\"true\"></option></select></div>");
$templateCache.put("app/pages/turf/jugar/widgets/importe.html","<div class=\"row btn-row btns-same-width-md\" ng-if=\"vm.selectedTriple && vm.selectedCaballos[0].length > 1\"><div class=\"button-wrapper\" ng-repeat=\"caballo in vm.inputtedCaballos\"><button type=\"button\" class=\"btn btn-default btn-lg\" ng-click=\"vm.setCaballoForTriple(caballo)\" ng-class=\"vm.caballoForTripleClass(caballo)\">{{ caballo }}</button></div></div><div class=\"row btn-row btns-same-width-md row-vales\" ng-if=\"vm.selectedTriple || vm.selectedTipos[0].code == \'eng\'\"><div class=\"button-wrapper\" ng-if=\"vm.selectedTriple\"><button type=\"button\" class=\"btn btn-info btn-lg\" ng-click=\"vm.addValeTriple(vm.selectedTriple.availableVales, true)\">TODOS</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info btn-lg\" ng-click=\"vm.addValeTriple(1, true)\">1 VALE</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info btn-lg\" ng-click=\"vm.addValeTriple(1/2, true)\">½ VALE</button></div></div><div class=\"row btn-row btns-same-width-md\" ng-if=\"vm.selectedTipos.length > 1\"><div class=\"button-wrapper\" ng-repeat=\"tipo in vm.selectedTipos\"><button type=\"button\" class=\"btn btn-default btn-lg\" ng-click=\"vm.setTipoForImporte(tipo)\" ng-class=\"vm.tipoForImporteClass(tipo)\">{{ tipo.code.toUpperCase() }}</button></div></div><div class=\"row btn-row btns-same-width-md row-importes-rapidos\" ng-if=\"vm.caballosListos() && !(vm.selectedTriple || vm.selectedTipos[0].code == \'eng\')\"><div class=\"button-wrapper\" ng-repeat=\"item in vm.importesRapidos\"><button type=\"button\" class=\"btn btn-info btn-lg\" ng-click=\"vm.addImporteRapido(item.monto)\">{{ item.label }}</button></div></div><div class=\"row btn-row btns-same-width-md row-vales\" ng-if=\"vm.caballosListos() && vm.vale.length > 0 && !(vm.selectedTipos[0].caballos == 1 && vm.selectedTipos[0].carreras == 1)\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info btn-lg\" ng-click=\"vm.addVale(2)\">2 VALES<br>$ {{ (2 * vm.vale.reduce(vm.GlobalHelpers.add, 0)) | money }}</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info btn-lg\" ng-click=\"vm.addVale(1)\">1 VALE<br>$ {{ vm.vale.reduce(vm.GlobalHelpers.add, 0) | money }}</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info btn-lg\" ng-click=\"vm.addVale(1/2)\">½ VALE<br>$ {{ (1/2 * vm.vale.reduce(vm.GlobalHelpers.add, 0)) | money }}</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info btn-lg\" ng-click=\"vm.addVale(1/4)\">¼ VALE<br>$ {{ (1/4 * vm.vale.reduce(vm.GlobalHelpers.add, 0)) | money }}</button></div></div><div ng-if=\"!(vm.selectedTriple || vm.selectedTipos[0].code == \'eng\')\"><div class=\"row btn-row btns-same-width-md\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.btnCalculadora(7)\">7</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.btnCalculadora(8)\">8</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.btnCalculadora(9)\">9</button></div></div><div class=\"row btn-row btns-same-width-md\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.btnCalculadora(4)\">4</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.btnCalculadora(5)\">5</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.btnCalculadora(6)\">6</button></div></div><div class=\"row btn-row btns-same-width-md\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.btnCalculadora(1)\">1</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.btnCalculadora(2)\">2</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.btnCalculadora(3)\">3</button></div></div></div><div class=\"row btn-row btns-same-width-md\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning btn-lg\" ng-click=\"vm.btnClear()\"><i class=\"ion-close-round\"></i></button></div><div ng-if=\"!(vm.selectedTriple || vm.selectedTipos[0].code == \'eng\')\" class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"vm.btnCalculadora(0)\">0</button></div><div ng-if=\"!(vm.selectedTriple || vm.selectedTipos[0].code == \'eng\')\" class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning btn-lg\" ng-click=\"vm.btnDelete()\"><i class=\"ion-chevron-left\"></i></button></div></div>");
$templateCache.put("app/pages/turf/jugar/widgets/preview.html","<h4 class=\"visor-preview\"><p ng-if=\"vm.SessionService.currentUser.tipo == \'particular\'\">SALDO: $ {{ vm.SessionService.currentUser.cliente.saldo | money }}</p><p ng-if=\"vm.SessionService.lugar.particular && vm.selectedCliente\">SALDO: $ {{ vm.selectedCliente.saldo | money }}</p><div id=\"combination-string\">{{ vm.combinationString() }}</div></h4><div class=\"button-wrapper hidden-xs\"><button class=\"btn btn-lg btn-enviar\" ng-click=\"vm.addCombination()\" ng-class=\"vm.enviarClass()\" ng-disabled=\"!vm.nextIsAbierta || vm.sendingApuesta\">ENVIAR</button></div><div class=\"button-wrapper visible-xs\"><button class=\"btn btn-lg btn-enviar btn-info\" ng-click=\"vm.prevPaso()\" ng-if=\"vm.paso == 2 || vm.paso == 3\">VOLVER</button> <button class=\"btn btn-lg btn-enviar btn-info\" ng-click=\"vm.nextPaso()\" ng-if=\"vm.paso == 1 || vm.paso == 2\" ng-disabled=\"vm.paso == 2 && !vm.validBet\">SIGUIENTE</button><button class=\"btn btn-lg btn-enviar\" ng-click=\"vm.addCombination()\" ng-class=\"vm.enviarClass()\" ng-disabled=\"!vm.nextIsAbierta || vm.sendingApuesta\" ng-if=\"vm.paso == 3\">ENVIAR</button></div>");
$templateCache.put("app/pages/turf/jugar/widgets/recientes.html","<div class=\"row\" ng-repeat=\"cliente in vm.selectedCarrera.clientes | orderBy:\'nickname\'\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default btn-md\" ng-click=\"vm.setCliente(cliente)\" ng-class=\"vm.isDeudor(cliente)\" on-long-press=\"vm.toggleDeudor(cliente)\" prevent-click=\"true\">{{ cliente.nickname.toUpperCase() }}</button></div></div>");
$templateCache.put("app/pages/turf/jugar/widgets/tipo.html","<div class=\"row btn-row btns-same-width-md\"><div class=\"button-wrapper\" ng-repeat=\"tipo in vm.tipos.slice(0, 3)\" ng-if=\"vm.tipoDisponible(tipo)\"><button type=\"button\" class=\"btn btn-lg btn-default\" ng-class=\"vm.tipoClass(tipo)\" ng-click=\"vm.toggleTipo(tipo)\"><span class=\"bet-tipo-btn\"><span class=\"bet-tipo-btn__code\">{{ tipo.code.toUpperCase() }}</span> <span class=\"bet-tipo-btn__vale\">$&nbsp;{{ vm.selectedCarrera[tipo.code] | money }}</span></span></button></div></div><div class=\"row btn-row btns-same-width-md\"><div class=\"button-wrapper\" ng-repeat=\"tipo in vm.tipos.slice(3, 7)\" ng-if=\"vm.tipoDisponible(tipo)\"><button type=\"button\" class=\"btn btn-lg btn-default\" ng-class=\"vm.tipoClass(tipo)\" ng-click=\"vm.toggleTipo(tipo)\"><span class=\"bet-tipo-btn\"><span class=\"bet-tipo-btn__code\">{{ tipo.code.toUpperCase() }}</span> <span class=\"bet-tipo-btn__vale\">$&nbsp;{{ vm.selectedCarrera[tipo.code] | money }}</span></span></button></div></div><div class=\"row btn-row btns-same-width-md\"><div class=\"button-wrapper\" ng-repeat=\"tipo in vm.tipos.slice(7)\" ng-if=\"vm.tipoDisponible(tipo)\"><button type=\"button\" class=\"btn btn-lg btn-default\" ng-class=\"vm.tipoClass(tipo)\" ng-click=\"vm.toggleTipo(tipo)\"><span class=\"bet-tipo-btn\"><span class=\"bet-tipo-btn__code\">{{ tipo.code.toUpperCase() }}</span> <span class=\"bet-tipo-btn__vale\">$&nbsp;{{ vm.selectedCarrera[tipo.code] | money }}</span></span></button></div></div>");
$templateCache.put("app/pages/turf/jugar/widgets/triples.html","<div class=\"row\" ng-repeat=\"vale in vm.selectedCarrera.vales\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default btn-md\" ng-click=\"vm.setTriple(vale)\" ng-class=\"vm.tripleClass(vale)\">{{ vale.nickname.toUpperCase() }} - {{ vale.availableVales }} VALES</button></div></div>");
$templateCache.put("app/pages/turf/limites/modals/agregarIntervalo.html","<div class=\"modal-content modal-limites\"><div class=\"modal-header bg-info\"><i class=\"ion-document modal-icon\"></i><span>AGREGAR INTERVALO</span></div><div class=\"modal-body text-center\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"minimo\" class=\"col-sm-2 control-label\">MÍNIMO</label><div class=\"col-sm-10\"><input ng-model=\"vm.minimo\" type=\"text\" class=\"form-control\" id=\"minimo\" placeholder=\"MÍNIMO\"></div></div><div class=\"form-group\"><label for=\"maximo\" class=\"col-sm-2 control-label\">MÁXIMO</label><div class=\"col-sm-10\"><input ng-model=\"vm.maximo\" type=\"text\" class=\"form-control\" id=\"maximo\" placeholder=\"MÁXIMO\"></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"$dismiss()\">CANCELAR</button> <button type=\"button\" class=\"btn btn-success btn-lg\" ng-click=\"vm.agregarIntervalo()\">ACEPTAR</button></div></div>");
$templateCache.put("app/pages/turf/limites/modals/editarIntervalo.html","<div class=\"modal-content modal-limites\"><div class=\"modal-header bg-info\"><i class=\"ion-document modal-icon\"></i><span>EDITAR INTERVALO</span></div><div class=\"modal-body text-center\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"minimo\" class=\"col-sm-2 control-label\">MÍNIMO</label><div class=\"col-sm-10\"><input id=\"minimo\" class=\"form-control\" type=\"text\" placeholder=\"MÍNIMO\" ng-model=\"vm.minimo\" ng-value=\"vm.intervalo.minimo\" ng-init=\"vm.minimo = vm.intervalo.minimo\"></div></div><div class=\"form-group\"><label for=\"maximo\" class=\"col-sm-2 control-label\">MÁXIMO</label><div class=\"col-sm-10\"><input id=\"maximo\" class=\"form-control\" type=\"text\" placeholder=\"MÁXIMO\" ng-model=\"vm.maximo\" ng-value=\"vm.intervalo.maximo\" ng-init=\"vm.maximo = vm.intervalo.maximo\"></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"$dismiss()\">CANCELAR</button> <button type=\"button\" class=\"btn btn-success btn-lg\" ng-click=\"vm.editarIntervalo()\">ACEPTAR</button></div></div>");
$templateCache.put("app/pages/turf/limites/modals/nuevoLimite.html","<div class=\"modal-content modal-limites\"><div class=\"modal-header bg-info\"><i class=\"ion-document modal-icon\"></i><span>NUEVO LÍMITE</span></div><div class=\"modal-body text-center\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"nombre\" class=\"col-sm-2 control-label\">NOMBRE</label><div class=\"col-sm-10\"><input ng-model=\"vm.nombre\" type=\"text\" class=\"form-control\" id=\"nombre\" placeholder=\"NOMBRE\"></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"$dismiss()\">CANCELAR</button> <button type=\"button\" class=\"btn btn-success btn-lg\" ng-click=\"vm.nuevoLimite()\">ACEPTAR</button></div></div>");
$templateCache.put("app/pages/turf/retirados/modals/multipleRetirado.html","<div class=\"modal-content\"><div class=\"modal-header bg-warning\"><i class=\"ion-android-warning modal-icon\"></i><span>RETIRAR CABALLO MÚLTIPLE</span></div><div class=\"modal-body text-center\">EL <strong>{{ vm.i }}</strong> TIENE MÚLTIPLES CABALLOS. DESEA RETIRARLO?</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.confirmPatch(vm.carrera)\">RETIRAR</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"$dismiss()\">CANCELAR</button></div></div>");
$templateCache.put("app/pages/turf/tarifas/modals/agregarIntervalo.html","<div class=\"modal-content modal-tarifas\"><div class=\"modal-header bg-info\"><i class=\"ion-document modal-icon\"></i><span>AGREGAR INTERVALO</span></div><div class=\"modal-body text-center\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"minimo\" class=\"col-sm-2 control-label\">MÍNIMO</label><div class=\"col-sm-10\"><input ng-model=\"vm.minimo\" type=\"text\" class=\"form-control\" id=\"minimo\" placeholder=\"MÍNIMO\"></div></div><div class=\"form-group\"><label for=\"maximo\" class=\"col-sm-2 control-label\">MÁXIMO</label><div class=\"col-sm-10\"><input ng-model=\"vm.maximo\" type=\"text\" class=\"form-control\" id=\"maximo\" placeholder=\"MÁXIMO\"></div></div><div class=\"form-group\"><label for=\"valor\" class=\"col-sm-2 control-label\">VALOR</label><div class=\"col-sm-10\"><input ng-model=\"vm.valor\" type=\"text\" class=\"form-control\" id=\"valor\" placeholder=\"VALOR\"></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"$dismiss()\">CANCELAR</button> <button type=\"button\" class=\"btn btn-success btn-lg\" ng-click=\"vm.agregarIntervalo()\">ACEPTAR</button></div></div>");
$templateCache.put("app/pages/turf/tarifas/modals/editarIntervalo.html","<div class=\"modal-content modal-tarifas\"><div class=\"modal-header bg-info\"><i class=\"ion-document modal-icon\"></i><span>EDITAR INTERVALO</span></div><div class=\"modal-body text-center\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"minimo\" class=\"col-sm-2 control-label\">MÍNIMO</label><div class=\"col-sm-10\"><input id=\"minimo\" class=\"form-control\" type=\"text\" placeholder=\"MÍNIMO\" ng-model=\"vm.minimo\" ng-value=\"vm.intervalo.minimo\" ng-init=\"vm.minimo = vm.intervalo.minimo\"></div></div><div class=\"form-group\"><label for=\"maximo\" class=\"col-sm-2 control-label\">MÁXIMO</label><div class=\"col-sm-10\"><input id=\"maximo\" class=\"form-control\" type=\"text\" placeholder=\"MÁXIMO\" ng-model=\"vm.maximo\" ng-value=\"vm.intervalo.maximo\" ng-init=\"vm.maximo = vm.intervalo.maximo\"></div></div><div class=\"form-group\"><label for=\"valor\" class=\"col-sm-2 control-label\">VALOR</label><div class=\"col-sm-10\"><input id=\"valor\" class=\"form-control\" type=\"text\" placeholder=\"VALOR\" ng-model=\"vm.valor\" ng-value=\"vm.intervalo.valor\" ng-init=\"vm.valor = vm.intervalo.valor\"></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"$dismiss()\">CANCELAR</button> <button type=\"button\" class=\"btn btn-success btn-lg\" ng-click=\"vm.editarIntervalo()\">ACEPTAR</button></div></div>");
$templateCache.put("app/pages/turf/tarifas/modals/nuevaTarifa.html","<div class=\"modal-content modal-tarifas\"><div class=\"modal-header bg-info\"><i class=\"ion-document modal-icon\"></i><span>NUEVA TARIFA</span></div><div class=\"modal-body text-center\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"nombre\" class=\"col-sm-2 control-label\">NOMBRE</label><div class=\"col-sm-10\"><input ng-model=\"vm.nombre\" type=\"text\" class=\"form-control\" id=\"nombre\" placeholder=\"NOMBRE\"></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"$dismiss()\">CANCELAR</button> <button type=\"button\" class=\"btn btn-success btn-lg\" ng-click=\"vm.nuevaTarifa()\">ACEPTAR</button></div></div>");
$templateCache.put("app/pages/turf/usuarios/modals/changePassword.html","<div class=\"modal-content\"><div class=\"modal-header bg-success\"><i class=\"ion-document modal-icon\"></i><span>CAMBIAR CONTRASEÑA</span></div><div class=\"modal-body text-center\">INGRESE LA NUEVA CONTRASEÑA PARA <strong>{{ vm.user.username.toUpperCase() }}</strong></div><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"CONTRASEÑA\" ng-model=\"vm.password\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.changePassword()\">ACEPTAR</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">CANCELAR</button></div></div>");}]);